import React, { createRef } from "react";
import request from "arcdynamic-request";
import {dateUStoISO, dateISOtoUS, dateToUsString, stringUStoISO, dateToTimestamp} from "../../date-converter";
import {browserHistory, Link} from "react-router";
import SellerDrawer from "../SellerDrawer/SellerDrawer";
import BuyerDrawer from "../BuyerDrawer/BuyerDrawer";
import FirmDrawer from "../FirmDrawer/FirmDrawer";
import AgentDrawer from "../AgentDrawer/AgentDrawer";
import ReminderPropertyDialog from "./ReminderPropertyDialog";
import Drawer from "../Drawer";
import { viewDateTimeFormat , compareDates, percent, convertKeysToLowerCase, addCommasToNumber,getAgentContribution, isAuthorizedUserForWebsiteChanges, isAgentUser, groupObjectByIndex } from "../../utils";
import {
    // GET_ALL_TENANTS,
    PROPERTY_UNDERWRITING_TENANTS,
    ESCROW_TRACKING,
    PROPERTY_DATA,
    // GET_PROPERTY_HISTORY,
    // GET_AGENT_GROSS_CUMULATIVE,
    HSC_AGENT_CUMULATIVE,
    // GET_PAYMENT_PROPERTIES,
    PROPERTIES_ADDRESS
} from "../../consts/queries";
import {
    AGENT_COMMISSION_PAID,
    AGENT_COMMISSION_PROCURED
} from '../../consts/queries';
import { removeDuplicateObjects} from "../../utils";

import {
    PROPERTIES,
    STRIVE_ESCROW_TRACKING,
    SELLERS,
    HSC_TRACKING,
    PROPERTY_HISTORY,
    HSC_LOAN_QUOTES,
    PROPERTY_PAYMENT_TEAM,
    PROPOSAL,
} from "../../consts/tables";
import {
    sendListedClosedEmail,
    sendNegotiationUnderContractEmail,
    sendDefaultEmail,
    sendHscClosingEmail,
    sendReferralClosingEmail,
    sendOffMarketSellerEmail,
    sendEmailNotification,
} from "../../requests/emailRequests";
import {env, url} from "../../consts/env";
import PropertyInfo from "./components/PropertyInfo";
import OwnershipInfo from "./components/OwnershipInfo";
import RepresentationAgreement from "./components/RepresentationAgreement";
import PropertyFinancials from "./components/PropertyFinancials";
import InNegotiationUnderContract from "./components/InNegotiationUnderContract";
import Financials from "../Financials";
import Website from "./components/Website";
import SaleInformation from "./components/SaleInformation";
import CRUD from "../CRUD";
import {executeQuery} from "../../requests/executeQuery";
import {getData, manageData} from "../../requests/CRUD";
import ListingAgent from "./components/ListingAgent";
import BuysideAgent from "./components/BuysideAgent";
import Dropdown from "../Dropdown/Dropdown";
import Loan from "./components/Loan";
import {pmtFunction} from "../UnderwritingSingleTenant/single-tenant-tables/constants";
import LenderDrawer from "../LenderDrawer/LenderDrawer";
import {apiBackOnMarketUrl, apiPriceChangeUrl} from "../../requests/apiBaseUrls";
import PropertyHistory from "./components/PropertyHistory";
import {CurrentHistoryModel, PropertyHistoryModel} from "../../models";
import PropertyPayments from "./components/PropertyPayments";
import { historyWeights, maxHscMembers, maxStriveMembers } from "../../consts/consts";
import LoanQuotes from "./components/LoanQuotes";
import Modal from "../Modal";
import {getHSCCumulativeAgentPercent, getHSCCumulativeThreshold, getPaymentPercentage, getPaymentThreshold, insertCurrentDataToSortedArray, formatAddress, getCurrentTrancheOnGrossAmount} from "../../utils";
import shallowEqual from "shallowequal";
import filter from "../../filter";
import hscTeamMembers from "../../hsc-team-members";
import Proposal from "./components/Proposal";
import { Button, Dialog, DialogActions, DialogTitle } from "@material-ui/core";
import moment from "moment";
import { GET_AGENT_COMMISSION_PAID, GET_AGENT_COMMISSION_PROCURED, GET_AGENT_GROSS_CUMULATIVE, GET_ALL_TENANTS, GET_ESCROW_TRACKING, GET_HSC_AGENT_CUMULATIVE, GET_HSC_LOAN_QUOTES, GET_HSC_TRACKING, GET_PAYMENT_PROPERTIES, GET_PROPERTIES_ADDRESS, GET_PROPERTY_DATA, GET_PROPERTY_HISTORY, GET_PROPERTY_PAYMENT_TEAM, GET_PROPERTY_UNDERWRITING_TENANTS, GET_PROPOSAL, GET_SELLER, GET_TEAM, V10_PROPERTIES_LIST, V10_PROPERTIES_STAT_COUNT, V10_PROPERTIES_STATS_ACTIVE, V7_PROPERTIES_LIST_DEV, V7_PROPERTIES_STAT_COUNT, V7_PROPERTIES_STATS_ACTIVE_DEV, V7_PROPERTIES_STATS_QUERY, V9_PROPERTIES_LIST, V9_PROPERTIES_STAT_COUNT, V9_PROPERTIES_STATS_ACTIVE } from "../Graphql/Queries/propertiesQuery";
import { ApolloConsumer } from "@apollo/client";
import { HSC_LOAN_QUOTES_MUTATION, PROPERTIES_MUTATION, PROPERTY_HISTORY_MUTATION, PROPERTY_NOTES_MUTATION, PROPERTY_PAYMENT_TEAM_MUTATION, PROPOSAL_MUTATION, SELLERS_MUTATION, UNDERWRITING_TENANTS } from "../Graphql/Mutations/propertiesMutation";
import { GET_HSC_TRACKING_BY_ID } from "../Graphql/Queries/hsc_TrackingQuery";
import { GET_ESCROW_TRACKING_BY_ID } from "../Graphql/Queries/EscrowTrackingQuery";
import { STRIVE_ESCROW_TRACKING_UPDATE } from "../Graphql/Mutations/EscrowTrackingMutation";
import { GET_SELLERS_BY_ID } from "../Graphql/Queries/SellersQuery";
import { CREATE_OR_UPDATE_HSC_TRACKING } from "../Graphql/Mutations/HscTrackingMutation";
import { GET_CONTACT_INVESTOR_BY_ID, GET_CONTACT_TEAM_LIST_QUERY, GET_INVESTOR_LIST_QUERY, GET_TENANTS_PROPERTY_LIST_QUERY } from "../Graphql/ContactsQueries/contactsQuery";
import { fetchData, mutateData } from "../Service/graphQlService";
import { CREATE_OR_UPDATE_CONTACTS_INVESTORS } from "../Graphql/ContactsMutations/allContactsMutation";
import { UserContext } from "../Root/Root";

import InvestorDrawer from "../InvestorDrawer/InvestorDrawer";
import { updateParams } from '../../utils';
import Listing from "../Listing/Listing";
import { GET_HOTLIST_PROPERTIES_BY_EMAIL } from "../Graphql/Queries/HotList";
import PopupDialog from "../PopupDialog/PopupDialog";
import PropertyNotes from "./components/PropertyNotes";
import PropertyGroupsTab from "./components/PropertyGroupsTab";

let cloneDeep = require("lodash.clonedeep");
let find = require("lodash.find");

const defaultVisibleTenants = 5;
const loanQuotesColumnsNumber = 6;
const minStriveMembers = 7;
const minReferralMembers = 3;

const hscAgentsKeys = [
    'hsc_team_member_1',
    'hsc_team_member_2'
]

const lqPriceProps = [
    "purchase_price",
    "down_payment",
    "loan_amount",
    "loan_payment_monthly",
    "loan_payment_annually",
    "noi",
    "cash_flow_monthly",
    "cash_flow_annually"
];

const lqPercentProps = [
    "down_payment_percent",
    "cap_rate",
    "interest_rate",
    "cash_on_cash",
    "debt_yield",
    "total_orignation_fee",
    "noi_percentage" 
];

const lqcheckboxProps = [
    "is_printable"
]

const priceProps = [
    "sqft",
    "list_price",
    "sold_price",
    "net_operating_income",
    "down_payment",
    "total_fee",
    "price_per_sqft",
    "rent_per_sqft",
    "close_price_per_sqft",
    "close_noi",
    "negotiation_price",
    "potential_fee",
    "negotiation_price_per_sqft",
    "base_rent",
    "list_fee",
    "buyside_fee",
    "referral_fee",
    "hsc_price",
    "hsc_total_fee",
    "hsc_list_fee",
    "loan_amount",
    "annual_loan_payment",
    "cash_flow",
    "credits_at_closing",
    "referral",
    "bank_bonus",
    "proforma_noi",
    "proforma_base_rent"
];

const percentProps = [
    "vacancy",
    "capitalization_rate",
    "seller_fee_percentage",
    "close_cap_rate",
    "negotiation_cap_rate",
    "ltv",
    "interest_rate",
    "cash_on_cash",
    "dscr",
    "referral_percent",
    "bank_bonus_percent",
    "hsc_fee_percentage",
    "noi_percent",
    "proforma_cap_rate"
];

const dateProps = [
    "listed_date",
    "expiration_date",
    "lease_commencement_date",
    "lease_expiration_date",
    "close_of_escrow",
    "loan_closing_date",
    "date_removed",
    "date_created",
    "last_modified_date",
    "proposal_date",
    "maturity_date",
    "hsc_listed_date",
    "hsc_expiration_date"
];

const checkboxProps = [
    "hide_financials",
    "is_proforma_pricing",
    "strive_slider",
    "featured",
    "visible",
    "hsc_financing",
    "hsc_approved",
    "other_financing"
];

const agentKeyPercents = [
    "listing_agent_1_percent",
    "listing_agent_2_percent",
    "listing_agent_3_percent",
    "listing_agent_4_percent",
    "buyer_agent_1_percent",
    "buyer_agent_2_percent",
    "buyer_agent_3_percent",
    "buyer_agent_4_percent"
];

const sellerKeys = [
    "first_name",
    "last_name",
    "phone",
    "email",
    "profile",
    "notes",
    "company_name",
    "company_address",
    "company_city",
    "company_state",
    "company_zip"
];

const excludedKeys = [
    "listing_agent_1_first_name",
    "listing_agent_1_last_name",
    "listing_agent_2_first_name",
    "listing_agent_2_last_name",
    "listing_agent_3_first_name",
    "listing_agent_3_last_name",
    "listing_agent_4_first_name",
    "listing_agent_4_last_name",
    "listing_agent_firm_name",
    "buyer_first_name",
    "buyer_last_name",
    "sale_lease_back",
    "original_lease_term"
];

const paymentsPercentProps = [
    'strive_team_member_percent',
    'strive_team_member_net_percent',
];

const paymentsPriceProps = [
    'strive_team_member_net_fee',
    'strive_team_member_gross_fee',
];
const buyer_agent4_firmvalue = env == '_DEV' ? '2' : '34';

export function pricePerFoot(priceStr, sqftStr, doller=false) {
    const price = priceToNumber(priceStr);
    const sqft = priceToNumber(sqftStr);

    if (price && sqft) {
        let value = (Math.round((price / sqft) * 100) / 100).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
        return doller ? value ? `$${value}`: '':value;
    } else {
        return "";
    }
}

function rentPerFoot(priceStr, sqftStr, occupancyStr) {
    if (priceStr && sqftStr && occupancyStr) {
        const price = priceToNumber(priceStr);
        const sqft = priceToNumber(sqftStr);
        const occupancy = percentToNumber(occupancyStr);

        if (price && sqft && occupancy) {
            return (Math.round((price / (sqft * (occupancy / 100))) * 100) / 100).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2});
        }
    }

    return "";
}

function getPropertiesDashboardUrl() {
    return `${arc.path.base}list?source=STRIVE&status=Active&transaction_type=Investment+Sales`;
}

// Last Properties list URL (filters/search included), saved by Listing; falls back to the default Active view.
function getLastPropertiesListUrl() {
    let url = null;
    try {
        url = localStorage.getItem("lastPropertiesListUrl");
    } catch (e) { }
    return url && url.startsWith(`${arc.path.base}list`) ? url : getPropertiesDashboardUrl();
}

function resolvePropertyBackUrl(fromListUrl) {
    if (!fromListUrl) {
        return null;
    }
    if (/\/investor\//i.test(fromListUrl)) {
        return getPropertiesDashboardUrl();
    }
    return fromListUrl;
}

function percentToNumber(str) {
    if (typeof str === "string") {
        str = str.trim().replace(/,/g, "").replace(/%$/, "");
        const num = Number(str);
        if (str && num === num) {
            // !isNaN
            return num;
        }
    }
    return false;
}

function percentToString(str) {
    if (typeof str === "string") {
        str = str.trim().replace(/,/g, "").replace(/%$/, "");
        return str;
    }
    return false;
}

export function priceToNumber(str) {
    if (typeof str === "string") {
        str = str.trim().replace(/\$|,/g, "");
        const num = Number(str);
        if (str && num === num) {
            // !isNaN
            return num;
        }
    }
    return str || false;
}

export function priceToString(str) {
    if (typeof str === "string") {
        str = str.trim().replace(/\$|,/g, "");
        return str;
    }
    return false;
}

// function convertDataToForm(dbData, withSeller) {
//     const data = {...dbData};
//     const seller = {};

//     priceProps
//         .filter((key) => data[key])
//         .forEach((key) => {
//             const num = Number(data[key]);
//             if (num === num) {
//                 // !isNaN
//                 if (["TOTAL_FEE", "POTENTIAL_FEE", "LIST_FEE", "BUYSIDE_FEE"].includes(key)) {
//                     data[key] = num.toLocaleString(undefined, {minimumFractionDigits: 2});
//                 } else {
//                     data[key] = num.toLocaleString();
//                 }
//             }
//         });

//     const price = data.SOURCE === 'HSC' ? data.HSC_PRICE : data.LIST_PRICE;
//     const rentPrice = data.TYPE === 'MT' ? data.BASE_RENT : data.NET_OPERATING_INCOME;
//     const occupancy = data.TYPE === 'MT' ? data.VACANCY : '100';
//     data.PRICE_PER_SQFT = pricePerFoot(price, data.SQFT);
//     data.RENT_PER_SQFT = rentPerFoot(rentPrice, data.SQFT, occupancy);
//     data.CLOSE_PRICE_PER_SQFT = pricePerFoot(data.SOLD_PRICE, data.SQFT);
//     data.NEGOTIATION_PRICE_PER_SQFT = pricePerFoot(data.NEGOTIATION_PRICE, data.SQFT);
//     data.CREDITS_AT_CLOSING = !data.CREDITS_AT_CLOSING ? '0' : data.CREDITS_AT_CLOSING;
//     if (!data.NOI_PERCENT)
//         data.NOI_PERCENT = 90;

//     dateProps
//         .filter((key) => data[key])
//         .forEach((key) => {
//             if(key !== 'CLOSE_OF_ESCROW'){
//                 const str = dateISOtoUS(data[key]);
//                 if (str !== false) {
//                     data[key] = str;
//                 }
//             }            
//         });

//     checkboxProps
//         .filter(key => data[key])
//         .forEach(key => {
//             data[key] = data[key] === 'y'
//         });

//     agentKeyPercents
//         .filter((key) => data[key])
//         .forEach((key) => {
//             if (!parseFloat(data[key])) {
//                 data[key] = "";
//             }
//         });


//     if (withSeller) {
//         sellerKeys.forEach(key => {
//             const sellerKey = `SELLER_${key}`;
//             if (data.hasOwnProperty(sellerKey)) {
//                 seller[key] = data[sellerKey];
//                 delete data[sellerKey];
//             }
//         });

//         return {data, seller};
//     }
//     return data;
// }

function convertDataToForm(dbData, withSeller) {
    const data = { ...dbData };
    const seller = {};

    priceProps
        .filter((key) => data[key])
        .forEach((key) => {
            const num = Number(data[key]);
            if (num === num) {
                // !isNaN
                if (["total_fee", "potential_fee", "list_fee", "buyside_fee"].includes(key)) {
                    data[key] = num.toLocaleString(undefined, { minimumFractionDigits: 2 });
                } else {
                    data[key] = num.toLocaleString();
                }
            }
        });

    const price = data.source === 'HSC' ? data.hsc_price : data.list_price;
    const rentPrice = data.type === 'MT' ? data.base_rent : data.net_operating_income;
    const occupancy = data.type === 'MT' ? data.vacancy : '100';
    data.price_per_sqft = pricePerFoot(price, data.sqft);
    data.rent_per_sqft = rentPerFoot(rentPrice, data.sqft, occupancy);
    data.close_price_per_sqft = pricePerFoot(data.sold_price, data.sqft);
    data.negotiation_price_per_sqft = pricePerFoot(data.negotiation_price, data.sqft);
    data.credits_at_closing = !data.credits_at_closing ? '0' : data.credits_at_closing;
    let propertiesArray = (data.hotlist_properties || '').split(',');
    data['hot_list'] = propertiesArray.includes(data.arcimedes_row_id) ? "1" : "0";

    if (!data.noi_percent)
        data.noi_percent = 90;

    dateProps
        .filter((key) => data[key])
        .forEach((key) => {
            if (key !== 'close_of_escrow') {
                const str = dateISOtoUS(data[key]);
                if (str !== false) {
                    data[key] = str;
                }
            }
        });

    checkboxProps
        .filter(key => data[key])
        .forEach(key => {
            data[key] = data[key] === 'y'
        });

    agentKeyPercents
        .filter((key) => data[key])
        .forEach((key) => {
            if (!parseFloat(data[key])) {
                data[key] = "";
            }
        });


    if (withSeller) {
        sellerKeys.forEach(key => {
            const sellerKey = `seller_${key}`;
            if (data.hasOwnProperty(sellerKey)) {
                seller[key] = data[sellerKey];
                delete data[sellerKey];
            }
        });

        return { data, seller };
    }
    return data;
}

function convertFormToData(formData) {
    //for the check of NAN when we destructuring formdata decimal values converting into NAN so below code changed
    // const data = {...formData,negotiation_cap_rate: parseFloat(formData.negotiation_cap_rate) || "",vacancy:parseFloat(formData.vacancy) || ""};
    const data = {
        ...formData,
        negotiation_cap_rate: formData.negotiation_cap_rate ? parseFloat(formData.negotiation_cap_rate) : "",
        vacancy: formData.vacancy ? parseFloat(formData.vacancy) : "",
      };
      
    // Convert money and locale number formatting to STRING
    priceProps.forEach((key) => {
        const num = priceToString(data[key]);
        if (num !== false) {
            data[key] = num;
        }
    });

    percentProps.forEach((key) => {
        const num = percentToString(data[key]);
        if (num !== false) {
            data[key] = num;
        }
    });

    dateProps
        .filter((key) => data[key])
        .forEach((key) => {
            const str = dateUStoISO(data[key]);
            if (str !== false) {
                data[key] = str;
            }
        });

    checkboxProps.forEach(key => {
        data[key] = data[key] ? 'y' : null
    });

    agentKeyPercents.forEach((key) => {
        const num = percentToString(data[key]);
        if (num !== false) {
            if (!parseFloat(data[key])) {
                data[key] = "0.000000000000000";
            } else {
                data[key] = num;
            }
        }
    });

    if (data.net_operating_income && data.status === "Closed" && !data.close_noi) {
        data.close_noi = data.net_operating_income;
    }

    if (data.sold_price && data.close_noi) {
        data.close_cap_rate = Math.round((data.close_noi / data.sold_price) * 10000) / 100;
    }

    // Normalize
    Object.keys(data).forEach((key) => {
        // Trim whitespace
        if (typeof data[key] === "string") {
            data[key] = data[key].trim();
        }

        // Replace empty with null for consistency
        if (data[key] === "") {
            data[key] = null;
        }
    });

    return data;
}

function convertPaymentsDataToForm(dbData, propertyId, isReferral) {
    let data = dbData && cloneDeep(dbData);
    if (data && data.data) {
        data = data.data;
    }
    data = data.filter((el) => el.deleted !== '1')
    const minMembers = isReferral ? minReferralMembers : minStriveMembers;
    while (data.length < minMembers) {
        data.push({
            property_id: propertyId
        });
    }

    data.map((row) => {
        paymentsPriceProps.forEach((key) => {
            const num = Number(data[key]);
            if (num === num) {
                row[key] = num.toLocaleString();
            }
        });
    });

    return data;
}

function convertPaymentsFormToData(formData) {
    const data = cloneDeep(formData);

    data.map((elem) => {
        paymentsPriceProps.forEach((key) => {
            const num = priceToString(elem[key]);
            if (num !== false) {
                elem[key] = num;
            }
        });

        paymentsPercentProps.forEach((key) => {
            const num = percentToString(elem[key]);
            if (num !== false) {
                elem[key] = Number(num).toFixed(2);
            }
        });

        // Normalize
        Object.keys(elem).forEach((key) => {
            // Trim whitespace
            if (typeof elem[key] === "string") {
                elem[key] = elem[key].trim();
            }

            // Replace empty with null for consistency
            if (elem[key] === "") {
                elem[key] = null;
            }
        });
    });

    return data;
}

function convertLoanQuotesDataToForm(lqData, propertyData) {
    const data = cloneDeep(lqData);
    const propData = {...propertyData};

    while (data.length < loanQuotesColumnsNumber){
        data.push({
            property_id: parseInt(propData.arcimedes_row_id)
        });
    }
    data.map((loanOption, index) => {
        loanOption.property_id = parseInt(propData.arcimedes_row_id)
        if(loanOption.amortization === 'Interest On'){
            loanOption.amortization = 'Interest Only'
        }
        if(!loanOption.loan_quotes_order){
            loanOption.loan_quotes_order = index;
        }else if(typeof loanOption.loan_quotes_order === 'string' && !isNaN(loanOption.loan_quotes_order)) {
            loanOption.loan_quotes_order =  parseInt(loanOption.loan_quotes_order, 10);
        }
        lqPriceProps
            .filter((key) => loanOption[key])
            .forEach((key) => {
                const num = Number(data[key]);
                if (num === num) {
                    loanOption[key] = num.toLocaleString();
                }
            });

        lqcheckboxProps.forEach((key) => {
            loanOption[key] = loanOption[key] === "1" || loanOption[key] === true || loanOption[key] === 1;
        });


        if (loanOption.down_payment_percent === "0.00") {
            loanOption.down_payment_percent = "";
        }
        if (loanOption.interest_rate === "0.000") {
            loanOption.interest_rate = "";
        }
        if (loanOption.loan_payment_annually === "0.00") {
            loanOption.loan_payment_annually = "";
        }
        if (!loanOption.purchase_price) {
            loanOption.purchase_price = propData.source === 'STRIVE' ? propData.negotiation_price && propData.negotiation_price.toString() : (propData.source ==='HSC' ? propData.hsc_price && propData.hsc_price.toString() : null);

            if (loanOption.down_payment_percent)
                loanOption.down_payment = loanOption.purchase_price * loanOption.down_payment_percent / 100;

            if (loanOption.down_payment)
                loanOption.loan_amount = loanOption.purchase_price - loanOption.down_payment;
        }

        if (!loanOption.cap_rate)
            loanOption.cap_rate = propData.source ==='STRIVE' ? propData.negotiation_cap_rate : (propData.source ==='HSC' ? propData.capitalization_rate : null) ;

        if((!loanOption.noi_percentage || loanOption.noi_percentage == "0.00") && propData.noi_percent){
            loanOption.noi_percentage = propData.noi_percent;
        }

        if(!loanOption.total_origination_fee && propData.total_origination_fee){
            loanOption.total_origination_fee = propData.total_origination_fee;
        }
        if (!loanOption.noi_multiplied && propData.net_operating_income) {
            loanOption.noi = propData.net_operating_income;
            if (loanOption.noi_percentage) {
                const NOI = priceToNumber(loanOption.noi);
                const NOIPercentage = Number(loanOption.noi_percentage).toFixed(2);
                loanOption.noi_multiplied = Math.round(NOI * NOIPercentage / 100);
            }

            if (loanOption.loan_payment_annually) {
                loanOption.cash_flow_annually = Math.round(priceToNumber(loanOption.noi) - priceToNumber(loanOption.loan_payment_annually));
                loanOption.cash_flow_monthly = Math.round(loanOption.cash_flow_annually / 12);
            }
            loanOption.noi = propData.net_operating_income && propData.net_operating_income.toString();
        }
        if (loanOption.noi_percentage === undefined || null || "0.00") {
            loanOption.noi_percentage = propData.noi_percent;
        }
        ["loan_term", "maturity"].forEach((key) => {
            if (loanOption[key] && typeof loanOption[key] === "string") {
                const num = parseFloat(loanOption[key]);
                loanOption[key] = num % 1 === 0 ? num.toFixed(0) : num.toString();
            }
        });
    });
    data.sort((a, b) => a.loan_quotes_order - b.loan_quotes_order);
    return data;
}

function convertLoanQuotesFormToData(formData) {
    const data = cloneDeep(formData);

    data && data.map((elem) => {
        lqPriceProps.forEach((key) => {
            const num = priceToString(elem[key]);
            if (num !== false) {
                elem[key] = num;
            }
        });

        lqcheckboxProps.forEach(key => {
            elem[key] = elem[key] ? true : false
        });

        lqPercentProps.forEach((key) => {
            const num = percentToString(elem[key]);
            if (num !== false) {
                if(key==='interest_rate'){
                    elem[key] = Number(num).toFixed(3);
                }
                else elem[key] = Number(num).toFixed(2);
            }
        });

        // Normalize
        Object.keys(elem).forEach((key) => {
            // Trim whitespace
            if (typeof elem[key] === "string") {
                elem[key] = elem[key].trim();
            }

            // Replace empty with null for consistency
            if (elem[key] === "") {
                elem[key] = null;
            }
        });
    });

    return data;
}

function calculateExpirationDate({noMonths, listedDate}) {
    if (!noMonths || !listedDate) {
        return "";
    }
    const date = new Date(listedDate);
    const months = parseInt(noMonths);
    if (date) {
        date.setMonth(date.getMonth() + months);
    }
    return date ? dateToUsString(date) : "";
}

function setListingAgentsPercent(data, p1, p2, p3, p4) {
    data.listing_agent_1_percent = p1;
    data.listing_agent_2_percent = p2;
    data.listing_agent_3_percent = p3;
    data.referring_listing_agent_percent = p4;
}

function setBuyingAgentsPercent(data, p1, p2, p3, p4) {
    data.buyer_agent_1_percent = p1;
    data.buyer_agent_2_percent = p2;
    data.buyer_agent_3_percent = p3;
    data.referring_buyer_agent_percent = p4;
}

function changeListingAgentsPercent(oldData) {
    const data = { ...oldData };
    if(['Active', 'Under Contract', 'Closed'].includes(data.status)){
        return data
    }
    const activeAgents = [
        data.listing_agent_1,
        data.listing_agent_2,
        data.listing_agent_3,
        data.referring_listing_agent,
    ].filter(Boolean); 

    const hasSplit = data.buyer_agent_1 || data.buyer_agent_2 || data.buyer_agent_3 || data.buyer_agent_4 || data.referring_buyer_agent;

    const percentage = activeAgents.length
        ? (hasSplit ? 50 : 100) / activeAgents.length
        : 0;

    data.listing_agent_1_percent = data.listing_agent_1 ? percentage.toFixed(2) : "0.00";
    data.listing_agent_2_percent = data.listing_agent_2 ? percentage.toFixed(2) : "0.00";
    data.listing_agent_3_percent = data.listing_agent_3 ? percentage.toFixed(2) : "0.00";
    data.referring_listing_agent_percent = data.referring_listing_agent ? percentage.toFixed(2) : "";
    
    data.listing_agent_4_percent = data.listing_agent_4_percent && data.listing_agent_4_percent != "0.00" ? data.listing_agent_4_percent : data.listing_agent_4
        ? (hasSplit ? "50.00" : "100.00")
        : "0.00";

    return data;
}

function changeBuyingAgentsPercent(oldData) {
    let data = { ...oldData };
    if(['Active', 'Under Contract', 'Closed'].includes(data.status)){
        return data
    }
    const activeAgents = [
        data.buyer_agent_1,
        data.buyer_agent_2,
        data.buyer_agent_3,
        data.referring_buyer_agent,
    ].filter(Boolean); 

    const percentage = activeAgents.length ? (50 / activeAgents.length).toFixed(2) : "0.00";

    data.buyer_agent_1_percent = data.buyer_agent_1 ? percentage : "0.00";
    data.buyer_agent_2_percent = data.buyer_agent_2 ? percentage : "0.00";
    data.buyer_agent_3_percent = data.buyer_agent_3 ? percentage : "0.00";
    data.referring_buyer_agent_percent = data.referring_buyer_agent ? percentage : "";

    data.buyer_agent_4_percent = data.buyer_agent_4_percent && data.buyer_agent_4_percent != "0.00" ? data.buyer_agent_4_percent : data.buyer_agent_4 ? "50.00" : "0.00";

    data = changeListingAgentsPercent(data);

    return data;
}


export default class CRUDProperty extends React.Component {
    currentPageRef;
    drawerComponentRef;
    static get contextType() {
        return UserContext;
      }
    constructor(props) {
        super(props);

        this.state = {
            openReminderDialog: false,
            openEscrowDialog: false,
                data: {},
                agentList: [],
                proposalData: {
                strengths: '',
                challenges: '',
                buyer_pool: 'Local, Regional, National, & International Private \n Capital Buyers, Many of Whom are in 1031 Exchanges \n Institutional Capital Targeting Quality, Stabilized Real Estate',
                qualifications: 'STRIVE: Most Active Retail Team in Texas & Surrounding States \n Track Record: We Close Transactions - Sold More Than 1,200 Retail Transactions \n  STRIVE Team Controls the Entire Process - Underwriting & Financial Analysts, Full Marketing Dept, Transaction Coordinators, and Team of Agents to Ensure High Probability of Closing \n   100% Cooperation – More Buyers - More Offers = Higher Price \n Ability to Source Qualified Debt Thru High Street Capital',
                recommendations: 'Sell Now to Take Advantage of the Current Market Before Interest Rates Increase Further and Capitalize on 1031 Buyers \n  If Awarded the Assignment, We Can Be on the Market Within One Week and Closed Within Our Average List-to-Close Time Frame of 4.5 Months',
            },
            loanQuotesData: null,
            originalLoanQuotesData: null,
            hscPaymentsData: null,
            propertyPaymentsData: null,
            deletedPaymentsData: [],
            originalPaymentsData : null,
            original: null,
            previousData: null,
            seller: null,
            originalSeller: null,
            buyer: null,
            originalBuyer: null,
            hasModifiedStatus: false,
            isHscApproved: false,
            isClosedReferral: false,
            hasModifiedListPrice: false,
            hasReducedListPrice: false,
            isBusy: null,
            error: null,
            success: null,
            financialsSpreadsheetInView: false,
            currentUser: null,
            newPropertyId: null,
            allTenants: null,
            allTenantsById: null,
            tenantsBySQFT: null,
            showDrawer: false,
            addNewItemType: null,
            newSeller: null,
            newBuyer: null,
            newAgent: null,
            newFirm: null,
            newLender: null,
            errorTabs: [],
            currentTab: 0,
            viewMode: this.props.edit || false,
            sellerSelected: false,
            showModal:false,
            showHscModal: false,
            historyDeleteRowId:null,
            agentsGrossCumulativeProcured: {},
            hscAgentsGrossCumulative: {},
            resetDrawer: false,
            displayedHSCAgents: 1,
            recomputePayments: false,
            openEscrowDateError: false,
            tranche:null,
            netFee:null,
            searchCrudFilter : false,
            filterData: [],
            currentIndex: 0,
            hotlist:0,
            fromListUrl: resolvePropertyBackUrl(
                (props.location.state && props.location.state.fromListUrl) ||
                localStorage.getItem("fromListUrl") ||
                null
            ),
            territoryMarketMap: {},
            propertyNotesData : []
        };
        this.userData = this.context;
        this.client = null;
        this.isPropertyExists = this.isPropertyExists.bind(this);
        this.notesRef = createRef();
        this.handleSubmit = this.handleSubmit.bind(this);
        this.setDataFromFinancials = this.setDataFromFinancials.bind(this);
        this.openFinancialsSpreadsheet = this.openFinancialsSpreadsheet.bind(this);
        this.closeFinancialsSpreadsheet = this.closeFinancialsSpreadsheet.bind(this);
        this.setValue = this.setValue.bind(this);
        this.handleChangeInput = this.handleChangeInput.bind(this);
        this.handlePropsalInputChange = this.handlePropsalInputChange.bind(this);
        this.handleLoanQuotesChangeInput = this.handleLoanQuotesChangeInput.bind(this);
        this.handleLoanQuotesChangeDropdown = this.handleLoanQuotesChangeDropdown.bind(this);
        this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
        this.handleNotesChange = this.handleNotesChange.bind(this)
        this.handleSellerChangeDropdown = this.handleSellerChangeDropdown.bind(this);
        this.handleSellerChangeInput = this.handleSellerChangeInput.bind(this);
        this.handleChangeFile = this.handleChangeFile.bind(this);
        this.handleDeleteHistory = this.handleDeleteHistory.bind(this);
        this.showHistoryDeleteModal = this.showHistoryDeleteModal.bind(this);
        this.handleChangeSeller = this.handleChangeSeller.bind(this);
        this.addNewItem = this.addNewItem.bind(this);
        this.savedNewItem = this.savedNewItem.bind(this);
        this.checkCoordinatesAndSave = this.checkCoordinatesAndSave.bind(this);
        this.closeDrawer = this.closeDrawer.bind(this);
        this.getTenantsForTags = this.getTenantsForTags.bind(this);
        this.redirectToEscrowTracking = this.redirectToEscrowTracking.bind(this);
        this.redirectToHscTracking = this.redirectToHscTracking.bind(this);
        this.getAgentsGrossCumulativeProcured = this.getAgentsGrossCumulativeProcured.bind(this);
        this.getAgentGrossCumulativeProcured = this.getAgentGrossCumulativeProcured.bind(this);
        this.setPaymentsData = this.setPaymentsData.bind(this);
        this.handlePaymentsChangeDropdown = this.handlePaymentsChangeDropdown.bind(this);
        this.handleAddMember = this.handleAddMember.bind(this);
        this.drawerComponentRef = React.createRef();
        this.currentPageRef = React.createRef();
        this.refreshHistoryData = this.refreshHistoryData.bind(this);
        this.openHscPayments = this.openHscPayments.bind(this);
        this.handleHscPaymentsChangeInput = this.handleHscPaymentsChangeInput.bind(this);
        this.handleHscPaymentsChangeDropdown = this.handleHscPaymentsChangeDropdown.bind(this);
        this.getHscAgentsGrossCumulative = this.getHscAgentsGrossCumulative.bind(this);
        this.getHscAgentGrossCumulative = this.getHscAgentGrossCumulative.bind(this);
        this.computeHscAgentFees = this.computeHscAgentFees.bind(this);
        this.addHscMember = this.addHscMember.bind(this);
        this.recomputePayments = this.recomputePayments.bind(this);
        this.handleInputBlur = this.handleInputBlur.bind(this);
        this.checkHistoryAndSave = this.checkHistoryAndSave.bind(this);
        this.calculateGrossAmount = this.calculateGrossAmount.bind(this);
        this.updateURL = this.updateURL.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handlePrintPagesDropDown = this.handlePrintPagesDropDown.bind(this);
        this.addNewColumn = this.addNewColumn.bind(this);
        this.saveData = this.saveData.bind(this)
        this.updateColumns = this.updateColumns.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.onConfirm = this.onConfirm.bind(this);
    }

    parseSortOptions(orderQuery) {
        if (orderQuery && Array.isArray(orderQuery)) {
            return orderQuery.map((item, index) => {
                const [field, order] = item.split('.');
                return {
                    field: field.toLowerCase(),
                    order: order.toLowerCase()
                };
            });
        }
        else if (orderQuery) {
            const [field, order] = orderQuery.split('.');
            return [{
                field: field.toLowerCase(),
                order: order.toLowerCase()
            }];
        }
        else{
            return [];
        }

    }

    componentWillReceiveProps(nextProps) {
        if (this.props.params.id !== nextProps.params.id) {
            this.getProperty(nextProps.params.id);
        }
    }

    parseFilterOptions(q) {
    let query = Listing.setQueryOrder(q);
        if (!query.order && q.source === "STRIVE" && q.status === "Active" && q.transaction_type === "Investment Sales") {
            let order = "Listed_date.desc";
            query = { ...query, order };
        }

        let page = 'properties';
        let propertiesQueryName = V7_PROPERTIES_LIST_DEV;
        let responseListKey = 'v7PropertiesList'
        // if(query.hasOwnProperty('territory_listing_agent_team')&&!['Territory1','Territory2','Territory3','Territory4'].includes(query.territory_listing_agent_team)){
        //     delete query.hscStatuses
        //     page = 'territories'
        //     propertiesQueryName = V9_PROPERTIES_LIST;
        //     responseListKey = 'v9PropertiesList'
        //     /* Retriving the category and type from product type */
        //     if(query.hasOwnProperty('product_type')){
        //         const _types = new Set();
        //         const _categories = new Set();
        //         query.product_type.split(',').forEach((product)=>{
        //             let _type = product.split(' ')
        //             if(_type.length === 2){
        //                 _categories.add(_type[1]);
        //                 _types.add(_type[0]);
        //             }
        //         })
        //         let category = '';
        //         let type = '';
        //         _categories.forEach((key)=>{category = category+','+key});
        //         _types.forEach((key)=>{type = type+','+key});
        //         category = category.replace(/^,|,$/g, '')
        //         type = type.replace(/^,|,$/g, '')
        //         if(_types.size > 0){
        //             query['type'] = type;
        //             query['category'] = category;
        //         }else if(_categories.size > 0){
        //             query['category'] = category;
        //         }else if(query.product_type !== null && query.product_type !== ''){
        //             query['category'] = query.product_type;
        //         }
        //     }
        // }else 
        if(query.hasOwnProperty('product_type_1')||query.hasOwnProperty('territory_1')||query.hasOwnProperty('territory_market_1')){
            // delete query.hscStatuses
            // page = 'territories'
            // propertiesQueryName = V10_PROPERTIES_LIST;
            // responseListKey = 'v10PropertiesList'
            /* Retriving the category and type from product type */
           let territoryProductType = groupObjectByIndex(query).map((val, idx)=>(`${val[`product_type_${idx+1}`]}`)).join(',');
           
                const _types = new Set();
                const _categories = new Set();
                if(territoryProductType && territoryProductType!==null && territoryProductType !==''){
                    territoryProductType.split(',').forEach((product)=>{
                        let _type = product.split(' ')
                        if(_type.length === 2){
                            _categories.add(_type[1]);
                            _types.add(_type[0]);
                        }else if(_type.length === 1){
                            _categories.add(_type[0]);
                        }
                    })
                }
                let category = '';
                let type = '';
                _categories.forEach((key)=>{category = category+','+key});
                _types.forEach((key)=>{type = type+','+key});
                category = category.replace(/^,|,$/g, '').toLowerCase()
                type = type.replace(/^,|,$/g, '')
                if(_types.size > 0){
                    query['type'] = type;
                    query['category'] = category;
                }else if(_categories.size > 0){
                    query['category'] = category;
                }else if(query.product_type !== null && query.product_type !== ''){
                    query['category'] = query.product_type.toLowerCase();
                }
                if(query['category'] && query['category'].includes('multi-family')){
                    query['category'] = query['category'] && query['category'].replace('multi-family', 'apartments');    
                }
        }
        const options = Listing.getOptions(query, page);
        options.param = updateParams(options.param, 'status', 8)
        options.param = updateParams(options.param, 'type', 2)
        options.param = updateParams(options.param, 'category', 5)
        // options.param = updateParams(options.param, 'product_type', 5)
        options.param = updateParams(options.param, 'zip', 120)
        options.param = updateParams(options.param, 'market', 9)
        // options.param = updateParams(options.param, 'territory_market', 11)
        // options.param = updateParams(options.param, 'territory', 4)
        options.param = updateParams(options.param, 'state')
        if(query.hasOwnProperty('product_type_1')||query.hasOwnProperty('territory_1')||query.hasOwnProperty('territory_market_1')){
            options.param.territory_combinations = groupObjectByIndex(query)
        }
        let hscStatuses = [];
        for (const key in options.param) {
            if (key.startsWith("hsc_status_")) {
                if (options.param[key] !== "NOMATCH") {
                    hscStatuses.push(options.param[key]);
                }
            }
        }
        if(hscStatuses.length){
            options.param.hscStatuses = hscStatuses;
        }
        function updateOffsetImmutable(obj, newOffset) { // due to BE response we are passing offset 0 for v7propertiesactive and count api 
            // Create a copy of the original object and update the offset
            const updatedObject = { ...obj, offset: newOffset };
            return updatedObject;
          }
          const updatedObject = updateOffsetImmutable(options.param, 0);
    
        return {
            updatedObject,
            originalParams: options.param,
            propertiesQueryName,
            responseListKey
        };
    }
    

    componentDidMount() {
        const resolvedBackUrl = resolvePropertyBackUrl(
            (this.props.location.state && this.props.location.state.fromListUrl) ||
            this.state.fromListUrl ||
            localStorage.getItem("fromListUrl") ||
            null
        );
        if (resolvedBackUrl) {
            localStorage.setItem("fromListUrl", resolvedBackUrl);
            this.setState({ fromListUrl: resolvedBackUrl });
        }
        const hasQuery = new URLSearchParams(this.props.location.search).toString().length > 0;
        if (!hasQuery) {
            this.getProperty(this.props.params.id);
            sessionStorage.setItem('lastClickedProperty', this.props.params.id);
            // request(arc.path.api, {
            //     service: 'arcimedes',
            //     action: 'open.datasource.table.Data.getData',
            //     params: ['code', 'TEAM', {
            //         limit: {
            //             count: 1000,
            //             offset: 0,
            //         },
            //         column: [
            //             'ARCIMEDES_ROW_ID',
            //             'FIRST_NAME',
            //             'LAST_NAME',
            //             'DELETED',
            //             'IS_AGENT',
            //         ],
            //         filter: [
            //             {
            //                 code: 'FIRST_NAME',
            //                 text: '',
            //                 type: 'notNull',
            //             },
            //             {
            //                 code: 'LAST_NAME',
            //                 text: '',
            //                 type: 'notNull',
            //             },
            //         ],
            //         filterType: 'and',
            //         order: [
            //             {
            //                 code: 'FIRST_NAME',
            //                 type: 'asc',
            //             },
            //             {
            //                 code: 'LAST_NAME',
            //                 type: 'asc',
            //             },
            //         ],
            //     }],
            // }).then(res => {
            //     let items = res.data ? res.data.filter(x => x.FIRST_NAME && x.LAST_NAME) : false;           
            //     this.setState({agentList: items});
            // });
            const token = localStorage.getItem('authToken');
            //     if(this.client){
            //         // variables: { pageOptions: { page: 1, pageSize: 20000 }, filters: [], sortOptions: [] },
            //         this.client.query({ query: GET_TEAM, variables: { filters: [], 
            //                             sortOptions:[{field: "first_name", order: "asc"}, {field: "last_name", order: "asc"}]},
            //             fetchPolicy: "no-cache",
            //             context: {
            //               headers: {
            //                 authorization: `Bearer ${token}`,
            //               },
            //             }}).then((res)=>{
            //                 let items = res.data && res.data.getTeamMembers.teamMember ? res.data.getTeamMembers.teamMember.filter(x => x.first_name && x.last_name) : false;
            //                 this.setState({ agentList: items });
            //             })
            //     }
            // }

            if (this.client) {
                // variables: { pageOptions: { page: 1, pageSize: 20000 }, filters: [], sortOptions: [] },
                // this.client.query({ query: GET_TEAM, variables: { filters: [], 
                // this.client.query({ query: GET_CONTACT_TEAM_LIST_QUERY, variables: {type:"Team", filters: [], 
                //                                 sortOptions:[{field: "first_name", order: "asc"}, {field: "last_name", order: "asc"}]},
                //                 fetchPolicy: "no-cache",
                //                 context: {
                //                   headers: {
                //                     authorization: `Bearer ${token}`,
                //                   },
                // }})
                fetchData(GET_CONTACT_TEAM_LIST_QUERY, {
                    type: "Team", filters: [],
                    sortOptions: [{ field: "first_name", order: "asc" }, { field: "last_name", order: "asc" }]
                })
                    .then((res) => {
                        // let items = res.data && res.data.getTeamMembers.teamMember ? res.data.getTeamMembers.teamMember.filter(x => x.first_name && x.last_name) : false;
                        let items = res.data && res.data.getContacts.data ? res.data.getContacts.data.filter(x => x.first_name && x.last_name) : false;
                        this.setState({ agentList: items });
                    })
            }
        }
        if(hasQuery){
            this.setState({ searchCrudFilter: true });
            this.handleQueryChange();
          }

    fetch('/territory_market_map.csv')
      .then(response => response.text())
      .then(csvText => {
        const cleanText = csvText.replace(/"/g, '');
        const lines = cleanText.trim().split('\n');
        
        const [headerLine, ...dataLines] = lines;

        const headers = headerLine.split(',').map(h => h.trim().toLowerCase());
        const zipIndex = headers.indexOf('zip');
        const marketIndex = headers.indexOf('market');
        if (zipIndex === -1 || marketIndex === -1) {
          console.error("CSV must contain 'zip' and 'market' columns.");
          return;
        }

        const map = {};

        dataLines.forEach(line => {
          const columns = line.split(',').map(col => col.trim());
          const zip = columns[zipIndex];
          const market = columns[marketIndex];

          if (zip && market) {
            map[zip] = market;
          }
        });

        this.setState({territoryMarketMap: map});
      })
      .catch(error => {
        console.error('Error loading CSV:', error);
      });
    }

    componentDidUpdate(prevProps, prevState) {
        if (!shallowEqual(this.props.location.query, prevProps.location.query)) {
         this.refreshHistoryData();
        }

        const hasQuery = new URLSearchParams(this.props.location.search).toString().length > 0;
        const prevHasQuery = new URLSearchParams(prevProps.location.search).toString().length > 0;
        if (hasQuery && prevProps.location.search !== this.props.location.search) {
            this.handleQueryChange();
            this.setState({ searchCrudFilter: true });
        }
        // Check if the query has changed
        // if (prevProps.location.search !== this.props.location.search) {
        //   this.handleQueryChange();
        // }
        if(!hasQuery && prevHasQuery){
               this.getProperty(this.props.params.id);
            // this.fetch(this.props.params.id);
            this.setState({ searchCrudFilter: false });
        }

        const prevBuyerId = prevState.data && prevState.data.buyer_id;
        const nextBuyerId = this.state.data && this.state.data.buyer_id;
        if (nextBuyerId && String(nextBuyerId) !== String(prevBuyerId || "")) {
            this.fetchBuyer();
        }

        const prevSellerId = prevState.data && prevState.data.seller_id;
        const nextSellerId = this.state.data && this.state.data.seller_id;
        if (nextSellerId && String(nextSellerId) !== String(prevSellerId || "")) {
            this.fetchSeller();
        }
      }

    handleQueryChange() {
        const query = this.props.location.query;
        const filterOptions = this.parseFilterOptions(query); 
      
        var isNoFilter = Object.keys(filterOptions).length === 0; 
      
        if (isNoFilter) {
            this.getProperty(this.props.params.id);
            sessionStorage.setItem('lastClickedProperty', this.props.params.id);
            if (this.client) {
                fetchData(GET_CONTACT_TEAM_LIST_QUERY, {
                    type: "Team", filters: [],
                    sortOptions: [{ field: "first_name", order: "asc" }, { field: "last_name", order: "asc" }]
                })
                    .then((res) => {
                        // let items = res.data && res.data.getTeamMembers.teamMember ? res.data.getTeamMembers.teamMember.filter(x => x.first_name && x.last_name) : false;
                        let items = res.data && res.data.getContacts.data ? res.data.getContacts.data.filter(x => x.first_name && x.last_name) : false;
                        this.setState({ agentList: items });
                    })
            }
        }
        else{
          this.fetchWithFilter(filterOptions)
        }
      }
    refreshHistoryData() {
        const query = {...this.props.location.query};
        const options = filter(query, 'history');
        let token = localStorage.getItem('authToken');
        options.param.property_id = this.props.params.id;
         Promise.all([
            //executeQuery({queryName: GET_PROPERTY_HISTORY, options: options})
            // this.client.query({ query: GET_PROPERTY_HISTORY, variables: { propertyId: options.param.property_id },fetchPolicy: "no-cache",
            //     context: {
            //       headers: {
            //         authorization: `Bearer ${token}`,
            //       },
            //     } })
                fetchData(GET_PROPERTY_HISTORY,{ propertyId: options.param.property_id })
        ]).then(res => {
            const filters = query.order ? (Array.isArray(query.order) ? query.order : [query.order]) : [];
            if(this.state.original && this.state.original.loan_type && this.state.original.loan_type == "Refi"){
                const _filter =this.state.original.data[0];
                const _agent = hscTeamMembers.find((e)=> e.EMAIL === _filter['hsc_team_member_1']);             
                _filter.status="Refi";
                _filter.date=_filter.loan_closing_date;
                _filter.listing_agent_firm_name="HSC";
                _filter.arcimedes_row_id=null;
                _filter.price= _filter.loan_amount / (_filter.ltv != null ? (_filter.ltv/100) : '1');
                _filter.listing_agent_4_first_name=_agent.NAME;
                _filter.listing_agent_4_last_name = "";
                res[0].data.propertyHistoryQuery.push(_filter);
            }

            const data = insertCurrentDataToSortedArray(this.state.currentHistoryData, res[0].data.propertyHistoryQuery, filters, historyWeights);

            this.setState({
                historyData:data,
                error: res[0].data.propertyHistoryQuery.length > 0 ? null : res[0].message,
            });
        });
    }

    static excludeSellerData(resData) {
        const data = {...resData};
        sellerKeys.forEach(key => delete data[`SELLER_${key}`]);
        return data;
    }

    closeDrawer() {
        this.setState({showDrawer: false, resetDrawer: true});
    }

    geocode(data, callback) {
        const xhr = new XMLHttpRequest();

        xhr.onload = (e) => {
            try {
                const res = JSON.parse(e.target.response);
                callback(res.results[0].geometry.location);
            } catch (e) {
                callback(null);
            }
        };
        xhr.onerror = () => {
            callback(null);
        };

        xhr.open("GET", "https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyDGktwxbb0xZmCadduTN59ErIU_TBu4soE&address=" + encodeURIComponent(`${data.address}, ${data.city}, ${data.state}`));

       // xhr.open("GET", "https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyDjYXM4MFH059vLuf5mUgItastWFVrKzv4&address=" + encodeURIComponent(`${data.ADDRESS}, ${data.CITY}, ${data.STATE}`));
        xhr.send();
    }

    // getProperty(id) {
    //     this.setState({
    //         data: null,
    //         original: null,
    //         originalLoanQuotesData: null,
    //         originalPaymentsData: null,
    //         error: null,
    //         success: null,
    //         currentUser: null,
    //     });

    //     // const userName = this.props.userData.person.firstName + " " + this.props.userData.person.lastName;
    //     const userName = this.props.userData.username;
    //     if (id === undefined) {
    //         if (this.client) {
    //             this.client.query({ query: GET_ALL_TENANTS })
    //             .then((res) => {
    //                 if (res && res.success && Array.isArray(res.data) && res.data.length) {
    //                     const allTenants = res.data;
    //                     const allTenantsById = [];
    //                     allTenants.forEach((x) => (allTenantsById[x.ARCIMEDES_ROW_ID] = x));
    
    //                     this.setState({
    //                         allTenants: allTenants,
    //                         allTenantsById: allTenantsById,
    //                     });
    //                 }
    //             });
    //         }
            

    //         const data = {
    //             date_created: new Date().toLocaleDateString("en-US"),
    //             created_by: userName,
    //             transaction_type: "Investment Sales",
    //             last_modified_by: userName,
    //             last_modified_date: new Date().toLocaleDateString("en-US"),
    //             proposal_date: new Date().toLocaleDateString("en-US"),
    //             featured: "y",
    //             listing_agent_1_percent: "",
    //             listing_agent_2_percent: "",
    //             listing_agent_3_percent: "",
    //             listing_agent_4_percent: "",
    //             buyer_agent_1_percent: "",
    //             buyer_agent_2_percent: "",
    //             buyer_agent_3_percent: "",
    //             buyer_agent_4_percent: "",
    //             credits_at_closing: '0',
    //         };
    //         this.setState({
    //             data: data,
    //             original: {},
    //             loanQuotesData: convertLoanQuotesDataToForm([], data),
    //             originalLoanQuotesData: {},
    //             originalPaymentsData: {},
    //             propertyPaymentsData: [],
    //             seller: {},
    //             originalSeller: {},
    //             currentUser: userName,
    //             financialsSpreadsheetInView: this.props.isAgent,
    //         });
    //         return;
    //     }


    //     const query = {...this.props.location.query};
    //     const options = filter(query, 'history');
    //     options.param.property_id = id;
    //     const token = localStorage.getItem('authToken');
    //     Promise.all([
    //         executeQuery({
    //             queryName: PROPERTY_DATA,
    //             params: {
    //                 PROPERTY_ID: id,
    //             },
    //         }),
    //         request(arc.path.api, {
    //             service: "arcimedes",
    //             action: "open.dataquery.execute",
    //             params: [PROPERTY_UNDERWRITING_TENANTS, {
    //                 param: {
    //                     PROPERTY_ID: id,
    //                 },
    //             },],
    //         }),
    //         request(arc.path.api, {
    //             service: "arcimedes",
    //             action: "open.dataquery.execute",
    //             params: [GET_ALL_TENANTS, {}],
    //         }),
    //         executeQuery({queryName: GET_PROPERTY_HISTORY,
    //             options:options
    //         }),
    //         getData({
    //             tableCode: HSC_LOAN_QUOTES,
    //             options: {
    //                 filterType: 'and',
    //                 filter: [
    //                     {
    //                         text: id,
    //                         code: 'PROPERTY_ID',
    //                         type: 'exact',
    //                     },
    //                     {
    //                         text: '',
    //                         code: 'DELETED',
    //                         type: 'null',
    //                     }
    //                 ],
    //             },
    //         }),
    //         getData({
    //             tableCode: PROPERTY_PAYMENT_TEAM,
    //             columns: [
    //                 'ARCIMEDES_ROW_ID',
    //                 'PROPERTY_ID',
    //                 'STRIVE_TEAM_MEMBER_ID',
    //                 'STRIVE_TEAM_MEMBER_PERCENT',
    //                 'STRIVE_TEAM_MEMBER_GROSS_FEE',
    //                 'STRIVE_TEAM_MEMBER_NET_FEE',
    //                 'STRIVE_TEAM_MEMBER_NET_PERCENT'
    //             ],
    //             options: {
    //                 filterType: 'and',
    //                 filter: [
    //                     {
    //                         text: id,
    //                         code: 'PROPERTY_ID',
    //                         type: 'exact',
    //                     },
    //                     {
    //                         text: '',
    //                         code: 'DELETED',
    //                         type: 'null',
    //                     }
    //                 ],
    //             },
    //         }),
    //         getData({
    //             tableCode: PROPOSAL,
    //             columns: [
    //                 'ARCIMEDES_ROW_ID',
    //                 'PROPERTY_ID',
    //                 'STRENGTHS',
    //                 'CHALLENGES',
    //                 'BUYER_POOL',
    //                 'QUALIFICATIONS',
    //                 'RECOMMENDATIONS'
    //             ],
    //             options: {
    //                 filterType: 'and',
    //                 filter: [
    //                     {
    //                         text: id,
    //                         code: 'PROPERTY_ID',
    //                         type: 'exact',
    //                     }
    //                 ],
    //             },
    //         }),
    //         this.client.query({ query: GET_PROPERTY_DATA, variables: { arcimedesRowId: id },
    //             fetchPolicy: "no-cache",
    //             context: {
    //               headers: {
    //                 authorization: `Bearer ${token}`,
    //               },
    //             } }),
    //             this.client.query({ query: GET_PROPERTY_UNDERWRITING_TENANTS, variables: { propertyId: id },
    //                 fetchPolicy: "no-cache",
    //                 context: {
    //                   headers: {
    //                     authorization: `Bearer ${token}`,
    //                   },
    //                 } }),
    //                 this.client.query({ query: GET_ALL_TENANTS,fetchPolicy: "no-cache",
    //         context: {
    //           headers: {
    //             authorization: `Bearer ${token}`,
    //           },
    //         } }),
    //         this.client.query({ query: GET_PROPERTY_HISTORY, variables: { property_id: options.param.property_id },fetchPolicy: "no-cache",
    //         context: {
    //           headers: {
    //             authorization: `Bearer ${token}`,
    //           },
    //         } }),
    //         this.client.query({
    //             query: GET_HSC_LOAN_QUOTES, variables: { propertyId: id },
    //             fetchPolicy: "no-cache",
    //             context: {
    //               headers: {
    //                 authorization: `Bearer ${token}`,
    //               },
    //             }
    //         }),
    //         this.client.query({
    //             query: GET_PROPERTY_PAYMENT_TEAM, variables: { propertyId: id },
    //             fetchPolicy: "no-cache",
    //             context: {
    //               headers: {
    //                 authorization: `Bearer ${token}`,
    //               },
    //             }
    //         }),
    //         this.client.query({
    //             query: GET_PROPOSAL, variables: { propertyId: id },
    //             fetchPolicy: "no-cache",
    //             context: {
    //               headers: {
    //                 authorization: `Bearer ${token}`,
    //               },
    //             }
    //         })
    //     ]).then((res) => {
    //         if (res && res[6] && res[6].success && res[6].data.length) {
    //             this.setState({proposalData: {BUYER_POOL: res[6].data[0].BUYER_POOL,
    //                 STRENGTHS: res[6].data[0].STRENGTHS,
    //                 CHALLENGES: res[6].data[0].CHALLENGES, QUALIFICATIONS: res[6].data[0].QUALIFICATIONS, RECOMMENDATIONS: res[6].data[0].RECOMMENDATIONS, ARCIMEDES_ROW_ID: res[6].data[0].ARCIMEDES_ROW_ID}})
    //         }
    //         if (res && res[0] && res[0].success && Array.isArray(res[0].data) && res[0].data.length) {
    //             let {data, seller} = convertDataToForm(res[0].data[0], true);
    //             // Verify if Tenants are saved in Underwriting Tenants Table too (just for Multi Tenant Properties)
    //             if (res[1] && res[1].success && Array.isArray(res[1].data) &&
    //                 res[2] && res[2].success && Array.isArray(res[2].data) && res[2].data.length) {
    //                 const underwritingTenants = res[1].data;
    //                 const allTenants = res[2].data;
    //                 const tenantIds = data.TENANT_ID ? data.TENANT_ID.split(",") : [];
    //                 let newTenants = [];
    //                 const allTenantsById = [];
    //                 allTenants.forEach((x) => (allTenantsById[x.ARCIMEDES_ROW_ID] = x));
    //                 let index = 0;
    //                 tenantIds.map((tenantId) => {
    //                     const existingTenant = underwritingTenants.filter(t => t.TENANT_ID == tenantId).length;
    //                     if (existingTenant <= 0 && allTenantsById[tenantId]) {
    //                         const tenantName = allTenantsById[tenantId].NAME;
    //                         newTenants.push({
    //                             PROPERTY_ID: id,
    //                             TENANT_ID: tenantId,
    //                             TENANT_NAME: tenantName,
    //                             TENANT_ROW_ID: index,
    //                         });
    //                         index++;
    //                     }
    //                 });
    //                 if (newTenants.length > 0) {
    //                     this.saveUnderwritingTenants(newTenants);
    //                 }
    //                 this.setState({
    //                     allTenants: allTenants,
    //                     allTenantsById: allTenantsById,
    //                     tenantsBySQFT: underwritingTenants,
    //                 });
    //             }

    //             const query = {...this.props.location.query};
    //             const filters = query.order ? (Array.isArray(query.order) ? query.order : [query.order]) : [];

    //             const isStrive = data && ['STRIVE','External'].includes(data.SOURCE);
    //             const currentData = new CurrentHistoryModel(res[0].data[0]);
    //             const historyData = res[3] && res[3].success && Array.isArray(res[3].data) ? (['Active', 'Removed', 'Closed'].includes(res[0].data[0].STATUS) ? insertCurrentDataToSortedArray(currentData, res[3].data, filters, historyWeights) : [...res[3].data] ): null;
    //             if(res[0].data[0].LOAN_TYPE == "Refi"){
    //                 const _filter =res[0].data[0];
    //                 const _agent = hscTeamMembers.find((e)=> e.EMAIL === _filter['HSC_TEAM_MEMBER_1'])
    //                 if(res[0].data[0].SOURCE ==="STRIVE"){
    //                     _filter.STATUS="Refi";
    //                 }
    //                 _filter.DATE=_filter.LOAN_CLOSING_DATE;
    //                 _filter.LISTING_AGENT_FIRM_NAME="HSC";
    //                 _filter.LISTING_AGENT_1_FIRST_NAME=_filter.HSC_TEAM_MEMBER;
    //                 _filter.PRICE= Math.round(_filter.LOAN_AMOUNT / (_filter.LTV != null ? (_filter.LTV/100) : 1));
    //                 _filter.ARCIMEDES_ROW_ID=null;
    //                 _filter.LISTING_AGENT_4_FIRST_NAME = _agent.NAME;
    //                 _filter.LISTING_AGENT_4_LAST_NAME = "";
    //                 historyData.push(_filter);
    //             }
    //             historyData.sort((a,b)=>{
    //                 return new Date(b.DATE).getTime() - new Date(a.DATE).getTime();
    //             })
    //             const loanQuotesData = res[4] && res[4].success && Array.isArray(res[4].data) ? convertLoanQuotesDataToForm(res[4].data, res[0].data[0]) : null;
    //             const originalLoanQuotesData = res[4] && res[4].success && Array.isArray(res[4].data) ? cloneDeep(loanQuotesData) : null;
    //             let propertyPaymentsData = [];
    //             const proposalData = res[6] && res[6].success && Array.isArray(res[6].data) ? res[6].data : [];
    //             if (isStrive) {
    //                 propertyPaymentsData = res[5] && res[5].success && Array.isArray(res[5].data) ? convertPaymentsDataToForm(res[5].data, id, res[0].data[0].TRANSACTION_TYPE === 'Referral') : Array.from({length: res[0].data[0].TRANSACTION_TYPE === 'Referral' ? minReferralMembers : minStriveMembers}, () => ({PROPERTY_ID: id}));
    //             }
    //             const originalPaymentsData = res[5] && res[5].success && Array.isArray(res[5].data) ? cloneDeep(propertyPaymentsData) : null;
    //             let displayedHSCAgents = hscAgentsKeys.filter((key) => data[key]!=null).length;
    //             const updatedData = this.handleProposalDataByType(data,this.state.proposalData)
    //             this.setState({
    //                 currentHistoryData: currentData,
    //                 financialsSpreadsheetInView: this.props.isAgent,
    //                 data: {...this.state.data, ...data},
    //                 originalData:res[0],
    //                 original: CRUDProperty.excludeSellerData(res[0].data[0]),
    //                 originalLoanQuotesData: originalLoanQuotesData,
    //                 historyData: historyData,
    //                 loanQuotesData: loanQuotesData,
    //                 propertyPaymentsData: propertyPaymentsData,
    //                 originalPaymentsData: originalPaymentsData,
    //                 displayedHSCAgents: displayedHSCAgents < 1 ? 1 : displayedHSCAgents,
    //                 seller: seller,
    //                 originalSeller: {...seller},
    //                 currentUser: userName,
    //                 error: null,
    //                 proposalData: updatedData,
    //             }, async () => {
    //                 await this.getAgentsGrossCumulativeProcured(data, propertyPaymentsData);
    //                 await this.getHscAgentsGrossCumulative(data);
    //             });
    //         } else {
    //             this.setState({
    //                 data: false,
    //                 original: false,
    //                 originalLoanQuotesData: false,
    //                 originalPaymentsData: false,
    //                 seller: false,
    //                 originalSeller: false,
    //                 error: res[0].message ? res[0].message : "Unidentified Error",
    //             });
    //         }
    //     });
    // }

    getProperty(id) {
        this.setState({
            // data: null,
            original: null,
            originalLoanQuotesData: null,
            originalPaymentsData: null,
            error: null,
            success: null,
            currentUser: null,
            currentUserFullname : null
        });

        // const userName = this.props.userData.person.firstName + " " + this.props.userData.person.lastName;
        const userData = this.context;
   const userFullName = (() => {
  const data = (userData && userData.userData) ? userData.userData : {};
  const hasFirstName = 'firstName' in data && data.firstName && data.firstName.trim() !== '';
  const hasLastName = 'lastName' in data && data.lastName && data.lastName.trim() !== '';

  if (hasFirstName && hasLastName) return `${data.firstName} ${data.lastName}`;
  if (hasFirstName) return data.firstName;
  if (hasLastName) return data.lastName;
  return '';
})();
        const userName = userData.userData.username;
        const token = localStorage.getItem('authToken');
        if (id === undefined) {
            if (this.client) {
                // request(arc.path.api, {
                //     service: "arcimedes",
                //     action: "open.dataquery.execute",
                //     params: [GET_ALL_TENANTS, {}],
                // }).
            //     this.client.query({ query: GET_ALL_TENANTS ,
            //     fetchPolicy: "no-cache",
            //     context: {
            //       headers: {
            //         authorization: `Bearer ${token}`,
            //       },
            //     } 
            // })
          fetchData(GET_TENANTS_PROPERTY_LIST_QUERY, { type:"Tenant"})
            .then((res) => {
                    if (res && res.data.getContacts.data && res.data.getContacts.data.length) {
                        const allTenants = res.data.getContacts.data;
                        const allTenantsById = [];
                        allTenants.forEach((x) => (allTenantsById[x.arcimedes_row_id] = x));

                        this.setState({
                            allTenants: allTenants,
                            allTenantsById: allTenantsById,
                        });
                    }
                });
            }
            const data = {
                // DATE_CREATED: new Date().toLocaleDateString("en-US"),
                // CREATED_BY: userName,
                // TRANSACTION_TYPE: "Investment Sales",
                // LAST_MODIFIED_BY: userName,
                // LAST_MODIFIED_DATE: new Date().toLocaleDateString("en-US"),
                // PROPOSAL_DATE: new Date().toLocaleDateString("en-US"),
                // FEATURED: "y",
                // LISTING_AGENT_1_PERCENT: "",
                // LISTING_AGENT_2_PERCENT: "",
                // LISTING_AGENT_3_PERCENT: "",
                // LISTING_AGENT_4_PERCENT: "",
                // BUYER_AGENT_1_PERCENT: "",
                // BUYER_AGENT_2_PERCENT: "",
                // BUYER_AGENT_3_PERCENT: "",
                // BUYER_AGENT_4_PERCENT: "",
                // CREDITS_AT_CLOSING: '0',


                date_created: new Date().toLocaleDateString("en-US"),
                created_by: userFullName || userName,
                transaction_type: "Investment Sales",
                last_modified_by: userFullName || userName,
                last_modified_date: new Date().toLocaleDateString("en-US"),
                proposal_date: new Date().toLocaleDateString("en-US"),
                featured: "y",
                listing_agent_1_percent: "",
                listing_agent_2_percent: "",
                listing_agent_3_percent: "",
                listing_agent_4_percent: "",
                buyer_agent_1_percent: "",
                buyer_agent_2_percent: "",
                buyer_agent_3_percent: "",
                buyer_agent_4_percent: "",
                credits_at_closing: '0',
            };
            this.setState({
                data: data,
                original: {},
                loanQuotesData: convertLoanQuotesDataToForm([], data),
                originalLoanQuotesData: {},
                originalPaymentsData: {},
                propertyPaymentsData: [],
                seller: {},
                originalSeller: {},
                currentUser: userName,
                currentUserFullname:userFullName,
                financialsSpreadsheetInView: this.props.isAgent && !isAgentUser(this.props.userData),
            });
            return;
        }


        const query = { ...this.props.location.query };
        const options = filter(query, 'history');
        options.param.property_id = id;
       
        Promise.all([
            // executeQuery({ ---0
            //     queryName: PROPERTY_DATA,
            //     params: {
            //         PROPERTY_ID: id,
            //     },
            // }),
            
            // this.client.query({ query: GET_PROPERTY_DATA, variables: { arcimedesRowId: id },
            //     fetchPolicy: "no-cache",
            //     context: {
            //       headers: {
            //         authorization: `Bearer ${token}`,
            //       },
            //     } }),

                fetchData(GET_PROPERTY_DATA,{ arcimedesRowId: id }),
                 // request(arc.path.api, { ---1
            //     service: "arcimedes",
            //     action: "open.dataquery.execute",
            //     params: [PROPERTY_UNDERWRITING_TENANTS, {
            //         param: {
            //             PROPERTY_ID: id,
            //         },
            //     },],
            // }),

            // this.client.query({ query: GET_PROPERTY_UNDERWRITING_TENANTS, variables: { propertyId: id },
            //     fetchPolicy: "no-cache",
            //     context: {
            //       headers: {
            //         authorization: `Bearer ${token}`,
            //       },
            //     } }),
         
            fetchData(GET_PROPERTY_HISTORY,{ propertyId: options.param.property_id }),
         // getData({ ---4
            //     tableCode: HSC_LOAN_QUOTES,
            //     options: {
            //         filterType: 'and',
            //         filter: [
            //             {
            //                 text: id,
            //                 code: 'PROPERTY_ID',
            //                 type: 'exact',
            //             },
            //             {
            //                 text: '',
            //                 code: 'DELETED',
            //                 type: 'null',
            //             }
            //         ],
            //     },
            // }),
            // this.client.query({
            //     query: GET_HSC_LOAN_QUOTES, variables: { propertyId: id },
            //     fetchPolicy: "no-cache",
            //     context: {
            //       headers: {
            //         authorization: `Bearer ${token}`,
            //       },
            //     }
            // }),   
            fetchData(GET_HSC_LOAN_QUOTES,{ propertyId: id }),
          // getData({ ---5
            //     tableCode: PROPERTY_PAYMENT_TEAM,
            //     columns: [
            //         'ARCIMEDES_ROW_ID',
            //         'PROPERTY_ID',
            //         'STRIVE_TEAM_MEMBER_ID',
            //         'STRIVE_TEAM_MEMBER_PERCENT',
            //         'STRIVE_TEAM_MEMBER_GROSS_FEE',
            //         'STRIVE_TEAM_MEMBER_NET_FEE',
            //         'STRIVE_TEAM_MEMBER_NET_PERCENT'
            //     ],
            //     options: {
            //         filterType: 'and',
            //         filter: [
            //             {
            //                 text: id,
            //                 code: 'PROPERTY_ID',
            //                 type: 'exact',
            //             },
            //             {
            //                 text: '',
            //                 code: 'DELETED',
            //                 type: 'null',
            //             }
            //         ],
            //     },
            // }),
            // this.client.query({
            //     query: GET_PROPERTY_PAYMENT_TEAM, variables: { propertyId: id },
            //     fetchPolicy: "no-cache",
            //     context: {
            //       headers: {
            //         authorization: `Bearer ${token}`,
            //       },
            //     }
            // }),
            fetchData(GET_PROPERTY_PAYMENT_TEAM,{ propertyId: id }),
    // getData({ ---6
            //     tableCode: PROPOSAL,
            //     columns: [
            //         'ARCIMEDES_ROW_ID',
            //         'PROPERTY_ID',
            //         'STRENGTHS',
            //         'CHALLENGES',
            //         'BUYER_POOL',
            //         'QUALIFICATIONS',
            //         'RECOMMENDATIONS'
            //     ],
            //     options: {
            //         filterType: 'and',
            //         filter: [
            //             {
            //                 text: id,
            //                 code: 'PROPERTY_ID',
            //                 type: 'exact',
            //             }
            //         ],
            //     },
            // }),
            // this.client.query({
            //     query: GET_PROPOSAL, variables: { propertyId: id },
            //     fetchPolicy: "no-cache",
            //     context: {
            //       headers: {
            //         authorization: `Bearer ${token}`,
            //       },
            //     }
            // })
            fetchData(GET_PROPOSAL,{ propertyId: id })
      ]).then((res) => {
    // ✅ GET_PROPOSAL (res[4])
    if (res && res[4] && res[4].data && res[4].data.getProposal && res[4].data.getProposal.length > 0) {
        const proposal = res[4].data.getProposal[0];
        this.setState({
            proposalData: {
                buyer_pool: proposal.buyer_pool ? proposal.buyer_pool : '',
                strengths: proposal.strengths ? proposal.strengths : '',
                challenges: proposal.challenges ? proposal.challenges : '',
                qualifications: proposal.qualifications ? proposal.qualifications : '',
                recommendations: proposal.recommendations ? proposal.recommendations : '',
                arcimedes_row_id: proposal.arcimedes_row_id ? proposal.arcimedes_row_id : ''
            }
        });
    }

    // ✅ GET_PROPERTY_DATA (res[0])
    if (res && res[0] && res[0].data && res[0].data.getpropertyQuery) {
        let { data, seller } = convertDataToForm(res[0].data.getpropertyQuery, true);

        let hotListProperties = res[0].data.getpropertyQuery.hotlist_properties &&
            res[0].data.getpropertyQuery.hotlist_properties.length > 0 &&
            res[0].data.getpropertyQuery.hotlist_properties.split(",");

        if (hotListProperties && hotListProperties.length > 0) {
            data['hot_list'] = hotListProperties.includes(String(res[0].data.getpropertyQuery.arcimedes_row_id)) ? "1" : "0";
        } else {
            data['hot_list'] = "0";
        }

        const query = { ...this.props.location.query };
        const filters = query.order ? (Array.isArray(query.order) ? query.order : [query.order]) : [];
        const isStrive = data && ['STRIVE', 'External'].includes(data.source);

        const currentData = new CurrentHistoryModel(res[0].data.getpropertyQuery);

        // ✅ GET_PROPERTY_HISTORY (res[1])
        let historyData = [];
        if (res && res[1] && res[1].data && Array.isArray(res[1].data.propertyHistoryQuery)) {
            if (['Active', 'Removed', 'Closed'].includes(res[0].data.getpropertyQuery.status)) {
                historyData = insertCurrentDataToSortedArray(currentData, res[1].data.propertyHistoryQuery, filters, historyWeights);
            } else {
                historyData = [...res[1].data.propertyHistoryQuery];
            }
        }

        if (res[0].data.getpropertyQuery.loan_type === "Refi") {
            const _filter = res[0].data.getpropertyQuery;
            const _agent = hscTeamMembers.find(e => e.EMAIL === _filter['hsc_team_member_1']);
            if (_filter.source === "STRIVE") {
                _filter.status = "Refi";
            }
            _filter.date = _filter.loan_closing_date;
            _filter.listing_agent_firm_name = "HSC";
            _filter.listing_agent_1_first_name = _filter.hsc_team_member;
            _filter.price = Math.round(_filter.loan_amount / (_filter.ltv != null ? (_filter.ltv / 100) : 1));
            _filter.arcimedes_row_id = null;
            _filter.listing_agent_4_first_name = _agent && _agent.NAMES ? _agent.NAMES : '';
            _filter.listing_agent_4_last_name = "";
            historyData.push(_filter);
        }

        historyData.sort((a, b) => {
            return new Date(b.date).getTime() - new Date(a.date).getTime();
        });

        // GET_HSC_LOAN_QUOTES (res[2])
        let loanQuotesData = null;
        if (res && res[2] && res[2].data && res[2].data.getHscLoanQuote) {
            loanQuotesData = convertLoanQuotesDataToForm(res[2].data.getHscLoanQuote, res[0].data.getpropertyQuery);
            if (loanQuotesData && loanQuotesData.length) {
                loanQuotesData.forEach((item, index) => {
                    if (!item["print_page_number"]) {
                        item["print_page_number"] = index <= 4 ? 1 : 2;
                    }
                });
            }
        }

        const originalLoanQuotesData = loanQuotesData ? cloneDeep(loanQuotesData) : null;

        // GET_PROPERTY_PAYMENT_TEAM (res[3])
        let propertyPaymentsData = [];
        if (isStrive) {
            if (res && res[3] && res[3].data && res[3].data.getPropertyPaymentTeam) {
                propertyPaymentsData = convertPaymentsDataToForm(
                    res[3].data.getPropertyPaymentTeam,
                    id,
                    res[0].data.getpropertyQuery.transaction_type === 'Referral'
                );
            } else {
                const count = res[0].data.getpropertyQuery.transaction_type === 'Referral' ? minReferralMembers : minStriveMembers;
                propertyPaymentsData = Array.from({ length: count }, () => ({ property_id: id }));
            }
        }

        const originalPaymentsData = (res && res[3] && res[3].data && res[3].data.getPropertyPaymentTeam)
            ? cloneDeep(propertyPaymentsData)
            : null;

        let displayedHSCAgents = hscAgentsKeys.filter((key) => data[key] != null).length;

        const updatedData = this.handleProposalDataByType(data, this.state.proposalData);
    const isAgentWithRestriction = this.props.isAgent && !isAgentUser(this.props.userData)
        this.setState({
            currentHistoryData: currentData,
            financialsSpreadsheetInView: isAgentWithRestriction,
            data: { ...this.state.data, ...data },
             //original: res[0]res[0].data.getpropertyQuery,
             // original: CRUDProperty.excludeSellerData(res[0].data[0]),
            original: CRUDProperty.excludeSellerData(res[0].data.getpropertyQuery),
            originalLoanQuotesData: originalLoanQuotesData,
            historyData: historyData,
            loanQuotesData: loanQuotesData,
            propertyPaymentsData: propertyPaymentsData,
            originalPaymentsData: originalPaymentsData,
            displayedHSCAgents: displayedHSCAgents < 1 ? 1 : displayedHSCAgents,
            seller: seller,
            originalSeller: { ...seller },
            currentUser: userName,
            currentUserFullname:userFullName,
            error: null,
            proposalData: updatedData,
        }, async () => {
            try {
                const nextData = this.state.data;
                const nextBuyer = this.state.buyer;
                const nextSeller = this.state.seller;
                const hasBuyerId = nextData && nextData.buyer_id;
                const hasBuyerName =
                    nextBuyer &&
                    (nextBuyer.first_name || nextBuyer.last_name);
                if (hasBuyerId && !hasBuyerName) {
                    this.fetchBuyer();
                }

                const hasSellerId = nextData && nextData.seller_id;
                const hasSellerName =
                    nextSeller &&
                    (nextSeller.first_name || nextSeller.last_name);
                if (hasSellerId && !hasSellerName) {
                    this.fetchSeller();
                }
            } catch (e) {
                // Swallow errors: investor link is optional UI.
            }
            await this.getNetFeeFromFeeAmount(data);
            await this.getAgentsGrossCumulativeProcured(data, propertyPaymentsData, token);
            await this.getHscAgentsGrossCumulative(data, token);
            await this.getTenantsApi(data,data.arcimedes_row_id);
        });

    } else {
        this.setState({
            data: false,
            original: false,
            originalLoanQuotesData: false,
            originalPaymentsData: false,
            seller: false,
            originalSeller: false,
            error: res[0] && res[0].message ? res[0].message : "Unidentified Error",
        });
    }
}).catch((error) => {
    console.error("Error fetching property data:", error);
    this.setState({ error });
});

    }

    fetchWithFilter(filterOptions) {
        ['limit', 'offset'].forEach(key => {
            delete filterOptions.originalParams[key];
        });
        this.setState({
            data: null,
            original: null,
            originalLoanQuotesData: null,
            originalPaymentsData: null,
            error: null,
            success: null,
            currentUser: null,
            currentUserFullname:null
        });
        fetchData(filterOptions.propertiesQueryName, { listOptions: filterOptions.originalParams})
                .then(res => {
                const filterData = res.data[filterOptions.responseListKey] || [];
                if(filterData.length > 0){
                  this.setState({
                    filterData,
                    currentIndex:0,
                    data:  filterData[0],
                    original: { ...filterData[0] },
                    error: null,
                  },() => {
                    this.updateURL(filterData[0]);
                  });
                }else {
                  this.setState({
                    filterData: [],
                    data: false,
                    error: "No filtered data found. Please try again with different filters.",
                  });
                }
                      })
                      .catch((error) => {
                this.setState({
                  data: false,
                  error: error.message || "Unidentified Error",
                });
              });
          
      }
      updateURL(data) {
        const queryParams = new URLSearchParams(this.props.location.search);
        // const name = queryParams.get("name");
        // const newUrl = `/firm/${data.company_id}${name ? `?name=${name}` : ""}`;
        const newUrl = `/property/${data.arcimedes_row_id}?${queryParams.toString()}`;
        browserHistory.push(newUrl);
      }
    handleProposalDataByType(propertyData,proposalData) {
        let data = { ...proposalData }
        /**Handling the null check for the main property data object**/
        if (propertyData && Object.keys(propertyData).length) {
            /** If the property type is single and industrial vacant**/
            if (propertyData.CATEGORY === 'industrial') {
                data.qualifications = 'STRIVE: Most Active Investment Group Based in, and Selling in, Texas \n Track Record: We Close Transactions - Sold More Than 1,300 Transactions \n  STRIVE Team Controls the Entire Process - Underwriting & Financial Analysts, Full Marketing Dept, Transaction Coordinators, and Team of Agents to Ensure High Probability of Closing \n   100% Cooperation – More Buyers - More Offers = Higher Price \n Ability to Source Qualified Debt Thru High Street Capital';
                data.recommendations = 'Sell Now to Take Advantage of the Current Market Before Interest Rates Increase & Capitalize on Buyers in 1031 Exchanges \n If Awarded the Assignment, Will be on the Market within 1 Week & Closed Within 5-6 Months (Ave List-to-Close)';
                data.buyer_pool = 'Local, Regional, National, & International Private \n Capital Buyers, Many of Whom are in 1031 Exchanges \n Institutional Capital Targeting Quality, Stabilized Real Estate';
            }else if(propertyData.category === 'retail'){
                data.qualifications = 'STRIVE: Most Active Retail Team in Texas & Surrounding States \n Track Record: We Close Transactions - Sold More Than 1,200 Retail Transactions \n  STRIVE Team Controls the Entire Process - Underwriting & Financial Analysts, Full Marketing Dept, Transaction Coordinators, and Team of Agents to Ensure High Probability of Closing \n   100% Cooperation – More Buyers - More Offers = Higher Price \n Ability to Source Qualified Debt Thru High Street Capital';
                data.recommendations = 'Sell Now to Take Advantage of the Current Market Before Interest Rates Increase Further and Capitalize on 1031 Buyers \n  If Awarded the Assignment, We Can Be on the Market Within One Week and Closed Within Our Average List-to-Close Time Frame of 5-6 Months';
                data.buyer_pool = 'Local, Regional, National, & International Private \n Capital Buyers, Many of Whom are in 1031 Exchanges \n Institutional Capital Targeting Quality, Stabilized Real Estate';
            }else{
                data.qualifications = 'STRIVE: Most Active Investment Group Based in, and Selling, in Texas \n Track Record: We Close Transactions - Sold More Than 1,300 Transactions STRIVE Team Controls the Entire Process - Underwriting & Financial Analysts, Full Marketing Dept, Transaction Coordinators, and Team of Agents to Ensure High Probability of Closing \n 100% Cooperation – More Buyers - More Offers = Higher Price \n Ability to Source Qualified Debt Thru High Street Capital';
                data.recommendations = 'Sell Now to Take Advantage of the Current Market Before Interest Rates Increase & Capitalize on Buyers in 1031 Exchanges \n If Awarded the Assignment, Will be on the Market within 1 Week & Closed Within 5-6 Months (Ave List-to-Close)';
                data.buyer_pool = 'Local, Regional, National, & International Private \n Capital Buyers, Many of Whom are in 1031 Exchanges \n Institutional Capital Targeting Quality, Stabilized Real Estate';
            }
            if((propertyData.single_tenant_subcategory === 'Vacant' || propertyData.multi_tenant_subcategory === 'Vacant' || propertyData.lease_type === 'Vacant')){
                data.recommendations = 'Sell Now to Take Advantage of the Current Market Before Interest Rates Increase & Capitalize on Buyers in 1031 Exchanges \n If Awarded the Assignment, Will be on the Market within 1 Week & Closed Within 8-9 Months (Ave List-to-Close)';
            }
        }
        return data;
    }

    async saveUnderwritingTenants(tenants) {
        // request(arc.path.api, {
        //     service: "arcimedes",
        //     action: "open.datasource.table.Data.updateByTableCode",
        //     params: [UNDERWRITING_TENANTS, {
        //         value: tenants,
        //     },],
        // tenants.proforma_rr_psf = tenants.proforma_rr_psf && tenants.proforma_rr_psf.toString();
        tenants.rr_monthly_rent = tenants.rr_monthly_rent && tenants.rr_monthly_rent.toString();
        tenants.proforma_lc = tenants.proforma_lc && tenants.proforma_lc.toString();
        tenants.rr_escalation_monthly_rent = tenants.rr_escalation_monthly_rent && tenants.rr_escalation_monthly_rent.toString();
        tenants.proforma_ti_sf = tenants.proforma_ti_sf && tenants.proforma_ti_sf.toString();
        const token = localStorage.getItem('authToken');
        const result = await Promise.all([
            // this.client.mutate({
            //     mutation: UNDERWRITING_TENANTS, variables: { input: tenants },
            //     fetchPolicy: "no-cache",
            //     context: {
            //         headers: {
            //             authorization: `Bearer ${token}`,
            //         },
            //     }
            // })
            mutateData(UNDERWRITING_TENANTS,{ input: tenants })
        ]);
        if (!result || !result[0].data.createOrUpdateUnderwritingTenent.success) {
            this.setState({
                error: result.data.createOrUpdateUnderwritingTenent.message ? result.data.createOrUpdateUnderwritingTenent.message : "Unidentified Error",
            });
        }

        // if(this.client){
        //     const token = localStorage.getItem('authToken');
        //     this.client.mutate({mutation:UNDERWRITING_TENANTS, variables:{input:tenants},
        //         fetchPolicy: "no-cache",
        //         context: {
        //           headers: {
        //             authorization: `Bearer ${token}`,
        //           },
        //         }
        //     }).then((result) => {
        //         if (!result || !result.success) {
        //             this.setState({
        //                 error: result.message ? result.message : "Unidentified Error",
        //             });
        //         }
        //     });
        // }
    }

    async getAgentsGrossCumulativeProcured(data, paymentsData,token) {
        if ((data.source === 'STRIVE' || data.source === 'External') && data.status === 'Closed' && data.close_of_escrow && paymentsData && paymentsData.length) {
            const requests = [];
            const closeOfEscrow = stringUStoISO(data.close_of_escrow);
            paymentsData.forEach(row => {
                if (row.strive_team_member_id)
                    // requests.push(
                    //     executeQuery({
                    //         queryName: GET_AGENT_GROSS_CUMULATIVE,
                    //         params: {
                    //             CURRENT_STRIVE_TEAM_MEMBER: row.strive_team_member_id,
                    //             close_of_escrow: closeOfEscrow,
                    //         }
                    //     })
                    // );

                    if (this.client) {
                        const params = {
                            current_strive_team_member: row.strive_team_member_id,
                            close_of: closeOfEscrow,
                        }
                        requests.push(
                            // this.client.query({ query: GET_AGENT_GROSS_CUMULATIVE, variables:  {
                            //     currentTeamMember: row.strive_team_member_id.toString(),
                            //     closeOfEscrow: closeOfEscrow,
                            // },
                            //     fetchPolicy: "no-cache",
                            //     context: {
                            //       headers: {
                            //         authorization: `Bearer ${token}`,
                            //       },
                            //     } 
                            // })
                            fetchData(GET_AGENT_GROSS_CUMULATIVE,{
                                currentTeamMember: row.strive_team_member_id.toString(),
                                closeOfEscrow: closeOfEscrow,
                            })
                        );
                    }
            });

            if (requests.length) {
                const res = await Promise.all(requests);
                let errorMessage = "";
                let agentsGrossCumulativeProcured = {};
                res.forEach((r, index) => {
                    if (r.data.getAgentGrossCumulative) {
                        // let grossCumulativeProcured = r.data.getAgentGrossCumulative[0] && r.data.getAgentGrossCumulative[0].listing_procured_gross_cumulative ? parseFloat(r.data.getAgentGrossCumulative[0].listing_procured_gross_cumulative) : 0;
                        // grossCumulativeProcured += r.data.getAgentGrossCumulative[0] && r.data.getAgentGrossCumulative[0].buying_procured_gross_cumulative ? parseFloat(r.data.getAgentGrossCumulative[0].buying_procured_gross_cumulative) : 0;
                        let grossCumulativeProcured = r.data.getAgentGrossCumulative && r.data.getAgentGrossCumulative.listingProcuredGrossCumulative ? parseFloat(r.data.getAgentGrossCumulative.listingProcuredGrossCumulative) : 0;
                        grossCumulativeProcured += r.data.getAgentGrossCumulative && r.data.getAgentGrossCumulative.buyingProcuredGrossCumulative ? parseFloat(r.data.getAgentGrossCumulative.buyingProcuredGrossCumulative) : 0;
                        agentsGrossCumulativeProcured[`GROSS_CUMULATIVE_${index + 1}`] = grossCumulativeProcured;
                    } else
                        errorMessage = r.message ? r.message : "Unidentified Error";
                });

                if (errorMessage)
                    this.setState({
                        error: errorMessage,
                    });
                else
                    this.setState({
                        agentsGrossCumulativeProcured,
                    });
            }
        }
    }

    computeHscAgentFees(data, memberKey){
        const agentsGrossCumulative = cloneDeep(this.state.hscAgentsGrossCumulative);

        data[memberKey+'_gross_fee'] = priceToNumber(data.hsc_list_fee) * percentToNumber(data[memberKey+'_percent']) / 100;
        const previousCumulative = agentsGrossCumulative[data[memberKey]];
        const cumulative = data[memberKey+'_gross_fee'] ? data[memberKey+'_gross_fee'] + previousCumulative : previousCumulative;
        const agentPreviousPercent = getHSCCumulativeAgentPercent(previousCumulative);
        const agentPercent = getHSCCumulativeAgentPercent(cumulative);
        let agentNet;
        if (agentPreviousPercent !== agentPercent){        
            const threshold = getHSCCumulativeThreshold(cumulative);
            agentNet = (threshold - previousCumulative) * agentPreviousPercent + (cumulative - threshold) * agentPercent;
        }
        else
            agentNet = data[memberKey+'_gross_fee'] ? data[memberKey+'_gross_fee'] * agentPercent : 0;

        data[memberKey+'_net_fee'] = Number(agentNet).toFixed(2);
        data[memberKey+'_net_percent'] = agentNet / data[memberKey+'_gross_fee']*100;
        data[memberKey+'_gross_fee'] = data[memberKey+'_gross_fee'].toFixed(2)
        return data;
    }

    async getHscAgentGrossCumulative(data, teamMember){
        let token = localStorage.getItem('authToken');
        if ((data.source === 'HSC' || data.hsc_financing) && data.loan_closing_date) {
            const loanClosingDate = stringUStoISO(data.loan_closing_date);
            // const request = executeQuery({
            //                     queryName: HSC_AGENT_CUMULATIVE,
            //                     params: {
            //                         HSC_TEAM_MEMBER: teamMember,
            //                         CURRENT_PROPERTY: data.ARCIMEDES_ROW_ID,
            //                         DATE: loanClosingDate,
            //                     }
            //                 });
                            const params = {
                                hscTeamMember: teamMember,
                                currentProperty: data.arcimedes_row_id,
                                date: loanClosingDate,
                            }
                            // const requestdata =  this.client.query({ query: GET_HSC_AGENT_CUMULATIVE, variables: {
                            //     hscTeamMember: teamMember,
                            //     currentProperty: data.arcimedes_row_id.toString(),
                            //     date: loanClosingDate,
                            // },
                            //     fetchPolicy: "no-cache",
                            //     context: {
                            //       headers: {
                            //         authorization: `Bearer ${token}`,
                            //       },
                            //     } 
                            // })
                            const requestdata = fetchData(GET_HSC_AGENT_CUMULATIVE,{
                                hscTeamMember: teamMember,
                                currentProperty: data.arcimedes_row_id.toString(),
                                date: loanClosingDate,
                            })

            const res = await requestdata;
            let hscAgentsGrossCumulative = this.state.hscAgentsGrossCumulative, errorMessage=null;

            if (res && res.data) {
                hscAgentsGrossCumulative[teamMember] = res.data.hscAgentGrossCumulative && res.data.hscAgentGrossCumulative.hscAgentGrossCumulative ? parseFloat(res.data.hscAgentGrossCumulative.hscAgentGrossCumulative) : 0;
            } else
                errorMessage = res.data.message ? res.data.message : "Hsc Agent cumulative data not found";//message added because no message is coming from the api

        if (errorMessage)
            this.setState({
                error: errorMessage,
            });
        else
            this.setState({
                hscAgentsGrossCumulative,
            });
        }
    }


    async getNetFeeFromFeeAmount(propData) {  
        const data = {...propData};
        const date = new Date(data && data.close_of_escrow);
        const year = date.getFullYear();
        const id = data && data.listing_agent_1;
        const feeAmount = data && data.referral_fee;
              
          if(feeAmount && year != 1970 && id){
            let q = {
                AGENT_ID: id,
                YEAR: year,
                order:'CLOSE_OF_ESCROW.asc'
            }   
    
            const options = filter(q, 'agent-commission');
            const optionsYear = parseInt(options.param.YEAR);
            const optionsAgentId = parseInt(options.param.AGENT_ID);
            
            Promise.all([
                // executeQuery({queryName: AGENT_COMMISSION_PROCURED, options}),
                // executeQuery({queryName: AGENT_COMMISSION_PAID, options})
                fetchData(GET_AGENT_COMMISSION_PROCURED,{year: optionsYear, agentId: optionsAgentId}),
                fetchData(GET_AGENT_COMMISSION_PAID,{options:{year: optionsYear, agent_id: optionsAgentId}}),
            ])
            .then(res => {
                // if (res && res[0] && res[0].success && Array.isArray(res[0].data) &&
                // res[1] && res[1].success && Array.isArray(res[1].data))
                if (res && res[0] && res[0].data && Array.isArray(res[0].data.agentCommissionProcured) &&
                res[1] && res[1] && res[1].data && Array.isArray(res[1].data.agentCommissionPaid))
                {                
                    let grossCumulative = 0;                   
                    let currentTrenche = 0;
                    let insertionIndex = 0;
                    // let paidData = removeDuplicateObjects(res[1].data.filter(property => property.MEMBER_ID === id));
                    let paidData = removeDuplicateObjects(res[1].data.agentCommissionPaid.filter(property => property.member_id === data.listing_agent_1));
                    let map = new Map();
                    // res[0].data.forEach(item =>{ 
                    //     map.set(item.ARCIMEDES_ROW_ID, item)
                    // });
                    res[0].data.agentCommissionProcured.forEach(item =>{ 
                        map.set(item.arcimedes_row_id, item)
                    });
                    // paidData.forEach(item => {
                    //     if (map.has(item.ARCIMEDES_ROW_ID)) {
                    //         let TEAM_MEMBER_GROSS_FEE = item.TEAM_MEMBER_GROSS_FEE;
                    //         map.set(item.ARCIMEDES_ROW_ID, {...map.get(item.ARCIMEDES_ROW_ID), TEAM_MEMBER_GROSS_FEE});
                    //     } else {
                    //         map.set(item.ARCIMEDES_ROW_ID, item);
                    //     }
                    // });
                    paidData.forEach(item => {
                        if (map.has(item.arcimedes_row_id)) {
                            let team_member_gross_fee = item.team_member_gross_fee;
                            map.set(item.arcimedes_row_id, {...map.get(item.arcimedes_row_id), team_member_gross_fee});
                        } else {
                            map.set(item.arcimedes_row_id, item);
                        }
                    });
                    const mergedArray =  Array.from(map.values());  
                    mergedArray.sort(compareDates);
                    const newCloseDate = new Date(data.close_of_escrow);
                    const index = mergedArray.findIndex(item => new Date(item.close_of_escrow) > newCloseDate);
                    if (index === -1) {
                        insertionIndex = mergedArray.length-1;                        
                    } else {
                        insertionIndex = index-1;
                    }
                    mergedArray.forEach((agentObj,index) => {
                    const listingProcuredGrossFee = agentObj.listing_gross_commission ? parseFloat(agentObj.listing_gross_commission) : 0;
                    const buyingProcuredGrossFee = agentObj.buying_gross_commission ? parseFloat(agentObj.buying_gross_commission) : 0;
                    const totalProcuredGrossFee = listingProcuredGrossFee + buyingProcuredGrossFee;                       
                    grossCumulative += totalProcuredGrossFee; 
                    if(insertionIndex === index)  {
                        currentTrenche = getCurrentTrancheOnGrossAmount(grossCumulative)                        
                        return;
                    }  
                });
                
                data['tranche'] = currentTrenche * 100 ; 
                data['net_fee'] = ((parseFloat(feeAmount.replace(/,/g, '')) * currentTrenche)).toFixed(2);
                this.setState({ 
                    netFee:(parseFloat(data.net_fee.replace(/,/g, ''))).toFixed(2),
                    tranche: (currentTrenche * 100).toString(), 
                    data: convertDataToForm(data)
                });
                }                
            });    
        }
        
    }

    async getHscAgentsGrossCumulative(data,token) {
        let assignedTeamMembers = [];
        hscAgentsKeys.map((key) =>{ 
            if(data[key]) 
                assignedTeamMembers.push(data[key])})
        if ((data.source === 'HSC' || data.hsc_financing) && data.loan_closing_date) {
            const requests = [];
            const loanClosingDate = stringUStoISO(data.loan_closing_date);
            assignedTeamMembers.forEach((agent) => {
                // requests.push(
                //     executeQuery({
                //         queryName: HSC_AGENT_CUMULATIVE,
                //         params: {
                //             HSC_TEAM_MEMBER: agent,
                //             CURRENT_PROPERTY: data.ARCIMEDES_ROW_ID,
                //             DATE: loanClosingDate,
                //         }
                //     })
                // );
                const params = {
                    hscTeamMember: agent,
                    currentProperty: data.arcimedes_row_id,
                    date: loanClosingDate,
                }
                // requests.push(this.client.query({ query: GET_HSC_AGENT_CUMULATIVE, variables: {
                //     hscTeamMember: agent,
                //     currentProperty: data.arcimedes_row_id.toString(),
                //     date: loanClosingDate,
                // },
                //     fetchPolicy: "no-cache",
                //     context: {
                //       headers: {
                //         authorization: `Bearer ${token}`,
                //       },
                //     } 
                // }))
                requests.push(fetchData(GET_HSC_AGENT_CUMULATIVE,{
                    hscTeamMember: agent,
                    currentProperty: data.arcimedes_row_id.toString(),
                    date: loanClosingDate,
                }))
            });


            const res = await Promise.all(requests);
            let hscAgentsGrossCumulative = {}, errorMessage=null;
            res.forEach((r, index) => {
                if (r.data.hscAgentGrossCumulative) {
                    hscAgentsGrossCumulative[hscTeamMembers[index].EMAIL] = r.data.hscAgentGrossCumulative && r.data.hscAgentGrossCumulative.hscAgentGrossCumulative ? parseFloat(r.data.hscAgentGrossCumulative.hscAgentGrossCumulative) : 0;
                } else
                    errorMessage = r.message ? r.message : "Unidentified Error";
            });

            if (errorMessage)
                this.setState({
                    error: errorMessage,
                });
            else
                this.setState({
                    hscAgentsGrossCumulative,
                });
        }
    }

async getTenantsApi(data, id) {
  try {
    const [contactsRes, underwritingRes] = await Promise.all([
      fetchData(GET_TENANTS_PROPERTY_LIST_QUERY, { type: "Tenant" }),
      fetchData(GET_PROPERTY_UNDERWRITING_TENANTS, { propertyId: id }),
    ]);

    // Extract underwriting tenants
    let underwritingTenants = [];
    if (
      underwritingRes &&
      underwritingRes.data &&
      Array.isArray(underwritingRes.data.getUnderwritingTenent)
    ) {
      underwritingTenants = underwritingRes.data.getUnderwritingTenent;
    }

    // Extract all tenant contacts
    let allTenants = [];
    if (
      contactsRes &&
      contactsRes.data &&
      contactsRes.data.getContacts &&
      Array.isArray(contactsRes.data.getContacts.data)
    ) {
      allTenants = contactsRes.data.getContacts.data;
    }

    // Get tenant IDs from passed `data`
    let tenantIds = [];
    if (data && typeof data.tenant_id === "string") {
      tenantIds = data.tenant_id.split(",");
    }

    // Map tenants by ID
    const allTenantsById = {};
    for (let i = 0; i < allTenants.length; i++) {
      const tenant = allTenants[i];
      allTenantsById[tenant.arcimedes_row_id] = tenant;
    }

    // Prepare new underwriting tenant objects
    const newTenants = [];
    for (let i = 0; i < tenantIds.length; i++) {
      const tenantId = tenantIds[i];
      const exists = underwritingTenants.some((t) => t.tenant_id == tenantId);
      if (!exists && allTenantsById[tenantId]) {
        const tenantName = allTenantsById[tenantId].name;
        newTenants.push({
          property_id: String(id),
          tenant_id: parseInt(tenantId),
          tenant_name: tenantName,
          tenant_row_id: String(i),
        });
      }
    }

    // Save new tenants if any
    if (newTenants.length > 0) {
      await this.saveUnderwritingTenants(newTenants);
    }

    // Update state
    this.setState(
      {
        allTenants: allTenants,
        allTenantsById: allTenantsById,
        tenantsBySQFT: underwritingTenants,
        tenantIds: tenantIds,
      },
      () => {
        setTimeout(() => {
          const tenantTags = this.getTenantsForTags(tenantIds);
          this.setState({ tenantTags });
        }, 200); // Delay to ensure state is ready
      }
    );
  } catch (error) {
    console.error("❌ Error in getTenantsApi:", error);
  }
}

async getAgentGrossCumulativeProcured(id, closeOfEscrow) {
    let token = localStorage.getItem('authToken');
    const res = await fetchData(GET_AGENT_GROSS_CUMULATIVE, {
        currentTeamMember: id.toString(),
        closeOfEscrow: closeOfEscrow,
    });
    if (res && res.data && res.data.getAgentGrossCumulative) {
        let grossCumulativeProcured = res.data.getAgentGrossCumulative.listingProcuredGrossCumulative
            ? parseFloat(res.data.getAgentGrossCumulative.listingProcuredGrossCumulative)
            : 0;
        grossCumulativeProcured += res.data.getAgentGrossCumulative.buyingProcuredGrossCumulative
            ? parseFloat(res.data.getAgentGrossCumulative.buyingProcuredGrossCumulative)
            : 0;
        return grossCumulativeProcured;
    }
    this.setState({
        error: res.message ? res.message : "Unidentified Error",
    });
    return 0;
}

    /* async getAgentGrossCumulativeProcured(id, closeOfEscrow) {
        let token = localStorage.getItem('authToken');        
        const params = {
            current_strive_team_member: id,
            close_of: stringUStoISO(closeOfEscrow),
        }        
        await fetchData(GET_AGENT_GROSS_CUMULATIVE,{
            currentTeamMember: id.toString(),
            closeOfEscrow: closeOfEscrow,
        })
        .then(res =>{
        if(res && res.data && res.data.getAgentGrossCumulative){
            let grossCumulativeProcured = res.data && res.data.getAgentGrossCumulative.listingProcuredGrossCumulative ? parseFloat(res.data.getAgentGrossCumulative.listingProcuredGrossCumulative) : 0;
            grossCumulativeProcured += res.data && res.data.getAgentGrossCumulative.buyingProcuredGrossCumulative ? parseFloat(res.data.getAgentGrossCumulative.buyingProcuredGrossCumulative) : 0;
            return grossCumulativeProcured;
        }
        this.setState({
            error: res.message ? res.message : "Unidentified Error",
        });
        return 0;
    })
    } */

    static editTrackingTask(data, task, key, substringStart, substringEnd) {
        let newTask = cloneDeep(task);
        const str = newTask.substring(substringStart, substringEnd);
        if (str) {
            newTask = newTask.replace(str, data[key] ? data[key] : "");
        } else {
            newTask = newTask.split("");
            newTask.splice(substringStart, 0, data[key] ? data[key] : "");
            newTask = newTask.join("");
        }
        return newTask;
    }

    // Contacts store "active" as DELETED IS NULL server-side, but the column comes back
    // as null, "1", or 1 depending on the write path, so test all of them.
    static isDeletedInvestor(contact) {
        if (!contact) return false;
        const deleted = contact.deleted;
        if (deleted === null || deleted === undefined || deleted === "") return false;
        return !["0", "false"].includes(String(deleted).toLowerCase());
    }

    // Narrow a raw contact row to the fields the property screen uses, keeping the
    // deleted flag and resolved contact_id that sellerKeys alone would drop.
    static toInvestorContact(result) {
        const transformedResult = {};
        Object.keys(result).forEach((key) => {
            transformedResult[key.toLowerCase()] = result[key];
        });

        const contact = {};
        sellerKeys.forEach((key) => {
            contact[key] = transformedResult[key];
        });
        contact.deleted = transformedResult.deleted;
        contact.contact_id = transformedResult.contact_id;
        return contact;
    }

    // Legacy rows can hold an ARCIMEDES_ROW_ID in buyer_id/seller_id, which
    // getContactByContactid (WHERE CONTACT_ID = ...) never matches. This path already
    // excludes deleted contacts, so a deleted investor resolves to nothing here.
    static fetchInvestorByRowId(investorId) {
        return fetchData(GET_INVESTOR_LIST_QUERY, {
            type: "Investor",
            filters: [{ arcimedes_row_id: String(investorId) }],
        })
            .then((res) => {
                const rows = res && res.data && res.data.getContacts
                    && res.data.getContacts.success && res.data.getContacts.data;
                return rows && rows.length ? rows[0] : null;
            })
            .catch(() => null);
    }

    fetchBuyer() {
        if (!this.state.data || !this.state.data.buyer_id) {
            return;
        }
        const investorId = this.state.data.buyer_id;
        fetchData(GET_CONTACT_INVESTOR_BY_ID, { contactid: Number(investorId) })
            .then((res) => {
                const contact = res && res.data.getContactByContactid.success
                    && res.data.getContactByContactid.contact;
                return contact || CRUDProperty.fetchInvestorByRowId(investorId);
            })
            .then((result) => {
                if (!result) return;
                const buyer = CRUDProperty.toInvestorContact(result);
                this.setState({
                    buyer,
                    originalBuyer: { ...buyer },
                    error: null,
                });
            })
            .catch(() => {});
    }

    fetchSeller() {
        // request(arc.path.api, {
        //     service: "arcimedes",
        //     action: "open.datasource.table.Data.getData",
        //     params: ["code", SELLERS, {
        //         filter: [{
        //             text: this.state.data.SELLER_ID,
        //             code: "ARCIMEDES_ROW_ID",
        //             type: "exact",
        //         },],
        //     },],
        // const token = localStorage.getItem("authToken");
        //     this.client.query({
        //         query: GET_SELLERS_BY_ID,
        //         variables: { arcimedesRowId : this.state.data.seller_id },
        //         fetchPolicy: "no-cache",
        //         context: {
        //           headers: {
        //             authorization: `Bearer ${token}`,
        //           },
        //         },
        // })
        const investorId = this.state.data.seller_id;
        fetchData(GET_CONTACT_INVESTOR_BY_ID, { contactid: Number(investorId) })
            .then((res) => {
            if (res && res.data.getContactByContactid.success && res.data.getContactByContactid.contact) {
                const seller = CRUDProperty.toInvestorContact(res.data.getContactByContactid.contact);
                this.setState({
                    seller,
                    originalSeller: {...seller},
                    sellerSelected: false,
                    error: null,
                });
                return;
            }
            // seller_id is not a CONTACT_ID (legacy rows can hold an arcimedes_row_id),
            // so retry on that column before treating the property as unloadable.
            return CRUDProperty.fetchInvestorByRowId(investorId).then((result) => {
                if (result) {
                    const seller = CRUDProperty.toInvestorContact(result);
                    this.setState({
                        seller,
                        originalSeller: {...seller},
                        sellerSelected: false,
                        error: null,
                    });
                    return;
                }
                this.setState({
                    data: false,
                    error: res.data.getContactByContactid.message ? res.data.getContactByContactid.message : "Unidentified Error",
                });
            });
        });
    }

    static updatePropertyData({data, oldData, original}) {
        const newData = {
            property_id: oldData.arcimedes_row_id,
        };

        let task = `${original.name} - ${original.city ? original.city : ""}, ${original.state ? original.state : ""}`;
        if (data.hasOwnProperty("name")) {
            task = CRUDProperty.editTrackingTask(data, task, "name", 0, task.indexOf("-") - 1);
        }
        if (data.hasOwnProperty("city")) {
            task = CRUDProperty.editTrackingTask(data, task, "city", task.indexOf("-") + 2, task.indexOf(","));
        }
        if (data.hasOwnProperty("state")) {
            task = CRUDProperty.editTrackingTask(data, task, "state", task.indexOf(",") + 2, task.length);
        }
        newData.task = task;

        return newData;
    }

    // async fetchEscrowData(data,token) {
    //     let inEscrow = false;
    //     const propertyInEscrow = await this.getPropertyEscrowTracking(this.state.data.arcimedes_row_id,token);
    //     const oldData = this.state.data;
    //     const striveID = !env ? "34" : "2";

    //     // In Escrow if source is STRIVE & status is Under Contract
    //     // 		  or if source is External & status is Under Contract & Listing/Buyer Agent 4 Firm is STRIVE
    //     if ((oldData.source === "STRIVE" && oldData.status === "Under Contract") ||
    //         (oldData.source === "External" && oldData.status === "Under Contract" &&
    //             (oldData.listing_agent_4_firm === striveID || oldData.buyer_agent_4_firm === striveID))) {
    //         inEscrow = true;
    //     }

    //     // Add property to STRIVE Escrow Tracking
    //     if (inEscrow && oldData.arcimedes_row_id &&
    //         (!propertyInEscrow || !propertyInEscrow.arcimedes_row_id || propertyInEscrow.deleted === 1)) {
    //         let newData = {
    //             property_id: parseInt(oldData.arcimedes_row_id),
    //             task: `${oldData.name} - ${oldData.city ? oldData.city : ""}, ${oldData.state ? oldData.state : ""}`,
    //             deleted: null,
    //         };
    //         if(propertyInEscrow && propertyInEscrow.arcimedes_row_id){
    //             newData = {...newData, arcimedes_row_id: propertyInEscrow.arcimedes_row_id}
    //         }
    //         this.updatePropertyTracking(newData, STRIVE_ESCROW_TRACKING_UPDATE,token);
    //     }

    //     // Update property info in STRIVE Escrow Tracking
    //     if (propertyInEscrow && propertyInEscrow.arcimedes_row_id && propertyInEscrow.deleted !== "1" && oldData.arcimedes_row_id &&
    //         (data.hasOwnProperty("name") || data.hasOwnProperty("city") || data.hasOwnProperty("state"))) {
    //         const original = this.state.original;
    //         const newData = CRUDProperty.updatePropertyData({data, oldData, original});
    //         this.updatePropertyTracking({...newData, arcimedes_row_id: propertyInEscrow.arcimedes_row_id}, STRIVE_ESCROW_TRACKING_UPDATE,token);
    //     }

    //     // Remove property from STRIVE Escrow Tracking
    //     if ((!inEscrow && propertyInEscrow && propertyInEscrow.arcimedes_row_id && propertyInEscrow.deleted !== "1")
    //         || oldData.deleted === "1") {
    //         const data = {
    //             arcimedes_row_id : propertyInEscrow.arcimedes_row_id,
    //             property_id: parseInt(this.state.data.arcimedes_row_id),
    //             deleted: "1",
    //         };
    //         this.updatePropertyTracking(data, STRIVE_ESCROW_TRACKING_UPDATE,token);
    //     }
    // }
    async fetchEscrowData(data, token) {
        let inEscrow = false;
    
        try {
            // Ensure we wait for the response
            const propertyInEscrow = await this.getPropertyEscrowTracking(this.state.data.arcimedes_row_id, token);
    
            const oldData = this.state.data;
            const striveID = !env ? "34" : "2";
            const isStatusActive = Object.keys(this.state.data).length && this.state.data.hasOwnProperty('status') && this.state.data.status && this.state.data.status.toLowerCase() === "active";

            // In Escrow if source is STRIVE & status is Under Contract
            // or if source is External & status is Under Contract & Listing/Buyer Agent 4 Firm is STRIVE
            if ((oldData.source === "STRIVE" && oldData.status === "Under Contract") ||
                (oldData.source === "External" && oldData.status === "Under Contract" &&
                    (oldData.listing_agent_4_firm === striveID || oldData.buyer_agent_4_firm === striveID))) {
                inEscrow = true;
            }
            // Add property to STRIVE Escrow Tracking
            if (inEscrow && oldData.arcimedes_row_id &&
                (!propertyInEscrow || !propertyInEscrow.arcimedes_row_id || propertyInEscrow.deleted === 1)) {
                let newData = {
                    property_id: parseInt(oldData.arcimedes_row_id),
                    task: `${oldData.name} - ${oldData.city || ""}, ${oldData.state || ""}`,
                    deleted: null,
                };
                if (propertyInEscrow && propertyInEscrow.arcimedes_row_id) {
                    newData = { ...newData, arcimedes_row_id: propertyInEscrow.arcimedes_row_id };
                }
                this.updatePropertyTracking(newData, STRIVE_ESCROW_TRACKING_UPDATE, token);
            }

            // Update property info in STRIVE Escrow Tracking
            if (propertyInEscrow && propertyInEscrow.arcimedes_row_id && propertyInEscrow.deleted !== "1" && oldData.arcimedes_row_id &&
                (data.hasOwnProperty("name") || data.hasOwnProperty("city") || data.hasOwnProperty("state"))) {
                const original = this.state.original;
                const newData = CRUDProperty.updatePropertyData({ data, oldData, original });
                this.updatePropertyTracking({ ...newData, arcimedes_row_id: propertyInEscrow.arcimedes_row_id }, STRIVE_ESCROW_TRACKING_UPDATE, token);
            }

            // Remove property from STRIVE Escrow Tracking
            if ((!inEscrow && propertyInEscrow && propertyInEscrow.arcimedes_row_id && propertyInEscrow.deleted !== "1")
                || oldData.deleted === 1) {
                let removeData = {
                    arcimedes_row_id: propertyInEscrow && propertyInEscrow.arcimedes_row_id,
                    property_id: parseInt(this.state.data.arcimedes_row_id),
                    deleted: "1",
                };
                const deleteEscrowRecords = {
                  title_company: null,
                  escrow_officer: null,
                  psa_sent_to_buyer: null,
                  psa_sent_to_buyer_checkbox: null,
                  have_all_due_diligence_materials: null,
                  effective_date: null,
                  effective_date_checkbox: null,
                  rofr_notice_sent_to_tenant: null,
                  rofr_notice_sent_to_tenant_checkbox: null,
                  rofr_waiver_sent_to_buyerside__title_co: null,
                  rofr_waiver_sent_to_buyerside__title_co_checkbox: null,
                  psa_sent_to_title: null,
                  psa_sent_to_title_checkbox: null,
                  survey_sent_to_title: null,
                  survey_sent_to_title_checkbox: null,
                  receipted_psa_received__sent_to_buyers_agent: null,
                  receipted_psa_received__sent_to_buyers_agent_checkbox: null,
                  dd_site_created__access_granted: null,
                  dd_site_created__access_granted_checkbox: null,
                  updated_db__istrive: null,
                  updated_to_uc_on_externals: null,
                  wiring_instructions_sent_to_buyeragent: null,
                  earnest_money_received: null,
                  earnest_money_received_checkbox: null,
                  has_title_approved_survey: null,
                  closing_date_checkbox: null,
                  closing_date: null,
                  closing_extension: null,
                  closing_period: null,
                  title_sent_out_closing_statements_for_review_checkbox: null,
                  title_sent_out_closing_statements_for_review: null,
                  update_insurance_certificates_checkbox: null,
                  update_insurance_certificates: null,
                  send_title_invoice_wire_cam_deposits_prorations_checkbox: null,
                  send_title_invoice_wire_cam_deposits_prorations: null,
                  verify_close_10_days_before_closing_checkbox: null,
                  verify_close_10_days_before_closing: null,
                  estoppelssdna_due_checkbox: null,
                  estoppelssdna_due: null,
                  estoppelsnda_requested_from_lender_buyer_or_tenant_checkbox: null,
                  estoppelsnda_requested_from_lender_buyer_or_tenant: null,
                  additional_earnest_money_received_checkbox: null,
                  additional_earnest_money_received: null,
                  financing_period_ends_checkbox: null,
                  financing_period_ends: null,
                  financing_approval_checkbox: null,
                  financing_approval: null,
                  feasibility_period_expires__deposit_nonrefundable_checkbox: null,
                  feasibility_period_expires__deposit_nonrefundable: null,
                  feasibility_extension: null,
                  feasibility_period: null,
                  financing_application_deadline_checkbox: null,
                  financing_application_deadline: null,
                  title_objection_period_checkbox: null,
                  title_objection_period: null,
                  seller_response_to_buyer_objections_checkbox: null,
                  seller_response_to_buyer_objections: null,
                  buyers_title_objections_due_checkbox: null,
                  buyers_title_objections_due: null,
                  received_title_commitment_checkbox: null,
                  received_title_commitment: null,
                  survey_ordered_checkbox: null,
                  survey_ordered: null,
                };
                if (isStatusActive) {
                    // Delete the escrow tracking data if the property status is modified to active
                    removeData = { ...removeData, ...deleteEscrowRecords }
                }    
                await this.updatePropertyTracking(removeData, STRIVE_ESCROW_TRACKING_UPDATE, token);
            }
    
        } catch (error) {
            console.error("Error in fetchEscrowData:", error);
        }
    }

    async fetchHscTrackingData(data,token) {
        let tracking = false;
        const property = await this.getPropertyHscTracking(this.state.data.arcimedes_row_id,token);
        
        const oldData = this.state.data;

        // Tracking if (source is HSC or is HSC financing) & status is Loan In Process
        if ((oldData.source === 'HSC' || oldData.hsc_financing) && oldData.hsc_status === 'Loan In Process') {
            tracking = true;
        }
        // Add property to HSC Tracking
        if (tracking && oldData.arcimedes_row_id &&
            (!property || !property.arcimedes_row_id || property.deleted == '1')) {
            let newData = {
                property_id: oldData.arcimedes_row_id && Number(oldData.arcimedes_row_id),
                task: `${oldData.name} - ${oldData.city ? oldData.city : ''}, ${oldData.state ? oldData.state : ''}`,
                deleted: null,
            };
            if(property && property.arcimedes_row_id){
                newData = {...newData, arcimedes_row_id: property.arcimedes_row_id}
            }
            this.updatePropertyTracking([newData], CREATE_OR_UPDATE_HSC_TRACKING,token);
        }

        // Update property info in HSC Tracking
        if (property && property.arcimedes_row_id && property.deleted !== '1' && oldData.arcimedes_row_id &&
            (data.hasOwnProperty('name') || data.hasOwnProperty('city') || data.hasOwnProperty('state'))) {
            const original = this.state.original;
            let newData = CRUDProperty.updatePropertyData({data, oldData, original});
            newData = {...newData, arcimedes_row_id: property.arcimedes_row_id, property_id: this.state.data.arcimedes_row_id && Number(this.state.data.arcimedes_row_id)}
            this.updatePropertyTracking([newData], CREATE_OR_UPDATE_HSC_TRACKING,token);
        }

        // Remove property from HSC Tracking
        if ((!tracking && property && property.arcimedes_row_id && property.deleted !== '1') || oldData.deleted === '1') {
            const data = [{
                arcimedes_row_id: property && property.arcimedes_row_id,
                property_id: this.state.data.arcimedes_row_id && Number(this.state.data.arcimedes_row_id),
                deleted: '1',
            }];
            this.updatePropertyTracking(data, CREATE_OR_UPDATE_HSC_TRACKING,token);
        }
    }
    async saveData(newData, showSaveAlert = true) {
        const loanQuotesDataCopy = [...(this.state.loanQuotesData || [])];
        //const loanQuotesDataCopy = [...this.state.loanQuotesData]
        if(loanQuotesDataCopy.length){
            loanQuotesDataCopy.forEach((data)=>{
                if (!data.arcimedes_row_id && !data.is_printable) {
                    data.autopopulate = 1;
                }
                else if(data.arcimedes_row_id && data.is_printable && data.autopopulate){
                    data.autopopulate = 0;
                }
            })
        }
        loanQuotesDataCopy.forEach((item) => {
          item.noi = newData && newData.net_operating_income; // This must be latest noi at this point
        });
        this.setState({loanQuotesData:loanQuotesDataCopy})
        const changedData = {...newData};
        const token = localStorage.getItem('authToken');
        if(Object.keys(changedData).length){
            for (let datafields in changedData) {
                const restricedFields = ["doors", 'office_to_warehouse', 'clear_height']
                if (restricedFields.includes(datafields)) {
                    delete changedData[datafields];
                }
            }
        }

        let data = {};
        const seller = {...this.state.seller};
        let lqData = convertLoanQuotesFormToData(this.state.loanQuotesData);
        let paymentsData = this.state.propertyPaymentsData ? convertPaymentsFormToData(this.state.propertyPaymentsData) : [];
        let deletedPaymentsData = this.state.deletedPaymentsData ? this.state.deletedPaymentsData : [];

        if (changedData) {
            data = convertFormToData(changedData);
        } else {
            data = convertFormToData(this.state.data);
        }       
                
         // Property Address Format
         data.address = formatAddress(data.address);
         data.address = data.address != null ? data.address.replace(/ *\([^)]*\) */g, ""): data.address;
         data.address = data.address != null ? data.address.replace('(', '') : data.address;
         data.address = data.address != null ? data.address.replace(')', '') : data.address;
         data.address = data.address != null ? data.address.replaceAll('.', ' ') : data.address;

         const res = await fetchData(GET_HOTLIST_PROPERTIES_BY_EMAIL, { email_id:this.context.userData.email});
         let hotListData = res.data.hotlistPropertiesByEmail.data[0];
         const propertyId = data.arcimedes_row_id;
         if(propertyId){
             if (data["hot_list"] === "1") {
                 if (hotListData && hotListData.hot_list_properties) {
                 let hotListProperties = hotListData.hot_list_properties
                    ? hotListData.hot_list_properties.split(",")
                    : [];

                 if (!hotListProperties.includes(String(propertyId))) {
                    hotListProperties.push(String(propertyId));
                 }     
                 const uniqueProperties = [...new Set(hotListProperties)];
                 data["hotlist_properties"] = uniqueProperties.length > 0 && uniqueProperties.join(",");                  
                    //  data["hotlist_properties"] = hotListProperties.length > 0 && hotListProperties.join(",");  
                    
                 } else {
                     data["hotlist_properties"] = String(propertyId); 
                 }
                  
             } 
             else if (data["hot_list"] === "0") {
                 if (hotListData && hotListData.hot_list_properties) {   
                    let hotListProperties = hotListData.hot_list_properties
                    ? hotListData.hot_list_properties.split(",")
                    : [];         
                     hotListProperties = hotListProperties.filter(id => id !== String(propertyId));                       
                    //  data["hotlist_properties"] = hotListProperties && hotListProperties.length > 0 ? hotListProperties.join(",") : "";
                    const uniqueProperties = [...new Set(hotListProperties)];
                    data["hotlist_properties"] = uniqueProperties.join(",");

                    // data["hotlist_properties"] = Array.isArray(hotListProperties) && hotListProperties.length > 0
                    //                                 ? hotListProperties.filter(item => item != null && item !== "").join(",")
                    //                                 : [];
                 }
             }
            data["hotlist_id"] =String(this.context.userData.id);  
            data["hotlist_name"] =this.context.userData.userName;  
            data["hotlist_email_id"] =this.context.userData.email;
         }else{
            data["hotlist_id"] =String(this.context.userData.id);  
             data["hotlist_name"] =this.context.userData.userName;  
             data["hotlist_email_id"] =this.context.userData.email; 


            if (hotListData && hotListData.hot_list_properties) {
                let hotListProperties = hotListData.hot_list_properties
                    ? hotListData.hot_list_properties.split(",")
                    : [];
                if(newData && newData.hot_list !== undefined && newData.hot_list !== null && newData["hot_list"] === "1"){
                    hotListProperties.push("first");
                    const uniqueProperties = [...new Set(hotListProperties)];
                    data["hotlist_properties"] = uniqueProperties.join(",");                   
                }else {
                    const uniqueProperties = [...new Set(hotListProperties)];
                    data["hotlist_properties"] = uniqueProperties.join(",");
                }
                    
             }else{
                data["hotlist_properties"] = newData && newData.hot_list !== undefined && newData.hot_list !== null && newData["hot_list"] === "1" ? "first" : "";
             } 
             //data["hotlist_properties"] = newData && newData.hot_list !== undefined && newData.hot_list !== null && newData["hot_list"] === "1" ? "first" : "";
         }
 

        if (this.state.currentUserFullname || this.state.currentUser) {
            data.last_modified_by = this.state.currentUserFullname || this.state.currentUser;
        }
        data.last_modified_date = new Date().toISOString().split("T")[0];

        if (this.state.original.status === 'Proposal'){
            data.proposal_date = new Date().toISOString().split("T")[0];
        } 

        if (this.state.original.close_of_escrow !== data.close_of_escrow) {
            try {
                paymentsData = await this.recomputePayments(data, paymentsData,token);
            } catch (e) {
                // A recompute failure must not block saving the property (e.g. delete/undelete)
                console.error('Failed to recompute payments:', e);
                this.setState({ recomputePayments: false });
            }
        }

        if (this.state.original.status !== data.status)
            this.setState({hasModifiedStatus: true});
        if (this.state.data.source === 'HSC' && (this.state.original.hsc_status !== data.hsc_status))
            this.setState({hasModifiedStatus: true});
        if ( data.hsc_approved === 'y')
            this.setState({isHscApproved: true});
        if (this.state.original.list_price !== data.list_price)
            this.setState({hasModifiedListPrice: true});
        if (this.state.original.list_price > data.list_price)
            this.setState({hasReducedListPrice: true});
        if(data.transaction_type === 'Referral' && this.state.original.close_of_escrow !== data.close_of_escrow && data.close_of_escrow){
            this.setState({isClosedReferral:true});
        }

        if (this.state.original.status === 'Proposal' && data.status === 'Property Info')
            data.property_info_since = new Date().toISOString().split('T')[0];
        if (this.state.original.status !== 'Off Market' && data.status === 'Off Market')
            data.off_market_since = new Date().toISOString().split('T')[0];

        if (["Active", "Closed"].includes(this.state.original["status"])
            && ["Under Contract", "In Negotiation"].includes(data["status"])) {
            data.under_contract_in_negotiation_since = new Date().toISOString().split("T")[0];
        } else if (["Under Contract", "In Negotiation"].includes(this.state.original["status"])
            && ["Active", "Closed"].includes(data["status"])
            && this.state.original.under_contract_in_negotiation_since
            && (data.listed_date || data.expiration_date)) {
            const lastModifiedDate = new Date(this.state.original.under_contract_in_negotiation_since);
            const today = new Date();

            // Calculate how many days a property spent in a status of 'Under Contract' or 'In Negotiation'
            const diffDays = Math.floor(Math.abs(today - lastModifiedDate) / (1000 * 60 * 60 * 24));

            if (data.listed_date) {
                const listingDate = new Date(data.listed_date);
                listingDate.setDate(listingDate.getDate() + diffDays);
                data.listed_date = listingDate.toISOString().split("T")[0];
            }

            if (data.expiration_date) {
                const expiringDate = new Date(data.expiration_date);
                expiringDate.setDate(expiringDate.getDate() + diffDays);
                data.expiration_date = expiringDate.toISOString().split("T")[0];
            }
        }
        if(data.hasOwnProperty('referral_fee') && data.referral_fee !== null && data.referral_fee !== undefined){
            data.referral_fee = String(data.referral_fee);
        }

        if (!data.is_listing && ["Active", "In Negotiation", "Under Contract", "Removed"].includes(data.status)) {
            data.is_listing = 1;
        }

        if (data.is_listing === "1" && ["Closed", "Off Market"].includes(data.status)) {
            data.is_listing = 0;
        }

        // #7221 adding proposed agent as listing 1 agent
        if (!this.props.edit && this.props.isSeniorAgent && newData.name && data.status === "Proposal" && data.source== 'STRIVE') {
            const currentUserFromList = this.state.agentList.filter(res => res.first_name + " " + res.last_name === this.state.currentUser);
            if (currentUserFromList.length) {
                data.listing_agent_1 = currentUserFromList[0].arcimedes_row_id;
                data.listing_agent_1_percent = '100.00'
            }
        }

        if (this.props.isSeniorAgent && data.status == 'Closed' && data.source== 'External'){
            if(!data.close_of_escrow && !this.state.openElscrowDialog){
               this.setState({openEscrowDialog: true});
               return;
            }
        }

        if (!data.was_proposal && data.status === "Proposal") {
            data.was_proposal = 1;
        }

        if (data.close_of_escrow && data.transaction_type === 'Referral')
            data.status = 'Closed';

        if (this.state.original.status !== data.status && data.status === 'Flagged') {
            data.flagged_date = new Date().toISOString().split("T")[0];
        }

        if(data.close_of_escrow){
            // handle validation of close of escrow date field
            const validDatePattern = /^(\d{2})\/(\d{2})\/(\d{4})$/;
            if((data.close_of_escrow.includes("/") || !data.close_of_escrow.includes("-"))&& !validDatePattern.test(data.close_of_escrow)){
                this.setState({openEscrowDateError: true});
                return;
            }
        }

        // Discard unchanged values
        Object.keys(data).forEach((key) => {
            if (this.state.original.hasOwnProperty(key) && data[key] === this.state.original[key] || excludedKeys.includes(key))
                delete data[key];
        });
        Object.keys(seller).forEach((key) => {
            if (this.state.originalSeller.hasOwnProperty(key) && seller[key] === this.state.originalSeller[key])
                delete seller[key];
        });

        let lqDataArray = [];

if (lqData && Array.isArray(lqData)) {
    lqData.forEach(elem => {
        if (elem && typeof elem === 'object') {
            const cleanedElem = {};

            // Convert is_printable to 1 or 0
            if (elem.hasOwnProperty('is_printable')) {
                if (elem.is_printable === true) {
                    cleanedElem.is_printable = 1;
                } else {
                    cleanedElem.is_printable = 0;
                }
            } else {
                cleanedElem.is_printable = 0;
            }

            // Proceed only if modified or has row ID
            if (elem.loan_quotes_modified === true || elem.arcimedes_row_id) {
                // Handle property_id fallback
                if (!elem.property_id) {
                    if (this.state && this.state.data && this.state.data.arcimedes_row_id) {
                        cleanedElem.property_id = parseInt(this.state.data.arcimedes_row_id);
                    } else if (this.state && this.state.original && this.state.original.arcimedes_row_id) {
                        cleanedElem.property_id = parseInt(this.state.original.arcimedes_row_id);
                    } else if (this.props && this.props.params && this.props.params.id) {
                        cleanedElem.property_id = parseInt(this.props.params.id);
                    }
                } else {
                    cleanedElem.property_id = elem.property_id;
                }

                // Set ID fields (cast to string)
                if (elem.hasOwnProperty('arcimedes_row_id') && elem.arcimedes_row_id != null) {
                    cleanedElem.arcimedes_row_id = String(elem.arcimedes_row_id);
                }

                // String fields
                var stringFields = [
                    'loan_structure', 'purchase_price', 'down_payment_percent',
                    'interest_rate', 'loan_term', 'maturity', 'amortization',
                    'prepayment_penalty', 'cap_rate', 'noi', 'cash_on_cash', 'notes',
                    'dscr', 'bank', 'bank_contact', 'deleted', 'noi_percentage',
                    'recourse', 'total_origination_fee', 'arcimedes_created',
                    'arcimedes_created_by', 'arcimedes_modified', 'arcimedes_modified_by'
                ];

                for (var i = 0; i < stringFields.length; i++) {
                    var key = stringFields[i];
                    if(elem[key] == null){
                        cleanedElem[key] = null;
                    }
                    else if (elem.hasOwnProperty(key)) {
                        cleanedElem[key] = String(elem[key]);
                    }
                }

                // Float fields
                var floatFields = ['down_payment', 'loan_amount', 'loan_payment_annually', 'noi_multiplied', 'debt_yield'];
                for (var j = 0; j < floatFields.length; j++) {
                    var fKey = floatFields[j];
                    if(elem[fKey] == null){
                        cleanedElem[fKey] = null;
                    }
                    else if (elem.hasOwnProperty(fKey) && !isNaN(parseFloat(elem[fKey]))) {
                        cleanedElem[fKey] = parseFloat(elem[fKey]);
                    }
                }

                // Int fields
                var intFields = ['cash_flow_monthly', 'cash_flow_annually', 'print_page_number', 'autopopulate', 'loan_quotes_order'];
                for (var k = 0; k < intFields.length; k++) {
                    var iKey = intFields[k];
                    if(elem[iKey] == null){
                        cleanedElem[iKey] = null;
                    }
                    else if (elem.hasOwnProperty(iKey) && !isNaN(parseInt(elem[iKey]))) {
                        cleanedElem[iKey] = parseInt(elem[iKey]);
                    }
                }

                lqDataArray.push(cleanedElem);
            }
            if (!this.props.edit) {
              lqDataArray.push(cleanedElem);
            }
       
        }
    });
}

        


        let paymentsDataArray = [];
        if(this.state.original.transaction_type === 'Extra Payment' && paymentsData){
            if(paymentsData && paymentsData[0] && paymentsData[0].arcimedes_row_id && paymentsData[0].arcimedes_row_id.trim() !== ''){
                paymentsData[0].payment_modified = true,
                paymentsData[0].strive_team_member_id = this.state.original.listing_agent_1;
                paymentsData[0].strive_team_member_percent = this.state.original.listing_agent_1_percent;
                paymentsData[0].strive_team_member_net_fee = parseFloat(data.net_fee.replace(/,/g, '')).toString();
                paymentsData[0].strive_team_member_net_percent = data.tranche.toString();
                paymentsData[0].strive_team_member_gross_fee = parseFloat(data.referral_fee.replace(/,/g, '')).toString();           
            }else{
                const extraPaymentPaymentData = new Array({
                    property_id:paymentsData[0].property_id,
                    payment_modified:true,
                    strive_team_member_id:this.state.original.listing_agent_1,
                    strive_team_member_percent:this.state.original.listing_agent_1_percent,
                    strive_team_member_net_fee:parseFloat(data.net_fee.replace(/,/g, '')).toString(),
                    strive_team_member_net_percent:data.tranche.toString(),
                    strive_team_member_gross_fee:this.state.original.referral_fee
                });
                    paymentsData = [...extraPaymentPaymentData];
            }            
        }
        paymentsData.forEach(elem => {
            if (elem.payment_modified === true) {
                delete elem.payment_modified;
                delete elem.__typename;
                delete elem.arcimedes_modified
                delete elem.arcimedes_created
                delete elem.arcimedes_created_by
                delete elem.arcimedes_modified_by
                elem.deleted = null
                elem.property_id = parseInt(elem.property_id);
                paymentsDataArray.push(elem);
            }
        });
        deletedPaymentsData.forEach(elem => {
            if (elem.arcimedes_row_id)
                paymentsDataArray.push(elem);
        });
        this.setState({referringAgentData: {
            referring_listing_agent: data.REFERRING_LISTING_AGENT,
            referring_listing_agent_percent: data.REFERRING_LISTING_AGENT_PERCENT, 
            referring_listing_agent_firm: data.REFERRING_LISTING_AGENT_FIRM, 
            referring_buyer_agent: data.REFERRING_BUYER_AGENT, 
            referring_buyer_agent_percent: data.REFERRING_BUYER_AGENT_PERCENT, 
            referring_buyer_agent_firm: data.REFERRING_BUYER_AGENT_FIRM}});

        // No changes detected, nothing to do
        if (!Object.keys(data).length && !Object.keys(seller).length && !lqDataArray.length && !paymentsData.length) {
            this.setState({
                isBusy: null,
                error: null,
                success: "No data to update",
            });
            window.scrollTo(0, 0);
            return;
        }

        this.setState({
            isBusy: true,
            error: null,
            success: null,
        });
        const isExtraPayment = this.state.data && this.state.data.transaction_type === 'Extra Payment';
        if(isExtraPayment){
            await this.calculateGrossAmount();   
            data.status = 'Closed'       
        }
        // await this.fetchEscrowData(data,token);
        // await this.fetchHscTrackingData(data,token);

        if (this.props.params.id) {
            data.arcimedes_row_id = this.props.params.id;
        } else {
            if (this.state.newPropertyId) {
                data.arcimedes_row_id = this.state.newPropertyId;
            }
        } 
        
        if(data.arcimedes_row_id != null || data.arcimedes_row_id != undefined){
            await this.fetchEscrowData(data,token);
            await this.fetchHscTrackingData(data,token);
        }
        

        if(data.hasOwnProperty('price_psf')){
            delete data.price_psf
        }
        // Underwriting-only fields copied over by the single tenant financials popup; not part of PropertyInput
        delete data.appraised_value;
        delete data.original_lease_term;
        if(data.hasOwnProperty('net_fee')){
            delete data.net_fee
        }
        const numberToStringKeys = [
          "lender_id",
          "referred_by_id",
          "cash_on_cash",
          "hsc_team_member_1_net_percent",
          "hsc_team_member_2_net_percent",
          "tenant_id",
          "proforma_noi",
          "seller_id",
          "lot_size",
          "parking_spaces"
        ];
        const stringToNumberKeys = ["amortization", "term","buyer_agent_4_firm","listing_agent_1","listing_agent_2","listing_agent_4_firm","referring_listing_agent","referring_listing_agent_firm","referring_buyer_agent_firm","referring_buyer_agent"];  //proforma_noi dont add this its failing in payment tab

        numberToStringKeys.forEach((key) => {
          if (data[key] && typeof data[key] === "number") {
            data[key] = data[key].toString();
          }
        });

        stringToNumberKeys.forEach((key) => {
          if (data[key] && typeof data[key] === "string") {
            data[key] = Math.round(parseFloat(data[key]));
          }
        });
if (data.hsc_team_member_1_net_percent === 0 && typeof data.hsc_team_member_1_net_percent === 'number') {
    data.hsc_team_member_1_net_percent = "0";
}

if (data.hsc_team_member_2_net_percent === 0 && typeof data.hsc_team_member_2_net_percent === 'number') {
    data.hsc_team_member_2_net_percent = "0";
}
        //delete data.source;
        // delete data.last_modified_by;
        delete data.last_modified_date;
        delete data.date_created;

        data.vacancy = parseInt(data.vacancy);
        data.negotiation_cap_rate = parseFloat(data.negotiation_cap_rate);
        delete data.arcimedes_modified;
        delete data.starting_date;
        delete data.lease_commencement;
        delete data.lease_expiration;
        delete data.arcimedes_created;
        delete data.__typename;
        delete data.arcimedes_created_by;
        delete data.arcimedes_modified_by;
        delete data.agent_1_last_name;
        delete data.agent_1_first_name;
        delete data.agent_2_last_name;
        delete data.agent_2_first_name;
        delete data.agent_3_last_name;
        delete data.agent_3_first_name;
        delete data.agent_4_last_name;
        delete data.agent_4_first_name;
        delete data.sellers_first_name;
        delete data.sellers_last_name;
        delete data.lender_name;
        delete data.hot_list;
        delete data.tranche;
        delete data.propertyPaymentsData;
        delete data.loanQuotesData;
        data.proforma_base_rent = data.proforma_base_rent && data.proforma_base_rent.toString();
        data.proforma_cap_rate = data.proforma_cap_rate && data.proforma_cap_rate.toString();

        if (data.capitalization_rate && typeof data.capitalization_rate === 'number') {
            data.capitalization_rate = data.capitalization_rate.toString();
        }

        // Auto-calculated when status flips to Closed, so it can arrive as a number
        if (typeof data.close_cap_rate === 'number') {
            data.close_cap_rate = data.close_cap_rate.toString();
        }

        // if (data.proforma_noi && typeof data.proforma_noi === 'string') {
        //     data.proforma_noi = parseInt(data.proforma_noi);
        // } dont add this above code we want in string in above we have change the proforma_noi data type
        if (paymentsDataArray.length > 0) {
            paymentsDataArray.forEach(payment => {
                // Convert strive_team_member_id to number
                payment.strive_team_member_id = Number(payment.strive_team_member_id);
        
                // Convert 'deleted' to number if it exists
                if (payment.hasOwnProperty('deleted')) {
                    payment.deleted = payment.deleted == null ? null : Number(payment.deleted);
                }
        
                // Remove __typename if it exists
                if (payment.hasOwnProperty('__typename')) {
                    delete payment.__typename;
                }
            });
        }
        lqDataArray.forEach(item => {
            delete item.arcimedes_created;
            delete item.arcimedes_modified;

            item.loan_amount = item.loan_amount !== undefined && item.loan_amount !== null
                ? item.loan_amount.toString()
                : null;

        });
        
        if (!this.props.edit && !this.props.params.id) {
            return mutateData(PROPERTIES_MUTATION,{
                input: [{ ...data,deleted: this.state.data.deleted && Number(this.state.data.deleted) === 1 ? 1: null,  strengths: undefined, buyer_pool: undefined, challenges: undefined, qualifications: undefined, recommendations: undefined }],
            }).then((propertyRes) => {
                const newPropertyId = propertyRes.data.createOrUpdateProperty.data[0].arcimedes_row_id;
                const proposalInput = {
                    strengths: this.state.proposalData.strengths,
                    recommendations: this.state.proposalData.recommendations,
                    qualifications: this.state.proposalData.qualifications,
                    buyer_pool: this.state.proposalData.buyer_pool,
                    challenges: this.state.proposalData.challenges,
                    lease_expiration_date: undefined,
                    property_id: newPropertyId
                };
                
                if (this.state.proposalData.arcimedes_row_id) {
                    proposalInput.arcimedes_row_id = this.state.proposalData.arcimedes_row_id;
                }
                
                const promiseArray = [
                    propertyRes, 
                    mutateData(PROPOSAL_MUTATION,{ input:[proposalInput] }),
                    Object.keys(seller).length &&
                    mutateData(CREATE_OR_UPDATE_CONTACTS_INVESTORS,{
                        input: {
                            contact_id: this.state.data.seller_id,
                            contact_type: "Investor",
                            ...Object.keys(seller).reduce((acc, key) => {
                                acc[key.toLowerCase()] = seller[key];
                                return acc;
                            }, {})
                        }
                    }),
                    lqDataArray.length && 
                    mutateData(HSC_LOAN_QUOTES_MUTATION,{input:lqDataArray.map(lq => ({...lq, property_id: parseInt(newPropertyId)})) }),
                    paymentsDataArray.length &&
                    mutateData(PROPERTY_PAYMENT_TEAM_MUTATION,{input:paymentsDataArray.map(p => ({...p, property_id: parseInt(newPropertyId)})) }),
                ];
                
                return Promise.all(promiseArray).then((res) => {
                    this.setState((prevState) => {
                        const updatedData = convertDataToForm(res[0].data.createOrUpdateProperty.data[0]);
                        if (res[1] && res[1].data && res[1].data.createOrUpdateProposal && res[1].data.createOrUpdateProposal.data) {
                            const proposalData = res[1].data.createOrUpdateProposal.data;
                            updatedData.strengths = proposalData.strengths;
                            updatedData.challenges = proposalData.challenges;
                            updatedData.recommendations = proposalData.recommendations;
                            updatedData.qualifications = proposalData.qualifications;
                            updatedData.buyer_pool = proposalData.buyer_pool;
                        }
                        
                        return {
                            isBusy: null,
                            success: showSaveAlert ? "Saved" : null,
                            data: updatedData,
                            original: {...res[0].data.createOrUpdateProperty.data[0]},
                            newPropertyId: null,
                        };
                    }, () => {
                       const newPropId = res[0].data.createOrUpdateProperty.data[0].arcimedes_row_id;
                        if(lqDataArray && lqDataArray.length && lqDataArray.length > 0){
                            const updatedLqData = lqDataArray.map((lq)=>(
                                {
                                    ...lq,
                                    property_id: parseInt(newPropId)
                                }
                            ))
                            mutateData(HSC_LOAN_QUOTES_MUTATION,{input:updatedLqData }).then(()=>{
                                browserHistory.push({pathname: `/property/${newPropId}`});
                            })
                        }else{
                            browserHistory.push({pathname: `/property/${newPropId}`});
                        }
                        window.scrollTo(0, 0);
                    });
                });
            });
        }
        
        return Promise.all([
            // manageData({ --0
            //     tableCode: PROPERTIES,
            //     data: [{...data, STRENGTHS: undefined, BUYER_POOL: undefined, CHALLENGES: undefined, QUALIFICATIONS: undefined, RECOMMENDATIONS: undefined}],
            // }),
            // this.client.mutate({
            //     mutation: PROPERTIES_MUTATION,
            //     variables: {
            //         input: [{ ...data,deleted: this.state.data.deleted && Number(this.state.data.deleted) === 1 ? 1: null,  strengths: undefined, buyer_pool: undefined, challenges: undefined, qualifications: undefined, recommendations: undefined }],
            //     },
            //     fetchPolicy: "no-cache",
            //     context: { 
            //       headers: {
            //         authorization: `Bearer ${token}`,
            //       },
            //     }
            // }),
            mutateData(PROPERTIES_MUTATION,{
                input: [{ ...data,deleted: this.state.data.deleted && Number(this.state.data.deleted) === 1 ? 1: null,  strengths: undefined, buyer_pool: undefined, challenges: undefined, qualifications: undefined, recommendations: undefined }],
            }),
            // manageData({ --1
            //     tableCode: PROPOSAL,
            //     data: [{...this.state.proposalData, LEASE_EXPIRATION_DATE: undefined, PROPERTY_ID: data.ARCIMEDES_ROW_ID, ARCIMEDES_ROW_ID: this.state.proposalData.ARCIMEDES_ROW_ID}],
            // }),
            // this.client.mutate({
            //     mutation:PROPOSAL_MUTATION, 
            //     variables: {
            //         input:[{strengths:data.strengths,recommendations:data.recommendations , qualifications:data.qualifications ,buyer_pool:data.buyer_pool , challenges:data.challenges, lease_expiration_date: undefined, property_id: data.arcimedes_row_id, arcimedes_row_id: this.state.proposalData.arcimedes_row_id}]
            //     },
            //     fetchPolicy: "no-cache",
            //     context: {
            //       headers: {
            //         authorization: `Bearer ${token}`,
            //       },
            //     }
            // }),
            mutateData(PROPOSAL_MUTATION,{
                input:[{strengths:this.state.proposalData.strengths,recommendations:this.state.proposalData.recommendations , qualifications:this.state.proposalData.qualifications ,buyer_pool:this.state.proposalData.buyer_pool , challenges:this.state.proposalData.challenges, lease_expiration_date: undefined, property_id: data.arcimedes_row_id, arcimedes_row_id: this.state.proposalData.arcimedes_row_id}]
            }),
            this.props.edit && Object.keys(seller).length &&
            // manageData({ --2
            //     tableCode: SELLERS,
            //     data: [{
            //         ARCIMEDES_ROW_ID: this.state.data.SELLER_ID,
            //         ...seller,
            //     }],
            // }),
            // this.client.mutate({
            //     mutation:SELLERS_MUTATION, 
            //     // variables: {
            //     //     input:{ARCIMEDES_ROW_ID: this.state.data.seller_id, ...seller}naveen
            //     // },
            //     variables: {
            //         input: {
            //             ARCIMEDES_ROW_ID: this.state.data.seller_id,
            //             ...Object.keys(seller).reduce((acc, key) => {
            //                 acc[key.toUpperCase()] = seller[key];
            //                 return acc;
            //             }, {})
            //         }
            //     },
            //     fetchPolicy: "no-cache",
            //     context: {
            //       headers: {
            //         authorization: `Bearer ${token}`,
            //       },
            //     }
            // }),
            // mutateData(SELLERS_MUTATION,{
            //     input: {
            //         ARCIMEDES_ROW_ID: this.state.data.seller_id,
            //         ...Object.keys(seller).reduce((acc, key) => {
            //             acc[key.toUpperCase()] = seller[key];
            //             return acc;
            //         }, {})
            //     }
            // }),
            mutateData(CREATE_OR_UPDATE_CONTACTS_INVESTORS,{
                input: {
                    contact_id: this.state.data.seller_id,
                    contact_type: "Investor",
                    ...Object.keys(seller).reduce((acc, key) => {
                        acc[key.toLowerCase()] = seller[key];
                        return acc;
                    }, {})
                }
            }),
            this.props.edit && lqDataArray.length && 
            mutateData(HSC_LOAN_QUOTES_MUTATION,{input:lqDataArray }),
            data.arcimedes_row_id &&
            // getData({ --4
            //     tableCode: HSC_LOAN_QUOTES,
            //     options: {
            //         filter: [
            //             {
            //                 text: data.ARCIMEDES_ROW_ID,
            //                 code: "PROPERTY_ID",
            //                 type: "exact",
            //             },
            //         ],
            //     },
            // }),
            // this.client.query({
            //     query: GET_HSC_LOAN_QUOTES, variables: { propertyId: data.arcimedes_row_id },
            //     fetchPolicy: "no-cache",
            //     context: {
            //       headers: {
            //         authorization: `Bearer ${token}`,
            //       },
            //     }
            // }),
            fetchData(GET_HSC_LOAN_QUOTES,{ propertyId: data.arcimedes_row_id }),
            this.props.edit && paymentsDataArray.length &&
            // manageData({ --5
            //     tableCode: PROPERTY_PAYMENT_TEAM,
            //     data: paymentsDataArray,
            // }),
            // this.client.mutate({
            //     mutation:PROPERTY_PAYMENT_TEAM_MUTATION, 
            //     variables: {
            //         input:{paymentsDataArray}
            //     },
            //     fetchPolicy: "no-cache",
            //     context: {
            //       headers: {
            //         authorization: `Bearer ${token}`,
            //       },
            //     }
            // }),
            mutateData(PROPERTY_PAYMENT_TEAM_MUTATION,{input:paymentsDataArray}),
            this.props.edit && paymentsDataArray.length &&
            // getData({ --6
            //     tableCode: PROPERTY_PAYMENT_TEAM,
            //     options: {
            //         filter: [
            //             {
            //                 text: data.ARCIMEDES_ROW_ID,
            //                 code: "PROPERTY_ID",
            //                 type: "exact",
            //             },
            //         ],
            //     },
            // }),
            // this.client.query({
            //     query: GET_PROPERTY_PAYMENT_TEAM, variables: { propertyId: data.arcimedes_row_id },
            //     fetchPolicy: "no-cache",
            //     context: {
            //       headers: {
            //         authorization: `Bearer ${token}`,
            //       },
            //     }
            // }),
            fetchData(GET_PROPERTY_PAYMENT_TEAM,{ propertyId: data.arcimedes_row_id }),
        ]).then((res) => {
            if(this.state.propertyNotesData && this.state.propertyNotesData.length > 0){
            this.handlePropertyNotesUpdate(res)
            }
            let paymentsData;
            paymentsData = res && res[5] && res[5].data && res[5].data.createOrUpdatePropertyPaymentTeam.success ? convertPaymentsDataToForm(res[5].data.createOrUpdatePropertyPaymentTeam, res[0].data.createOrUpdateProperty.data[0].arcimedes_row_id, res[0].data.createOrUpdateProperty.data[0].transaction_type==='Referral') : this.state.propertyPaymentsData;
            //if (res && res[0] && res[0].success && res[1] && res[1].success && res[2] && res[2].success) {

          if (res && res[0] && res[0].data.createOrUpdateProperty.success && res[1] && res[1].data.createOrUpdateProposal.success && res[2] && res[2].data.createOrUpdateContact.success) {
                // changes in both property & seller
                this.setState((prevState) => ({
                    isBusy: null,
                    success: showSaveAlert ? "Saved" : null,
                    propertyPaymentsData: paymentsData,
                    previousData: prevState.original,
                    data: convertDataToForm(res[0].data.createOrUpdateProperty.data[0]),
                    original: {...res[0].data.createOrUpdateProperty.data[0]},
                    // loanQuotesData: convertLoanQuotesDataToForm(res[2].data, res[0].data[0]),
                    // originalLoanQuotesData: convertLoanQuotesDataToForm(res[2].data, res[0].data[0]),
                    // seller: {...res[2].data[0]},
                    // originalSeller: {...res[2].data[0]},
                    loanQuotesData: convertLoanQuotesDataToForm([res[2].data.createOrUpdateContact.contact], res[0].data.createOrUpdateProperty.data[0]),
                    originalLoanQuotesData: convertLoanQuotesDataToForm([res[2].data.createOrUpdateContact.contact], res[0].data.createOrUpdateProperty.data[0]),
                    seller: {...res[2].data.createOrUpdateContact.contact},
                    originalSeller: {...res[2].data.createOrUpdateContact.contact},
                    newPropertyId: null,
                }), () => {
                    if (!this.props.edit) {
                        // redirect from add
                        if(lqDataArray && lqDataArray.length && lqDataArray.length > 0){
                            lqDataArray = lqDataArray.map((lq)=>(
                                {
                                    ...lq,
                                    property_id: parseInt(res[0].data.createOrUpdateProperty.data[0].arcimedes_row_id)
                                }
                            ))
                            mutateData(HSC_LOAN_QUOTES_MUTATION,{input:lqDataArray }).then(()=>{
                                browserHistory.push({pathname: `/property/${res[0].data.createOrUpdateProperty.data[0].arcimedes_row_id}`});
                            })
                        }else{
                            browserHistory.push({pathname: `/property/${res[0].data.createOrUpdateProperty.data[0].arcimedes_row_id}`});
                        }
                    }
                    window.scrollTo(0, 0);
                });
           // } else if (res && res[0] && res[0].success && res[1] && res[1].success && res[2] && res[2].success) {

            } else if (res && res[0] && res[0].data.createOrUpdateProperty.success && res[1] && res[1].data.createOrUpdateProposal.success && res[2] && res[2].data.createOrUpdateContact.success) {
                // changes in both property & seller
                this.setState((prevState) => ({
                    isBusy: null,
                    success: showSaveAlert ? "Saved" : null,
                    propertyPaymentsData: paymentsData,
                    previousData: prevState.original,
                    data: convertDataToForm(res[0].data.createOrUpdateProperty.data[0]),
                    original: {...res[0].data.createOrUpdateProperty.data[0]},
                    // seller: {...res[2].data[0]},
                    // originalSeller: {...res[2].data[0]},
                    seller: {...res[2].data.createOrUpdateContact.contact},
                    originalSeller: {...res[2].data.createOrUpdateContact.contact},
                    newPropertyId: null,
                }), () => {
                    if (!this.props.edit) {
                            // redirect from add
                            if(lqDataArray && lqDataArray.length && lqDataArray.length > 0){
                                lqDataArray = lqDataArray.map((lq)=>(
                                    {
                                        ...lq,
                                        property_id: parseInt(res[0].data.createOrUpdateProperty.data[0].arcimedes_row_id)
                                    }
                                ))
                                mutateData(HSC_LOAN_QUOTES_MUTATION,{input:lqDataArray }).then(()=>{
                                    browserHistory.push({pathname: `/property/${res[0].data.createOrUpdateProperty.data[0].arcimedes_row_id}`});
                                })
                            }else{
                                browserHistory.push({pathname: `/property/${res[0].data.createOrUpdateProperty.data[0].arcimedes_row_id}`});
                            }
                        }
                    window.scrollTo(0, 0);
                });
            } else if (res && res[0] && res[0].data.createOrUpdateProperty.success && res[2] && res[2].data.createOrUpdateContact.success) {
                // changes in both property & loan quotes
                this.setState((prevState) => ({
                    isBusy: null,
                    success: showSaveAlert ? "Saved" : null,
                    propertyPaymentsData: paymentsData,
                    previousData: prevState.original,
                    data: convertDataToForm(res[0].data.createOrUpdateProperty.data[0]),
                    original: {...res[0].data.createOrUpdateProperty.data[0]},
                    loanQuotesData: convertLoanQuotesDataToForm([res[2].data.createOrUpdateContact.contact], res[0].data.createOrUpdateProperty.data[0]),
                    originalLoanQuotesData: convertLoanQuotesDataToForm([res[2].data.createOrUpdateContact.contact], res[0].data.createOrUpdateProperty.data[0]),
                    newPropertyId: null,
                }), () => {
                    if (!this.props.edit) {
                        // redirect from add
                        if(lqDataArray && lqDataArray.length && lqDataArray.length > 0){
                            lqDataArray = lqDataArray.map((lq)=>(
                                {
                                    ...lq,
                                    property_id: parseInt(res[0].data.createOrUpdateProperty.data[0].arcimedes_row_id)
                                }
                            ))
                            mutateData(HSC_LOAN_QUOTES_MUTATION,{input:lqDataArray }).then(()=>{
                                browserHistory.push({pathname: `/property/${res[0].data.createOrUpdateProperty.data[0].arcimedes_row_id}`});
                            })
                        }else{
                            browserHistory.push({pathname: `/property/${res[0].data.createOrUpdateProperty.data[0].arcimedes_row_id}`});
                        }
                    }
                    window.scrollTo(0, 0);
                });
            } else if (res && res[1] && res[1].data.createOrUpdateProposal.success && res[2] && res[2].data.createOrUpdateContact.success) {
                // changes in seller & loan quotes
                const data = {...this.state.data};
                this.setState(() => ({
                    isBusy: null,
                    success: showSaveAlert ? "Saved" : null,
                    loanQuotesData: convertLoanQuotesDataToForm([res[2].data.createOrUpdateContact.contact], data),
                    originalLoanQuotesData: convertLoanQuotesDataToForm([res[2].data.createOrUpdateContact.contact], data),
                    seller: {...res[2].data.createOrUpdateContact.contact},
                    originalSeller: {...res[2].data.createOrUpdateContact.contact},
                    newPropertyId: null,
                }), () => {
                    if (!this.props.edit) {
                        // redirect from add
                        if(lqDataArray && lqDataArray.length && lqDataArray.length > 0){
                            lqDataArray = lqDataArray.map((lq)=>(
                                {
                                    ...lq,
                                    property_id: parseInt(res[0].data.createOrUpdateProperty.data[0].arcimedes_row_id)
                                }
                            ))
                            mutateData(HSC_LOAN_QUOTES_MUTATION,{input:lqDataArray }).then(()=>{
                                browserHistory.push({pathname: `/property/${res[0].data.createOrUpdateProperty.data[0].arcimedes_row_id}`});
                            })
                        }else{
                            browserHistory.push({pathname: `/property/${res[0].data.createOrUpdateProperty.data[0].arcimedes_row_id}`});
                        }
                    }
                    window.scrollTo(0, 0);
                });
            } else if (res && res[0] && res[0].data.createOrUpdateProperty.success) {
                // changes in property
                this.setState((prevState) => ({
                    isBusy: null,
                    success: showSaveAlert ? "Saved" : null,
                    propertyPaymentsData: paymentsData,
                    previousData: prevState.original,
                    data: convertDataToForm(res[0].data.createOrUpdateProperty.data[0]),
                    original: {...res[0].data.createOrUpdateProperty.data[0]},
                    newPropertyId: null,
                }), () => {
                    if (!this.props.edit) {
                        // redirect from add
                        if(lqDataArray && lqDataArray.length && lqDataArray.length > 0){
                            lqDataArray = lqDataArray.map((lq)=>(
                                {
                                    ...lq,
                                    property_id: parseInt(res[0].data.createOrUpdateProperty.data[0].arcimedes_row_id)
                                }
                            ))
                            mutateData(HSC_LOAN_QUOTES_MUTATION,{input:lqDataArray }).then(()=>{
                                browserHistory.push({pathname: `/property/${res[0].data.createOrUpdateProperty.data[0].arcimedes_row_id}`});
                            })
                        }else{
                            browserHistory.push({pathname: `/property/${res[0].data.createOrUpdateProperty.data[0].arcimedes_row_id}`});
                        }
                    }
                    // else {
                    //     // new seller selected, get seller data
                    //     res[0].data.createOrUpdateProperty.data[0].seller_id && this.state.sellerSelected && this.fetchSeller();
                    // }
                    else if (
                        res &&
                        res[0] &&
                        res[0].data &&
                        res[0].data.createOrUpdateProperty &&
                        res[0].data.createOrUpdateProperty.data &&
                        res[0].data.createOrUpdateProperty.data[0] &&
                        res[0].data.createOrUpdateProperty.data[0].seller_id &&
                        this.state.sellerSelected
                      ) {
                        this.fetchSeller();
                      }
                    window.scrollTo(0, 0);
                });
            } else if (res && res[2] && res[2].data.createOrUpdateContact.success) {
                // changes in seller
                this.setState(() => ({
                    isBusy: null,
                    success: showSaveAlert ? "Saved" : null,
                    seller: {...res[2].data.createOrUpdateContact.contact},
                    originalSeller: {...res[2].data.createOrUpdateContact.contact},
                    newPropertyId: null,
                }), () => {
                    if (!this.props.edit) {
                        // redirect from add
                        if(lqDataArray && lqDataArray.length && lqDataArray.length > 0){
                            lqDataArray = lqDataArray.map((lq)=>(
                                {
                                    ...lq,
                                    property_id: parseInt(res[0].data.createOrUpdateProperty.data[0].arcimedes_row_id)
                                }
                            ))
                            mutateData(HSC_LOAN_QUOTES_MUTATION,{input:lqDataArray }).then(()=>{
                                browserHistory.push({pathname: `/property/${res[0].data.createOrUpdateProperty.data[0].arcimedes_row_id}`});
                            })
                        }else{
                            browserHistory.push({pathname: `/property/${res[0].data.createOrUpdateProperty.data[0].arcimedes_row_id}`});
                        }
                    }
                    window.scrollTo(0, 0);
                });
            } else if (res && res[2] && res[2].data.createOrUpdateContact.success) {
                // changes in loan quotes
                const data = {...this.state.data}
                this.setState(() => ({
                    isBusy: null,
                    success: showSaveAlert ? "Saved" : null,
                    loanQuotesData: convertLoanQuotesDataToForm(res[3].data, data),
                    originalLoanQuotesData: convertLoanQuotesDataToForm(res[3].data, data)
                }));
            } else {
                this.setState({
                    isBusy: null,
                    // error: res[2] && res[2].message ? res[2].message : "Unspecified error",
                    error: res[2] && res[2].data.createOrUpdateContact.message ? res[2].data.createOrUpdateContact.message : "Unspecified error",
                });
            }
            if(res && res[3] && res[3].data && res[3].data.createOrUpdateHscLoanQuote.data.length && res[3].data.createOrUpdateHscLoanQuote.data[0].hasOwnProperty('loan_structure')){
                // changes in loan quotes
                const data = {...this.state.data}
                this.setState(() => ({
                    loanQuotesData: convertLoanQuotesDataToForm(res[3].data.createOrUpdateHscLoanQuote.data, data),
                    originalLoanQuotesData: convertLoanQuotesDataToForm(res[3].data.createOrUpdateHscLoanQuote.data, data)
                }));
            }

            const link = res[0].data.createOrUpdateProperty.success ?
                res[0].data.createOrUpdateProperty.data[0].source === 'HSC' ?
                    `${url}list?name=${res[0].data.createOrUpdateProperty.data[0].name}&source=${res[0].data.createOrUpdateProperty.data[0].source}&address=${res[0].data.createOrUpdateProperty.data[0].address}&hsc_status=${res[0].data.createOrUpdateProperty.data[0].hsc_status}&transaction_type=${res[0].data.createOrUpdateProperty.data[0].transaction_type}`
                    :
                    `${url}list?name=${res[0].data.createOrUpdateProperty.data[0].name}&source=${res[0].data.createOrUpdateProperty.data[0].source}&address=${res[0].data.createOrUpdateProperty.data[0].address}&status=${res[0].data.createOrUpdateProperty.data[0].status}&transaction_type=${res[0].data.createOrUpdateProperty.data[0].transaction_type}`
                : '';

            return {
                success: res[0].data.createOrUpdateProperty.success,
                property: {
                    ...res[0].data.createOrUpdateProperty.data[0],
                    LINK: link
                },
            };
        }).then(async (res) => {
            if (!this.props.params.id) {
                this.fetchEscrowData(res.property,token);
                this.fetchHscTrackingData(res.property,token);
            }

            if (res.success) {
                const previousStatus = this.state.previousData.status ? this.state.previousData.status : null;
                this.checkHistoryAndSave(res.property.status, previousStatus,token);
                // send the Just Closed email only if there is a difference of less than 6 months between today and Close of Escrow
                const closeOfEscrow = new Date(res.property.close_of_escrow);
                const today = new Date();
                const sixMonthsToMillis = 6 * 30 * 24 * 60 * 60 * 1000;
                const hscDataModified = (((moment(res.property.loan_closing_date).format('MM/DD/YYYY')) !== (moment(this.state.original.loan_closing_date).format('MM/DD/YYYY'))) || (this.state.original.hsc_approved !== res.property.hsc_approved))
                const vacantLeaseType = res.property.hasOwnProperty('lease_type') && res.property.lease_type === 'Vacant'
                if (this.state.hasModifiedStatus && res.property.source === "STRIVE" && res.property.status === "Active" && ["Property Info", "Proposal", ""].includes(previousStatus)
                    || this.state.hasModifiedStatus && (res.property.source === "STRIVE" || res.property.buyer_agent_4_firm == "34" && res.property.source === "External") && res.property.status === "Closed" && today - closeOfEscrow < sixMonthsToMillis) {
                    sendEmailNotification({ data: res.property, type: 'just-listed-closed-email' })
                }
                if (this.state.hasModifiedStatus && res.property.source === "STRIVE" && ["In Negotiation", "Under Contract"].includes(res.property.status) && !vacantLeaseType){
                    sendEmailNotification({ data: res.property, type: 'negotiation-under-contract-email' })
                }
                if (this.state.hasReducedListPrice && res.property.source === 'STRIVE' && ['Active', 'In Negotiation', 'Under Contract'].includes(res.property.status)){
                    sendEmailNotification({ data: res.property, type: 'list-price-change-email' })
                }
                if (this.state.hasModifiedStatus && res.property.source === 'STRIVE' && res.property.status === 'Active' && ['In Negotiation', 'Under Contract'].includes(previousStatus)) {
                    sendEmailNotification({ data: res.property, type: `back-to-market${vacantLeaseType ? '-vacant-' : '-'}email` })
                }
                if ((this.state.previousData.hsc_approved !== res.property.hsc_approved) && this.state.isHscApproved && res.property.hsc_approved && res.property.hsc_approved==='y'){
                    sendEmailNotification({ data: res.property, type: 'hsc-closing-email' })
                }
                if (this.state.isClosedReferral){
                    sendEmailNotification({ data: res.property, type: 'referral-closing-email' })
                }
                if (this.state.hasModifiedStatus && res.property.status === 'Off Market'){
                    let resp = await sendEmailNotification({ data: res.property, type: 'off-market-seller-email' });
                    if(resp.data.sendEmailNotification.message == 'missing information'){
                        this.setState({
                            error: "Missing information for off market property",
                        });
                    }
                }
                if(res.property.source === "STRIVE" && res.property.status === 'Removed' && res.property.status!==previousStatus){
                    sendEmailNotification({ data: res.property, type: 'expired-listing-email' })
                }
                if (
                    (this.state.hasModifiedStatus &&
                        ['In Negotiation', 'Under Contract'].includes(res.property.status) &&
                        (!['In Negotiation', 'Under Contract'].includes(this.state.previousData.status)) &&
                        (res.property.source === "STRIVE") &&
                        res.property.hasOwnProperty('lease_type') &&
                        (res.property.lease_type === 'Vacant') &&
                        ((res.property.status !== this.state.previousData.status) || (this.state.previousData.lease_type !== res.property.lease_type))) || 
                    (
                        ['In Negotiation', 'Under Contract'].includes(res.property.status) &&
                        (['In Negotiation', 'Under Contract'].includes(this.state.previousData.status)) &&
                        (res.property.source === "STRIVE") &&
                        res.property.status === this.state.previousData.status && (
                            res.property.hasOwnProperty('lease_type') &&
                            (res.property.lease_type === 'Vacant') && 
                            (res.property.source === "STRIVE") &&
                            ((res.property.lease_type !== this.state.previousData.lease_type) || (res.property.source !== this.state.previousData.source))
                        )
                    )
                ) {
                    sendEmailNotification({ data: res.property, type: 'negotiation-under-contract-vacant-email' })
                }
            }

            this.setState({
                hasModifiedStatus: false,
                isHscApproved: false,
                isClosedReferral: false,
                hasModifiedListPrice: false,
                hasReducedListPrice: false,
            });
        }).catch((e)=>{
            this.setState({
                isBusy: false,
                error: null,
                success: null,
            });
        });
    }

    savePropertyHistory(property,token) {
        let data = new PropertyHistoryModel(property);
        data.seller_id = data.seller_id && data.seller_id.toString();
        const query = {...this.props.location.query};
        const options = filter(query, 'history');
        options.param.property_id = property.arcimedes_row_id;
        const filters = query.order ? (Array.isArray(query.order) ? query.order : [query.order]) : [];
        data.property_id = data.property_id.toString();
        data.seller_id = data.seller_id && data.seller_id.toString();
        let payload = {
            "arcimedes_row_id": property.arcimedes_row_id,
            "deleted": 1
        }
        if (data.net_operating_income != null) {
            data.net_operating_income = data.net_operating_income.toString();
        }
        if (data.base_rent !== undefined && data.base_rent !== null) {  //api failed issue expect Int but getting string so modify.
            data.base_rent = parseInt(data.base_rent.toString().replace(/,/g, ''), 10);
        }
        if (data.rent_per_sqft == "") {
            data.rent_per_sqft = null
        }
        //manageData({tableCode: PROPERTY_HISTORY, data: [data]
        //     this.client.mutate({
        //         mutation: PROPERTY_HISTORY_MUTATION, variables:{input:data},
        //         fetchPolicy: "no-cache",
        //         context: {
        //             headers: {
        //                 authorization: `Bearer ${token}`,
        //             },
        //         }
        // })
        mutateData(PROPERTY_HISTORY_MUTATION,{input:data})
        .then(res => {
            if (!res || !res.data.createOrUpdatePropertyHistory.success) {
                this.setState({
                    error: res && res.data.createOrUpdatePropertyHistory.message ? res.data.createOrUpdatePropertyHistory.message : "Unspecified error",
                });
            } else {
                Promise.all([
                    // executeQuery({queryName: GET_PROPERTY_HISTORY,
                    //     options:options
                    // }),
                    // this.client.query({ query: GET_PROPERTY_HISTORY, variables: { propertyId: options.param.property_id },fetchPolicy: "no-cache",
                    //     context: {
                    //       headers: {
                    //         authorization: `Bearer ${token}`,
                    //       },
                    //     } }),
                        fetchData(GET_PROPERTY_HISTORY,{ propertyId: options.param.property_id }),
                    // executeQuery({queryName: PROPERTY_DATA,
                    //     params: {
                    //         PROPERTY_ID: property.ARCIMEDES_ROW_ID,
                    //     },
                    // })
                    // this.client.query({ query: GET_PROPERTY_DATA, variables: { arcimedesRowId: property.arcimedes_row_id },
                    //     fetchPolicy: "no-cache",
                    //     context: {
                    //       headers: {
                    //         authorization: `Bearer ${token}`,
                    //       },
                    //     } }),
                        fetchData(GET_PROPERTY_DATA,{ arcimedesRowId: property.arcimedes_row_id }),
                ]).then(res => {
                    let historyData = [];
                    const currentData = new CurrentHistoryModel(res[1].data.getpropertyQuery);
                    if (res && res[1] && res[1].success && Array.isArray(res[1].data) && res[1].data.length && ['Active', 'Removed', 'Closed'].includes(res[1].data[0].status))
                        historyData.push(currentData);
                    if (res && res[0] && Array.isArray(res[0].data.propertyHistoryQuery) && res[0].data.propertyHistoryQuery.length)
                            historyData = insertCurrentDataToSortedArray(currentData, res[0].data.propertyHistoryQuery, filters, historyWeights);
                    this.setState({
                        currentHistoryData:currentData,
                        historyData,
                    });
                });
            }
        });
    }

    updatePropertyTracking(data, table,token) {
       if (data.property_id && typeof data.property_id === 'string') {
            data.property_id = parseInt(data.property_id);
        }
        // manageData({tableCode: table, data: [data]}).then(res => {
        //     if (!res || !res.success)
        //         this.setState({
        //             error: res && res.message ? res.message : "Unspecified error",
        //         });
        // });
        try {
           
            //  this.client.mutate({
            //     mutation: table,
            //     variables: {
            //       input: data
            //     },
            //     context: {
            //       headers: {
            //         authorization: `Bearer ${token}`,  // Bearer token added here
            //       },
            //     },
            //  })
             mutateData(table,{input: data}).then(async res => {
            if (table === STRIVE_ESCROW_TRACKING_UPDATE) {
                if ((!res && !res.data.createOrUpdateStriveEscrowTracking.success)) {
                    this.setState({
                        error: res && res.data.createOrUpdateStriveEscrowTracking.message ? res.data.createOrUpdateStriveEscrowTracking.message : "Unspecified error",
                    });
                }
            }
            else {
                if (!res && !res.data.createOrUpdateHscTracking.success) {
                    this.setState({
                        error: res && res.data.createOrUpdateHscTracking.message ? res.data.createOrUpdateHscTracking.message : "Unspecified error",
                    });
                }
            }
        })
        }catch (error) {
            console.error("Error in update Property Tracking:", error);
          }
    }

//     async getPropertyEscrowTracking(propertyId,token) {
//         // const res = await request(arc.path.api, {
//         //     service: "arcimedes",
//         //     action: "open.dataquery.execute",
//         //     params: [ESCROW_TRACKING, {param: {PROPERTY_ID: propertyId}}],
//         // });
//         try{
//         // this.client.query({
//         //     query: GET_ESCROW_TRACKING_BY_ID, variables :{propertyId:propertyId},fetchPolicy: "no-cache",
//         //     context: {
//         //         headers: {
//         //             authorization: `Bearer ${token}`, // Bearer token added here
//         //         },
//         //     },
//         // })
//             fetchData(GET_ESCROW_TRACKING_BY_ID, { propertyId: propertyId })
//                 .then(async res => {

//                     if (res && res.data.getStriveEscrowTrackingByPropertyId  &&  Object.keys(res.data.getStriveEscrowTrackingByPropertyId.data).length) {
//                         return res.data.getStriveEscrowTrackingByPropertyId.data;
//                     }
//                     return null;
//                 })
// }
//     catch(error){
//         console.log(error.message)
//         return null;
//     }
// }

 getPropertyEscrowTracking(propertyId, token) {
    // try {
    //     const res = await fetchData(GET_ESCROW_TRACKING_BY_ID, { propertyId });
    //     
    //     if (res && res.data && res.data.getStriveEscrowTrackingByPropertyId 
    //         && res.data.getStriveEscrowTrackingByPropertyId.data 
    //          && Object.keys(res.data.getStriveEscrowTrackingByPropertyId.data).length
    //     ) {
    //         return convertKeysToLowerCase(res.data.getStriveEscrowTrackingByPropertyId.data);
    //     }
        
    //     // return null;
    // } catch (error) {
    //     console.log(error.message);
    //     return null;
    // }
    try {
        const res =  fetchData(GET_ESCROW_TRACKING_BY_ID, { propertyId });
    
        if (
            res && 
            res.data && 
            res.data.getStriveEscrowTrackingByPropertyId && 
            res.data.getStriveEscrowTrackingByPropertyId.data && 
            typeof res.data.getStriveEscrowTrackingByPropertyId.data === 'object' && 
            Object.keys(res.data.getStriveEscrowTrackingByPropertyId.data).length > 0
            && res.data.getStriveEscrowTrackingByPropertyId.data.ARCIMEDES_ROW_ID != null
        ) {
            return convertKeysToLowerCase(res.data.getStriveEscrowTrackingByPropertyId.data);
        }
    
        return null; // Don't forget to return null if no data
    } catch (error) {
        console.log(error.message);
        return null;
    }
    
}

async getPropertyHscTracking(propertyId,token)  {
        //const options = {
        //     filter: [{
        //         'text': propertyId,
        //         'code': 'PROPERTY_ID',
        //         'type': 'exact',
        //     }],
        // };
        //const res = await getData({tableCode: HSC_TRACKING, options});
        //executeQuery({queryName, params: param})
        try{
        //  this.client.query({
        //     query: GET_HSC_TRACKING_BY_ID, variables :{propertyId:propertyId},fetchPolicy: "no-cache",
        //     context: {
        //         headers: {
        //             authorization: `Bearer ${token}`, // Bearer token added here
        //         },
        //     },
        // })
        return fetchData(GET_HSC_TRACKING_BY_ID,{propertyId:propertyId}).then(async res => {

        if (res && res.data.getHscTracking && Array.isArray(res.data.getHscTracking) && res.data.getHscTracking.length){
            return res.data.getHscTracking[0];
        }
        return null;
})
        }catch(error){
            console.log(error.message)
            return null;
        }
    }

    static verifyPercentDecimalsLimit({value, isAgentPercent}) {
        if (isAgentPercent) {
            const number = value.split(".");
            const decimals = number[1] ? number[1].length : null;
            if (decimals && decimals > 15) {
                return true;
            }
        }
        return false;
    }
    checkHistoryAndSave(currentStatus, previousStatus,token){

        if (this.state.hasModifiedStatus){
            //Active, Remove, Closed -> Active, Removed, Closed
            if(['Active', 'Removed', 'Closed'].includes(previousStatus) && ['Active', 'Removed', 'Closed'].includes(currentStatus))
                this.savePropertyHistory(this.state.previousData,token);

            //Closed, Remove -> Proposal
            else if(['Closed','Removed'].includes(previousStatus) && currentStatus === 'Proposal')
                this.savePropertyHistory(this.state.previousData,token);

            //Flagged -> Closed, Proposal, Removed
            else if(previousStatus === 'Flagged' && ['Closed','Proposal','Removed'].includes(currentStatus))
                this.savePropertyHistory(this.state.previousData,token);

            //proposal or property info
            else if(currentStatus === 'Proposal' || currentStatus === 'Property Info')
                this.savePropertyHistory(this.state.data);
        }
        //List price changed & Active status
        else if(this.state.hasModifiedListPrice && currentStatus === 'Active')
            this.savePropertyHistory(this.state.previousData,token);  
    }
    clearBuysideAgentFieldsAndUnderContratPrice(){
        this.state.data.buyer_id = "";
        this.state.data.buyer_agent_1 = "";
        this.state.data.buyer_agent_1_percent = "";
        this.state.data.buyer_agent_2 = "";
        this.state.data.buyer_agent_2_percent = "";
        this.state.data.buyer_agent_3 = "";
        this.state.data.buyer_agent_3_percent = "";
        this.state.data.buyer_agent_4 = "";
        this.state.data.buyer_agent_4_firm = "";
        this.state.data.buyer_agent_4_percent = "";
        this.state.data.negotiation_price ? this.state.data.negotiation_price = "" : this.state.data.hsc_price = "";
        this.state.data.potential_fee = "";
        this.state.data.negotiation_price_per_sqft = "";
        this.state.data.negotiation_cap_rate = "";
    }
    checkCoordinatesAndSave(data, original) {
        // mutateData throws on a GraphQL error; log it and release the busy state instead of leaving an unhandled rejection
        const save = () => this.saveData(data).catch(err => {
            console.error('Property save failed:', err);
            this.setState({isBusy: null});
        });
        if (!data.address || !data.city || !data.state) {
            data.latitude = null;
            data.longitude = null;
            save();
        } else if (data.address !== original.address || data.city !== original.city || data.state !== original.state || !original.latitude || !original.longitude) {
            this.geocode(data, (geo) => {
                data.latitude = geo ? geo.lat : null;
                data.longitude = geo ? geo.lng : null;
                save();
            });
        } else {
            save();
        }
    }

    openHscPayments(){
        this.setState({showHscModal:true});
    }

    async isPropertyExists(e) {
        e.preventDefault();
        const data = this.state.data;
        if(!this.props.edit){
            var AddressInput = {
                address: data.address, 
                city: data.city
            }
            const res = await fetchData(GET_PROPERTIES_ADDRESS,{input: AddressInput})
            
            if (res.data.propertiesAddess.length > 0) {
                this.setState({ openReminderDialog: true })
            }
            else{
                this.handleSubmit(e);
            }
        }else{
            this.handleSubmit(e);
        }
    }

    async handleSubmit(e) {
        e.preventDefault();
        if (this.state.viewMode) this.setState({viewMode: false});
        if (this.state.viewMode) this.setState({ viewMode: false });
        if (this.notesRef.current && this.notesRef.current.validateNotes) {
       const isValid = this.notesRef.current.validateNotes();
       if (!isValid){
       console.log("Stop submit: notes invalid");
       return;
       }
}
        if (this.state.data.name === undefined || this.state.data.name === "") {
            this.setState({errorTabs: [0], success: null});
            return;
        } else {
            this.setState({errorTabs: []});
        }

        if (this.state.isBusy || this.state.viewMode === true) return;
        if(["Active", "In Negotiation", "Under Contract"].includes(this.state.data.status) && this.state.data.source === "STRIVE" && (this.state.data.list_price != addCommasToNumber(this.state.original.list_price))){
            this.setState({isDialogueOpen: true}); 
           return;
        }
        if(this.state.data.status === 'Active' && (this.state.original.status === 'Under Contract' || this.state.original.status === 'In Negotiation')){            
            this.clearBuysideAgentFieldsAndUnderContratPrice();
        }
        const data = this.state.data;
        const original = this.state.original;
        this.setState({viewMode: true}, () =>
            this.checkCoordinatesAndSave(data, original)
        );
    }

    static getAgentProcuredPercent({agentId, data}) {
        let percent = 0;
        if (data.listing_agent_1 === agentId){
            percent += percentToNumber(data.listing_agent_1_percent);
            if(!data.listing_2gent_1 && !data.listing_agent_3)
            percent = 100
        }
        else if (data.listing_agent_2 === agentId)
            percent += percentToNumber(data.listing_agent_2_percent);
        else if (data.listing_agent_3 === agentId)
            percent += percentToNumber(data.listing_agent_3_percent);
        if (data.buyer_agent_1 === agentId)
            percent += percentToNumber(data.buyer_agent_1_percent);
        else if (data.buyer_agent_2 === agentId)
            percent += percentToNumber(data.buyer_agent_2_percent);
        else if (data.buyer_agent_3 === agentId)
            percent += percentToNumber(data.buyer_agent_3_percent);
        return percent;
    }

    static computeFees({fee, percentProcured, percentPaid, grossCumulativeProcured, grossFeeProcured = null, grossFeePaid = null, closeDate = null}) {
        if (!fee && !grossFeePaid)
            return {
                grossPaid: null,
                net: null,
                netPercentage: null
            };
        const grossProcured = grossFeeProcured !== null ? grossFeeProcured : priceToNumber(fee) * percentProcured / 100;
        const grossPaid = grossFeePaid !== null ? grossFeePaid : priceToNumber(fee) * percentToNumber(percentPaid) / 100;
        const previousPaymentPercentProcured = getPaymentPercentage(grossCumulativeProcured - grossProcured, closeDate) / 100;
        const paymentPercentProcured = getPaymentPercentage(grossCumulativeProcured, closeDate) / 100;
        let net;
        if (previousPaymentPercentProcured !== paymentPercentProcured) {
            // Bracket transition detected - payment percentage changes
            const threshold = getPaymentThreshold(grossCumulativeProcured, closeDate);
            const amountOverThreshold = grossCumulativeProcured - threshold;
            const previousProcured = grossCumulativeProcured - grossProcured; // Previous cumulative before current gross procured
            const previousGrossCumulativeTranche = threshold - previousProcured; // Amount available in previous bracket
            
            // 2026+ Logic: When difference between Previous Gross Cumulative & Tranche is greater than Gross Paid
            if(previousGrossCumulativeTranche > grossPaid){
                // Formula: [Gross Paid – (Current Gross Cumulative Procured – Tranche)] * Old Tranche Percentage 
                //        + [Current Gross Cumulative Procured - Tranche] * New Tranche Percentage
                net = (grossPaid - (grossCumulativeProcured - threshold)) * previousPaymentPercentProcured 
                    + (grossCumulativeProcured - threshold) * paymentPercentProcured;
            }else{
                // When Gross Paid exceeds the available balance in current tranche
                // Portion up to threshold uses old percentage, remainder uses new percentage
                net =  (threshold - (grossCumulativeProcured - grossProcured)) * previousPaymentPercentProcured 
                    + (grossPaid - (threshold - (grossCumulativeProcured - grossProcured))) * paymentPercentProcured;
            }
        } else {
            // No bracket transition - use single percentage for entire gross paid amount
            net = grossPaid * paymentPercentProcured;
        }
        const netPercentage = grossPaid ? net / grossPaid * 100 : null;

        return {
            grossPaid: grossPaid ? grossPaid.toFixed(2) : null,
            net: net ? net.toFixed(2) : null,
            netPercentage: netPercentage ? netPercentage.toFixed(2) : null,
        };
    }

    async setPaymentsData(params) {
        const { key, value, index } = params;
        let paymentsData = cloneDeep(this.state.propertyPaymentsData);
        let deletedRows = cloneDeep(this.state.deletedPaymentsData);
        let propData = {...this.state.data};
        const isReferral = propData.transaction_type === 'Referral';
        const agentsGrossCumulativeProcured = cloneDeep(this.state.agentsGrossCumulativeProcured);
        const strivePercentage = getAgentContribution(propData,  paymentsData[index]['strive_team_member_id']);
        paymentsData[index][key] = value;
        if (key === 'strive_team_member_percent' && paymentsData[index].strive_team_member_id) {
            const percentProcured = CRUDProperty.getAgentProcuredPercent({agentId: paymentsData[index].strive_team_member_id, data: propData});
            const grossCumulativeProcured = agentsGrossCumulativeProcured[`GROSS_CUMULATIVE_${index + 1}`] || 0;
            const {grossPaid, net, netPercentage} = CRUDProperty.computeFees({
                fee: isReferral ? propData.referral_fee : propData.potential_fee,
                percentProcured:strivePercentage,
                percentPaid: value,
                grossCumulativeProcured,
                closeDate: propData.close_of_escrow,
            });
            paymentsData[index].strive_team_member_gross_fee = grossPaid;
            paymentsData[index].strive_team_member_net_fee = net;
            paymentsData[index].strive_team_member_net_percent = netPercentage;
        }

        if (key === 'strive_team_member_id' && value && propData.close_of_escrow) {
            // get STRIVE Team Member gross cumulative procured
            let grossCumulativeProcured = await this.getAgentGrossCumulativeProcured(value, propData.close_of_escrow);
            agentsGrossCumulativeProcured[`GROSS_CUMULATIVE_${index + 1}`] = grossCumulativeProcured;

            if (paymentsData[index].strive_team_member_percent) {
                const percentProcured = CRUDProperty.getAgentProcuredPercent({agentId: value, data: propData});
                const {grossPaid, net, netPercentage} = CRUDProperty.computeFees({
                    fee: isReferral ? propData.referral_fee : propData.potential_fee,
                    percentProcured,
                    percentPaid: paymentsData[index].strive_team_member_percent,
                    grossCumulativeProcured,
                    closeDate: propData.close_of_escrow,
                });
                paymentsData[index].strive_team_member_gross_fee = grossPaid;
                paymentsData[index].strive_team_member_net_fee = net;
                paymentsData[index].strive_team_member_net_percent = netPercentage;
            }
        }

        if (key === 'strive_team_member_id' && !value) {
            paymentsData[index].strive_team_member_gross_fee = null;
            paymentsData[index].strive_team_member_net_fee = null;
            paymentsData[index].strive_team_member_net_percent = null;
            paymentsData[index].strive_team_member_percent = null;
        }

        paymentsData[index].payment_modified = true;
        if (key === 'deleted') {
            const deletedRow = {...paymentsData[index]};
            delete deletedRow.payment_modified;
            deletedRows.push(deletedRow);
            paymentsData.splice(index, 1);
        }

        this.setState({
            propertyPaymentsData: paymentsData,
            deletedPaymentsData: deletedRows,
            agentsGrossCumulativeProcured,
        });
    }

    // setLoanQuotesData(key, value){
    //     let lqData = this.state.loanQuotesData;
    //     let propData = {...this.state.data};
    //     let downPaymentChanged = false, loanAmountChanged = false, annualLoanPaymentChanged = false, annualCashFlowChanged = false;

    //     const nameKey = key.split('-');
    //     let lqKey = nameKey[0];
    //     let lqRow = nameKey[1];

    //     lqData[lqRow][lqKey] = value;

    //     if (lqKey === 'AMORTIZATION' || lqKey === 'MATURITY') {
    //         const maturity = lqData[lqRow].MATURITY;
    //         const amortization = lqData[lqRow].AMORTIZATION;
    //         lqData[lqRow].LOAN_STRUCTURE = (maturity ? maturity + ' Yr. / ' : '- / ') + (amortization == "Interest Only" ? amortization : ( amortization ? amortization + ' Yr.' : ' -'));
    //     }

    //     if (lqKey === 'PURCHASE_PRICE' || lqKey === 'DOWN_PAYMENT_PERCENT') {
    //         const purchasePrice = priceToNumber(lqData[lqRow].PURCHASE_PRICE);
    //         const downPaymentPercent = percentToNumber(lqData[lqRow].DOWN_PAYMENT_PERCENT);
    //         lqData[lqRow].DOWN_PAYMENT = purchasePrice && downPaymentPercent ? Math.round(purchasePrice * downPaymentPercent / 100) : null;
    //         lqData[lqRow].LOAN_AMOUNT = purchasePrice && lqData[lqRow].DOWN_PAYMENT ? purchasePrice - lqData[lqRow].DOWN_PAYMENT : null;
    //         downPaymentChanged = true;
    //         loanAmountChanged = true;
    //     }

    //     if (lqKey === 'DOWN_PAYMENT') {
    //         const purchasePrice = priceToNumber(lqData[lqRow].PURCHASE_PRICE);
    //         const downPayment = priceToNumber(lqData[lqRow].DOWN_PAYMENT);
    //         lqData[lqRow].LOAN_AMOUNT = purchasePrice && downPayment ? Math.round(purchasePrice - downPayment) : null;
    //         loanAmountChanged = true;
    //     }

    //     if (lqKey === 'INTEREST_RATE' || lqKey === 'AMORTIZATION' || lqKey === 'LOAN_AMOUNT' || loanAmountChanged) {
    //         const interestRate = percentToNumber(lqData[lqRow].INTEREST_RATE);
    //         const amortization = isNaN(Number(lqData[lqRow].AMORTIZATION)) ? 0 : Number(lqData[lqRow].AMORTIZATION);
    //         const loanAmount = typeof lqData[lqRow].LOAN_AMOUNT === 'string' ? priceToNumber(lqData[lqRow].LOAN_AMOUNT) : lqData[lqRow].LOAN_AMOUNT; 
    //         lqData[lqRow].LOAN_PAYMENT_ANNUALLY = interestRate && amortization && loanAmount ? Math.round(-pmtFunction(interestRate / 100 / 12, amortization * 11.8, loanAmount) * 12) : amortization == 0 ? Math.round(loanAmount * (interestRate/100)) : null;
    //         annualLoanPaymentChanged = true;
    //     }

    //     if (lqKey === 'LOAN_PAYMENT_ANNUALLY' || annualLoanPaymentChanged) {
    //         const annualLoanPayment = typeof lqData[lqRow].LOAN_PAYMENT_ANNUALLY === 'string' ? priceToNumber(lqData[lqRow].LOAN_PAYMENT_ANNUALLY) : lqData[lqRow].LOAN_PAYMENT_ANNUALLY;
    //         lqData[lqRow].LOAN_PAYMENT_MONTHLY = annualLoanPayment ? Math.round(annualLoanPayment / 12) : null;
    //     }

    //     if (lqKey === 'PURCHASE_PRICE' || lqKey === 'NOI') {
    //         const purchasePrice = priceToNumber(lqData[lqRow].PURCHASE_PRICE);
    //         const NOI = priceToNumber(lqData[lqRow].NOI);
    //         lqData[lqRow].CAP_RATE = purchasePrice && NOI ? (NOI / purchasePrice * 100).toFixed(2) : null;
    //     }

    //     if (lqKey === 'NOI' || lqKey === 'LOAN_PAYMENT_ANNUALLY' || annualLoanPaymentChanged) {
    //         const NOI = priceToNumber(lqData[lqRow].NOI);
    //         const annualLoanPayment = typeof lqData[lqRow].LOAN_PAYMENT_ANNUALLY === 'string' ? priceToNumber(lqData[lqRow].LOAN_PAYMENT_ANNUALLY) : lqData[lqRow].LOAN_PAYMENT_ANNUALLY;
    //         lqData[lqRow].CASH_FLOW_ANNUALLY = NOI && annualLoanPayment ? Math.round(NOI - annualLoanPayment) : null;
    //         annualCashFlowChanged = true;
    //     }

    //     if (lqKey === 'CASH_FLOW_ANNUALLY' || annualCashFlowChanged) {
    //         const cashFlowAnnually = typeof lqData[lqRow].CASH_FLOW_ANNUALLY === 'string' ? priceToNumber(lqData[lqRow].CASH_FLOW_ANNUALLY) : lqData[lqRow].CASH_FLOW_ANNUALLY;
    //         lqData[lqRow].CASH_FLOW_MONTHLY = cashFlowAnnually ? Math.round(cashFlowAnnually / 12) : null;
    //     }

    //     if (lqKey === 'DOWN_PAYMENT' || downPaymentChanged || lqKey === 'CASH_FLOW_ANNUALLY' || annualCashFlowChanged) {
    //         const cashFlow = typeof lqData[lqRow].CASH_FLOW_ANNUALLY === 'string' ? priceToNumber(lqData[lqRow].CASH_FLOW_ANNUALLY) : lqData[lqRow].CASH_FLOW_ANNUALLY;
    //         const downPayment = typeof lqData[lqRow].DOWN_PAYMENT === 'string' ? priceToNumber(lqData[lqRow].DOWN_PAYMENT) : lqData[lqRow].DOWN_PAYMENT;
    //         lqData[lqRow].CASH_ON_CASH = cashFlow && downPayment ? (cashFlow / Math.round(downPayment) * 100).toFixed(2) : null;
    //     }

    //     if (lqKey === 'NOI' || lqKey === 'NOI_PERCENTAGE') {
    //         const NOI = priceToNumber(lqData[lqRow].NOI);
    //         const NOIPercentage = Number(lqData[lqRow].NOI_PERCENTAGE).toFixed(2);
    //         lqData[lqRow].NOI_MULTIPLIED = NOI && NOIPercentage ? NOI * NOIPercentage / 100 : null;
    //     }

    //     if (lqKey === 'NOI' || lqKey === 'LOAN_AMOUNT' || loanAmountChanged) {
    //         const NOI = priceToNumber(lqData[lqRow].NOI);
    //         const loanAmount = typeof lqData[lqRow].LOAN_AMOUNT === 'string' ? priceToNumber(lqData[lqRow].LOAN_AMOUNT) : lqData[lqRow].LOAN_AMOUNT;
    //         lqData[lqRow].DEBT_YIELD = NOI && loanAmount ? NOI / loanAmount * 100 : null;
    //     }

    //     if (lqKey === 'NOI' || lqKey === 'LOAN_PAYMENT_ANNUALLY' || annualLoanPaymentChanged || lqKey === 'NOI_PERCENTAGE') {
    //         const NOI = priceToNumber(lqData[lqRow].NOI);
    //         const NOIPercentage = Number(lqData[lqRow].NOI_PERCENTAGE).toFixed(2);
    //         const annualLoanPayment = typeof lqData[lqRow].LOAN_PAYMENT_ANNUALLY === 'string' ? priceToNumber(lqData[lqRow].LOAN_PAYMENT_ANNUALLY) : lqData[lqRow].LOAN_PAYMENT_ANNUALLY;
    //         lqData[lqRow].DSCR = NOI && annualLoanPayment ? ((NOI * NOIPercentage/ 100) / annualLoanPayment).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : null;
    //     }

    //     lqData[lqRow].LOAN_QUOTES_MODIFIED = true;
    //     this.setState({
    //         loanQuotesData: lqData
    //     });
    // }

    setLoanQuotesData(key, value) {
        let lqData = this.state.loanQuotesData;
        let propData = { ...this.state.data };
        let downPaymentChanged = false, loanAmountChanged = false, annualLoanPaymentChanged = false, annualCashFlowChanged = false;

        const nameKey = key.split('-');
        let lqKey = nameKey[0];
        let lqRow = nameKey[1];

        lqData[lqRow][lqKey] = value;
        if (lqKey === 'amortization' || lqKey === 'maturity') {
            const maturity = lqData[lqRow].maturity;
            const amortization = lqData[lqRow].amortization;
            lqData[lqRow].loan_structure = (maturity ? maturity + ' Yr. / ' : '- / ') + (amortization == "Interest Only" ? amortization : (amortization ? amortization + ' Yr.' : ' -'));
        }

        if (lqKey === 'purchase_price' || lqKey === 'down_payment_percent') {
            const purchasePrice = priceToNumber(lqData[lqRow].purchase_price);
            const downPaymentPercent = percentToNumber(lqData[lqRow].down_payment_percent);
            lqData[lqRow].down_payment = purchasePrice && downPaymentPercent ? Math.round(purchasePrice * downPaymentPercent / 100) : null;
            lqData[lqRow].loan_amount = purchasePrice && lqData[lqRow].down_payment ? purchasePrice - lqData[lqRow].down_payment : null;
            downPaymentChanged = true;
            loanAmountChanged = true;
        }

        if (lqKey === 'down_payment') {
            const purchasePrice = priceToNumber(lqData[lqRow].purchase_price);
            const downPayment = priceToNumber(lqData[lqRow].down_payment);
            lqData[lqRow].loan_amount = purchasePrice && downPayment ? Math.round(purchasePrice - downPayment) : null;
            loanAmountChanged = true;
        }

        if (lqKey === 'interest_rate' || lqKey === 'amortization' || lqKey === 'loan_amount' || loanAmountChanged) {
            const interestRate = percentToNumber(lqData[lqRow].interest_rate);
            const amortization = isNaN(Number(lqData[lqRow].amortization)) ? 0 : Number(lqData[lqRow].amortization);
            const loanAmount = typeof lqData[lqRow].loan_amount === 'string' ? priceToNumber(lqData[lqRow].loan_amount) : lqData[lqRow].loan_amount;
            lqData[lqRow].loan_payment_annually = interestRate && amortization && loanAmount ? Math.round(-pmtFunction(interestRate / 100 / 12, amortization * 11.8, loanAmount) * 12) : amortization == 0 ? Math.round(loanAmount * (interestRate / 100)) : null;
            annualLoanPaymentChanged = true;
        }

        if (lqKey === 'loan_payment_annually' || annualLoanPaymentChanged) {
            const annualLoanPayment = typeof lqData[lqRow].loan_payment_annually === 'string' ? priceToNumber(lqData[lqRow].loan_payment_annually) : lqData[lqRow].loan_payment_annually;
            lqData[lqRow].loan_payment_monthly = annualLoanPayment ? Math.round(annualLoanPayment / 12) : null;
        }

        if (lqKey === 'purchase_price' || lqKey === 'NOI') {
            const purchasePrice = priceToNumber(lqData[lqRow].purchase_price);
            const noi = priceToNumber(lqData[lqRow].noi);
            lqData[lqRow].cap_rate = purchasePrice && noi ? (noi / purchasePrice * 100).toFixed(2) : null;
        }

        if (lqKey === 'noi' || lqKey === 'loan_payment_annually' || annualLoanPaymentChanged) {
            const noi = priceToNumber(lqData[lqRow].noi);
            const annualLoanPayment = typeof lqData[lqRow].loan_payment_annually === 'string' ? priceToNumber(lqData[lqRow].loan_payment_annually) : lqData[lqRow].loan_payment_annually;
            lqData[lqRow].cash_flow_annually = noi && annualLoanPayment ? Math.round(noi - annualLoanPayment) : null;
            annualCashFlowChanged = true;
        }

        if (lqKey === 'cash_flow_annually' || annualCashFlowChanged) {
            const cashFlowAnnually = typeof lqData[lqRow].cash_flow_annually === 'string' ? priceToNumber(lqData[lqRow].cash_flow_annually) : lqData[lqRow].cash_flow_annually;
            lqData[lqRow].cash_flow_monthly = cashFlowAnnually ? Math.round(cashFlowAnnually / 12) : null;
        }

        if (lqKey === 'down_payment' || downPaymentChanged || lqKey === 'cash_flow_annually' || annualCashFlowChanged) {
            const cashFlow = typeof lqData[lqRow].cash_flow_annually === 'string' ? priceToNumber(lqData[lqRow].cash_flow_annually) : lqData[lqRow].cash_flow_annually;
            const downPayment = typeof lqData[lqRow].down_payment === 'string' ? priceToNumber(lqData[lqRow].down_payment) : lqData[lqRow].down_payment;
            lqData[lqRow].cash_on_cash = cashFlow && downPayment ? (cashFlow / Math.round(downPayment) * 100).toFixed(2) : null;
        }

        if (lqKey === 'noi' || lqKey === 'noi_percentage') {
            const noi = priceToNumber(lqData[lqRow].noi);
            const NOIPercentage = Number(lqData[lqRow].noi_percentage).toFixed(2);
            lqData[lqRow].noi_multiplied = noi && NOIPercentage ? noi * NOIPercentage / 100 : null;
        }

        if (lqKey === 'noi' || lqKey === 'loan_amount' || loanAmountChanged) {
            const NOI = priceToNumber(lqData[lqRow].noi);
            const loanAmount = typeof lqData[lqRow].loan_amount === 'string' ? priceToNumber(lqData[lqRow].loan_amount) : lqData[lqRow].loan_amount;
            lqData[lqRow].debt_yield = NOI && loanAmount ? NOI / loanAmount * 100 : null;
        }

        if (lqKey === 'noi' || lqKey === 'loan_payment_annually' || annualLoanPaymentChanged || lqKey === 'noi_percentage') {
            const NOI = priceToNumber(lqData[lqRow].noi);
            const NOIPercentage = Number(lqData[lqRow].noi_percentage).toFixed(2);
            const annualLoanPayment = typeof lqData[lqRow].loan_payment_annually === 'string' ? priceToNumber(lqData[lqRow].loan_payment_annually) : lqData[lqRow].loan_payment_annually;
            lqData[lqRow].dscr = NOI && annualLoanPayment ? ((NOI * NOIPercentage / 100) / annualLoanPayment).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : null;
        }

        lqData[lqRow].loan_quotes_modified = true;
        this.setState({
            loanQuotesData: lqData
        });
    }

    async setData(key, value, isAgentPercent = false, addAdditionalData = false, additionalDataValue = null) {
        let data = {...this.state.data};

        const lqData = cloneDeep(this.state.loanQuotesData);            
        let paymentsData = this.state.propertyPaymentsData;

        let closeNoiChanged = false, soldPriceChanged = false, hscPriceChanged = false, loanPaymentChanged = false,
            cashFlowChanged = false, downPaymentChanged = false, hscTotalFeeChanged = false;
        const exceededDecimalsLimit = CRUDProperty.verifyPercentDecimalsLimit({value, isAgentPercent});

        if (!exceededDecimalsLimit) {
            data = {...data, [key]: value};
        }
        if (this.props.isSeniorAgent) {
            if (key === 'status' &&( value === 'Active' || value === 'Closed') ) {
                data.source = 'External';
            }
            else if(key === 'status' && (value === 'Proposal' || value === 'Property Info')){
                data.source = 'STRIVE';
            }
            else if (key === 'status' && !( value === 'Active' || value === 'Closed')) {
                    data.source = '';
            }
        }
        if( key === 'transaction_type' && value === 'Extra Payment'){
             data.source = 'STRIVE';
        }else{
            // data.source = '';
            data.source = data.source;
        }
        if (key === 'status' && value === 'Closed' && data.source === 'STRIVE' && data.name && data.name.includes('Christian Brothers Automotive') && data.type === 'STNL' &&  data.sale_lease_back === 'Yes' && data.close_of_escrow){
            data.lease_commencement_date = data.close_of_escrow;
            const escrowDate = new Date(data.close_of_escrow);
            const expirationYear = escrowDate.getFullYear()+15;
            const expirationDate = new Date(expirationYear, escrowDate.getMonth() + 1, 0).getDate();
            data.lease_expiration_date = `${escrowDate.getMonth()+1}/${expirationDate}/${expirationYear}`;
        }

        if (key === "source") {
            // data.listing_agent_4_firm = value === "STRIVE" ? (!env ? 34 : 2) : null;
             data.listing_agent_4_firm = value === "STRIVE" ? 34 : null;

            if(value === "STRIVE")
                data.estimated_price_type = "Act" 
        }

        if (key === 'type' && value === 'STNL') {
            data.vacancy = '100';
        }

        if (key === "sqft" || key === "list_price") {
            data.price_per_sqft = pricePerFoot(data.list_price, data.sqft);
        }

        if (key === "sqft" || key === "negotiation_price") {
            data.negotiation_price_per_sqft = pricePerFoot(data.negotiation_price, data.sqft);
        }

        if (key === "sqft" || key === "base_rent" || key === 'net_operating_income' || key === "vacancy") {
            const price = data.type === 'MT' ? data.base_rent : data.net_operating_income;
            const occupancy = data.type === 'MT' ? data.vacancy : '100';
            data.rent_per_sqft = rentPerFoot(price, data.sqft, occupancy);
        }

        if (key === 'net_operating_income') {
            data.base_rent = data.net_operating_income;
        }

        if ((key === 'net_operating_income' || key === 'status') && data.status === 'Closed' || key === 'close_of_escrow') {
            data.close_noi = data.net_operating_income;
            closeNoiChanged = true;
        }

        if ((key === 'negotiation_price' || key === 'status') && data.status === 'Closed' || key === 'close_of_escrow') {
            data.sold_price = (data.source === 'HSC' || data.source === 'External') ? data.hsc_price : data.negotiation_price;
            soldPriceChanged = true;
        }

        if (key === 'close_of_escrow') {
           // data.LOAN_CLOSING_DATE = data.close_of_escrow;
            data.loan_closing_date = data.LOAN_TYPE != "Refi" ? data.close_of_escrow : data.loan_closing_date;
            value = viewDateTimeFormat(value);
            const date = value ? value.split('/').length === 3 : false;
            if (data.name && data.name.includes('Christian Brothers Automotive') && data.type && data.type === 'STNL' &&  data.sale_lease_back && data.sale_lease_back === 'Yes' && date) {
                data.lease_commencement_date = value;
                const escrowDate = new Date(value);
                const expirationYear = escrowDate.getFullYear() + 15;
                const expirationDate = new Date(expirationYear, escrowDate.getMonth() + 1, 0).getDate();
                data.lease_expiration_date = `${escrowDate.getMonth()+1}/${expirationDate}/${expirationYear}`;
            }
        }

        if (key === "negotiation_price" || key === "net_operating_income") {
            const price = priceToNumber(data.negotiation_price);
            const noi = priceToNumber(data.net_operating_income);
            data.negotiation_cap_rate = noi !== false && price !== false ? price ? Math.round((noi / price) * 10000) / 100 : 0 : "";
        }

        if (key === "sold_price" || key === "close_noi" || closeNoiChanged || soldPriceChanged) {
            const price = priceToNumber(data.sold_price);
            const noi = priceToNumber(data.close_noi);
            data.close_cap_rate = noi !== false && price !== false ? price ? Math.round((noi / price) * 10000) / 100 : 0 : "";
        }

        if (key === 'sqft' || key === 'sold_price' || soldPriceChanged) {
            data.close_price_per_sqft = pricePerFoot(data.sold_price, data.sqft);
        }

        if (["listing_agent_1", "listing_agent_2", "listing_agent_3", "listing_agent_4","referring_listing_agent"].indexOf(key) !== -1) {
            data = changeListingAgentsPercent(data);
        }

        if (["buyer_agent_1", "buyer_agent_2", "buyer_agent_3", "buyer_agent_4","referring_buyer_agent"].indexOf(key) !== -1) {
            data = changeBuyingAgentsPercent(data);
        }

        if (["list_price", "seller_fee_percentage"].indexOf(key) !== -1) {
            const price = priceToNumber(data.list_price);
            const percent = percentToNumber(data.seller_fee_percentage);
            data.total_fee = price !== false && percent !== false ? (price * (percent / 100)).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2,}) : "";
        }
        

        if (soldPriceChanged ||
            ["sold_price", "negotiation_price", "seller_fee_percentage", "listing_agent_1", "listing_agent_2", "listing_agent_3", "listing_agent_4",
                "buyer_agent_1", "buyer_agent_2", "buyer_agent_3", "buyer_agent_4",
                "listing_agent_1_percent", "listing_agent_2_percent", "listing_agent_3_percent", "listing_agent_4_percent",
                "buyer_agent_1_percent", "buyer_agent_2_percent", "buyer_agent_3_percent", "buyer_agent_4_percent",].indexOf(key) !== -1) {
            const price = data.sold_price ? priceToNumber(data.sold_price) : priceToNumber(data.negotiation_price);
            const feePercent = percentToNumber(data.seller_fee_percentage);
            const strivePercents = percentToNumber(data.listing_agent_1_percent) + percentToNumber(data.listing_agent_2_percent) + percentToNumber(data.listing_agent_3_percent) + percentToNumber(data.buyer_agent_1_percent) + percentToNumber(data.buyer_agent_2_percent) + percentToNumber(data.buyer_agent_3_percent);
            data.potential_fee = price !== false && feePercent !== false && strivePercents ? (price * (feePercent / 100) * (strivePercents / 100)).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2,}) : "";
        }

        if (soldPriceChanged ||
            ["sold_price", "seller_fee_percentage", "listing_agent_1", "listing_agent_2", "listing_agent_3",
            "listing_agent_1_percent", "listing_agent_2_percent", "listing_agent_3_percent", "listing_agent_4_percent",
            "buyer_agent_1", "buyer_agent_2", "buyer_agent_3", "buyer_agent_4",].indexOf(key) !== -1) {
            const soldPrice = priceToNumber(data.sold_price);
            const feePercent = percentToNumber(data.seller_fee_percentage);
            const listAgentsPercent = percentToNumber(data.listing_agent_1_percent) + percentToNumber(data.listing_agent_2_percent) + percentToNumber(data.listing_agent_3_percent) + percentToNumber(data.listing_agent_4_percent);
            data.list_fee = soldPrice !== false && feePercent !== false && listAgentsPercent ? (soldPrice * (feePercent / 100) * (listAgentsPercent / 100)).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2,}) : "";
        }

        if (soldPriceChanged ||
            ["sold_price", "seller_fee_percentage", "buyer_agent_1", "buyer_agent_2", "buyer_agent_3", "buyer_agent_4",
            "buyer_agent_1_percent", "buyer_agent_2_percent", "buyer_agent_3_percent", "buyer_agent_4_percent",
                "listing_agent_1", "listing_agent_2", "listing_agent_3",].indexOf(key) !== -1) {
            const soldPrice = priceToNumber(data.sold_price);
            const feePercent = percentToNumber(data.seller_fee_percentage);
            const buyingAgentsPercent = percentToNumber(data.buyer_agent_1_percent) + percentToNumber(data.buyer_agent_2_percent) + percentToNumber(data.buyer_agent_3_percent) + percentToNumber(data.buyer_agent_4_percent);
            data.buyside_fee = soldPrice !== false && feePercent !== false && buyingAgentsPercent ? (soldPrice * (feePercent / 100) * (buyingAgentsPercent / 100)).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2,}) : "";
        }

        if (["expiration_no_of_months", "listed_date"].indexOf(key) !== -1) {
            data.expiration_date = calculateExpirationDate({noMonths: data.expiration_no_of_months, listedDate: data.listed_date});
        }

        if ('source' === key && value === 'HSC') {
            data.transaction_type = 'Financing';
            data.hsc_expiration_no_of_months = '6';
        }

        if (["hsc_expiration_no_of_months", "hsc_listed_date"].indexOf(key) !== -1) {
            data.hsc_expiration_date = calculateExpirationDate({noMonths: data.hsc_expiration_no_of_months, listedDate: data.hsc_listed_date});
        }

        if (key === "hsc_financing") {
            data.hsc_financing = value;
            data.other_financing = null;
        } else if (key === "other_financing") {
            data.other_financing = value;
            data.hsc_financing = null;
        }

        if (data.hsc_financing && (!data.hsc_price || soldPriceChanged || ['sold_price', 'negotiation_price'].includes(key))) {
            data.hsc_price = data.status === 'Closed' ? data.sold_price : data.negotiation_price;
            hscPriceChanged = true;
        }
        if (addAdditionalData) {
    if (
        addAdditionalData === "buyer_agent_4" || 
        addAdditionalData === "listing_agent_4"
    ) {
        //  Only set if buyer_agent_4 or listing_agent_4 has value
        if (data["buyer_agent_4"] != null || data["listing_agent_4"] != null) {
            data[addAdditionalData] = additionalDataValue;
        }
    } else {
        //  For all other fields (like referred_by_type, etc.)
        data[addAdditionalData] = additionalDataValue;
    }
}

        // below code having issue for referred_by in loan info tab
        //    if (addAdditionalData && (( data["buyer_agent_4"] !== null && data["buyer_agent_4"] !== undefined) ||  (data["listing_agent_4"] !== null && data["listing_agent_4"] !== undefined)) ) {
        //     data[addAdditionalData] = additionalDataValue;
        // }

        // below line if different old code.
    //    if (["buyer_agent_1", "buyer_agent_2", "buyer_agent_3"].includes(key)) {
    //        data.buyer_agent_4_firm = !env ? 34 : 2;
    //    }
   const isBuyerAgent_4Empty = 
  data["buyer_agent_4"] === null || data["buyer_agent_4"] === undefined || data["buyer_agent_4"] === "" ;
 
  const isAgentEmpty_4Empty = data["listing_agent_4"] === null|| data["listing_agent_4"] === undefined || data["listing_agent_4"] === "" ;
const hasOtherBuyerAgent = ["buyer_agent_1", "buyer_agent_2", "buyer_agent_3"]
  .some(agent => data[agent] !== null && data[agent] !== undefined && data[agent] !== "");
const isAllEmptyBuySideAgent =  ((data["buyer_agent_1"] === null || data["buyer_agent_1"] === undefined )  && (data["buyer_agent_2"] === null || data["buyer_agent_2"] === undefined) && (data["buyer_agent_3"] === null || data["buyer_agent_3"] === undefined)) && (data["buyer_agent_4"] === null || data["buyer_agent_4"] === undefined);
const isAllEmptyListingSideAgent =  ((data["listing_agent_1"] === null || data["listing_agent_1"] === undefined) && (data["listing_agent_2"] === null || data["listing_agent_2"] === undefined) && ( data["listing_agent_3"] === null || data["listing_agent_3"] === undefined) )&& (data["listing_agent_4"] === null|| data["listing_agent_4"] === undefined) ;
  const hasOtherListingAgent = ["listing_agent_1","listing_agent_2","listing_agent_3"]
  .some(agent => data[agent] !== null && data[agent] !== undefined && data[agent] !== "");

if (isBuyerAgent_4Empty && hasOtherBuyerAgent) {
  data["buyer_agent_4_firm"] = 34;
}
if(isAgentEmpty_4Empty && hasOtherListingAgent){
data["listing_agent_4_firm"] = 34;
} 
  if(isAllEmptyBuySideAgent){
  data["buyer_agent_4_firm"] = null;
 }  if(isAllEmptyListingSideAgent) {
  data["listing_agent_4_firm"] = null
 }


        if (data.source === 'HSC' && ['hsc_price', 'net_operating_income'].includes(key)) {
            const price = priceToNumber(data.hsc_price);
            const noi = priceToNumber(data.net_operating_income);
            data.capitalization_rate = price !== false && noi !== false ? (noi / price * 100).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : '';
        }

        if (hscPriceChanged || ['hsc_price', 'loan_amount'].includes(key)) {
            const price = priceToNumber(data.hsc_price);
            const loanAmount = priceToNumber(data.loan_amount);
            data.ltv = price !== false && loanAmount !== false ? (loanAmount / price * 100).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : '';
            data.down_payment = price !== false && loanAmount !== false ? (price - loanAmount).toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0}) : '';
            downPaymentChanged = true;
        }

        if ((data.source==='HSC' || data.hsc_financing) && ['hsc_price', 'sqft'].includes(key)) {
            data.price_per_sqft = pricePerFoot(data.hsc_price, data.sqft);
        }

        if (['hsc_fee_percentage', 'loan_amount'].includes(key)) {
            const loanAmount = priceToNumber(data.loan_amount);
            const percent = percentToNumber(data.hsc_fee_percentage);
            data.hsc_total_fee = loanAmount !== false && percent !== false ? (loanAmount * (percent / 100)).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : "";
            hscTotalFeeChanged = true;
        }

        if (hscTotalFeeChanged || ['referral', 'credits_at_closing','BANK_BONUS'].includes(key)) {
            const hscTotalFee = priceToNumber(data.hsc_total_fee);
            const referral = data.referral ? priceToNumber(data.referral) : 0;
            const credits = data.credits_at_closing ? priceToNumber(data.credits_at_closing) : 0;
            const bankBonus = data.bank_bonus ? priceToNumber(data.bank_bonus) : 0;
            data.hsc_list_fee = hscTotalFee !== false && referral !== false && credits !== false && bankBonus !== false ? (hscTotalFee - referral - credits + bankBonus).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : "";
        }

        if (hscTotalFeeChanged || 'referral' === key) {
            const hscTotalFee = priceToNumber(data.hsc_total_fee);
            const referral = priceToNumber(data.referral);
            data.referral_percent = hscTotalFee !== false && referral !== false ? (referral / hscTotalFee * 100).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : '';
        }

        if (hscTotalFeeChanged || 'referral_percent' === key) {
            const hscTotalFee = priceToNumber(data.hsc_total_fee);
            const referralPercent = priceToNumber(data.referral_percent);
            data.referral = hscTotalFee !== false && referralPercent !== false ? (hscTotalFee/100 * referralPercent).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : '';     
            //data.referral = hscTotalFee !== false && referralPercent !== false ? (Math.floor(hscTotalFee/100) * referralPercent).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : '';
        }

        if (hscTotalFeeChanged || 'bank_bonus' === key) {
            const loanPayment = priceToNumber(data.loan_amount);
            const bankBonus = priceToNumber(data.bank_bonus);
            data.bank_bonus_percent = loanPayment !== false && bankBonus !== false ? (bankBonus / loanPayment * 100).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : '';
        }

        if ('bank_bonus_percent' === key) {
            const loanPayment = priceToNumber(data.loan_amount);
            const bankBonusPercent = priceToNumber(data.bank_bonus_percent);
            data.bank_bonus = loanPayment !== false && bankBonusPercent !== false ? (loanPayment/100 * bankBonusPercent).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : '';
            //data.bank_bonus = loanPayment !== false && bankBonusPercent !== false ? (Math.floor(loanPayment/100) * bankBonusPercent).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : '';
        }

        if(hscTotalFeeChanged){
            hscAgentsKeys.filter(key=> data[key] != null).map((key)=>{
                this.computeHscAgentFees(data,key);
            });
        }

        if (['interest_rate', 'amortization', 'loan_amount'].includes(key)) {
            const interestRate = percentToNumber(data.interest_rate);
            const amortization = priceToNumber(data.amortization);
            const loanAmount = priceToNumber(data.loan_amount);
            data.annual_loan_payment = interestRate !== false && amortization !== false && loanAmount !== false ? (-pmtFunction(interestRate/100/ 12, amortization * 11.8, loanAmount) * 12).toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0}) : '';
            loanPaymentChanged = true;
        }

        if (loanPaymentChanged || 'net_operating_income' === key) {
            const noi = priceToNumber(data.net_operating_income);
            const loanPayment = priceToNumber(data.annual_loan_payment);
            data.cash_flow = noi !== false && loanPayment !== false ? (noi - loanPayment).toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0}) : '';
            data.dscr = noi !== false && loanPayment !== false ? loanPayment ? (noi / loanPayment).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : 0 : '';
            cashFlowChanged = true;
        }

        if (cashFlowChanged || downPaymentChanged) {
            const cashFlow = priceToNumber(data.cash_flow);
            const downPayment = priceToNumber(data.down_payment);
            data.cash_on_cash = cashFlow !== false && downPayment !== false ? downPayment ? (cashFlow / downPayment * 100).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : 0 : '';
        }

        if (['loan_closing_date', 'term', 'close_of_escrow'].includes(key)) {
            const loanClosingDate = data.loan_closing_date && !isNaN(new Date(data.loan_closing_date)) ? new Date(data.loan_closing_date) : false;
            const term = data.term ? parseInt(data.term) : false;
            data.maturity_date = '';
            if (loanClosingDate !== false && term !== false) {
                loanClosingDate.setFullYear(loanClosingDate.getFullYear() + term);
                data.maturity_date = dateToUsString(loanClosingDate);
            }
        }

        if (key === "hsc_approved") {
            if (value) {
                const date = new Date();
                const formattedDate = dateToTimestamp(date);

                const teamMember = hscTeamMembers.find(elem =>  elem.EMAIL === data.hsc_team_member_1 )
                data.hsc_approved_initials = teamMember ? teamMember.INITIALS : null;
                data.hsc_approved = value;
                data.hsc_approved_timestamp = formattedDate;
            } else {
                data.hsc_approved = value;
            }
        }

        if (key === 'negotiation_price' && data.source === 'STRIVE' || key === 'hsc_price' && data.source ==='HSC') {
            lqData.forEach(element => {
                element.purchase_price = priceToString(data[key]);
                element.down_payment = element.down_payment_percent ? Math.round(element.purchase_price * element.down_payment_percent / 100) : null;
                element.loan_amount = element.down_payment ? element.purchase_price - element.down_payment : null;

                if (data.source === 'STRIVE')
                    element.cap_rate = data.negotiation_cap_rate;
            });
        }

        if (key === 'net_operating_income') {
            lqData.forEach(element => {
                element.noi = Math.round(priceToNumber(data[key]));
                element.noi_multiplied = element.noi_percentage ? Math.round(element.noi * element.noi_percentage / 100) : Math.round(element.noi*0.9);

                if (element.loan_payment_annually && element.noi)
                    element.dscr = (element.noi / element.loan_payment_annually).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2});
                if (element.loan_amount && element.noi)
                    element.debt_yield = element.noi / element.loan_amount * 100; 

                element.noi = (Math.round(priceToNumber(data[key]))).toString();
            });
        }

        if (key === 'capitalization_rate' && data.source ==='HSC') {
            lqData.forEach(element => {
                element.cap_rate = percentToNumber(data[key]);
            });
        }

        if (key === 'noi_percent') {
            lqData.forEach((element) => { 
                // element.NOI_MULTIPLIED = percentToNumber(data[key]) / 100 * element.NOI;
                element.dscr = String((Number(element.noi_multiplied)/Number(element.loan_payment_annually)).toFixed(2));
            });
        }

        if (['transaction_type','source'].includes(key) && data.transaction_type === 'Referral' && data.source === 'STRIVE' && data.close_of_escrow) {
            const filledAgentsNr = paymentsData.filter(el => el.arcimedes_row_id).length;

            if (filledAgentsNr > minReferralMembers)
                paymentsData.length = filledAgentsNr;
            else
                paymentsData.length = minReferralMembers;
        }

        if (['transaction_type','source','status'].includes(key) && data.transaction_type !== 'Referral' && data.source === 'STRIVE' && data.status === 'Closed') {
            const paymentsLength = paymentsData.length;
            const filledAgentsNr = paymentsData.filter(el => el.arcimedes_row_id).length;

            if (filledAgentsNr > minStriveMembers) {
                Array.from({length: paymentsLength - filledAgentsNr}, () => ({property_id: data.arcimedes_row_id})).map((elem)=>{
                    paymentsData.push(elem);
                });
            } else if (paymentsLength < minStriveMembers) {
                Array.from({length: minStriveMembers - paymentsLength}, () => ({property_id: data.arcimedes_row_id})).map((elem)=>{
                    paymentsData.push(elem);
                });
            }
        }

        

        // let displayedHSCAgents = this.state.displayedHSCAgents;
        // if (key && key.includes('hsc_team_member')) {
        //     if (key === 'hsc_team_member_1' || key === 'hsc_team_member_2') {
        //         const otherTeamMemberKey = key === 'hsc_team_member_1' ? 'hsc_team_member_2' : 'hsc_team_member_1';

        //         if (!value) {
        //             data[key+'_percent'] = null;
        //             data[key+'_net_fee'] = null;
        //             data[key+'_net_percent'] = null;
        //             data[key+'_gross_fee'] = null;
        //             if (displayedHSCAgents > 1)
        //                 displayedHSCAgents-- ;
        //             if (data[otherTeamMemberKey]) {
        //                 data[otherTeamMemberKey+'_percent'] = '100';

        //                 this.computeHscAgentFees(data,otherTeamMemberKey);
        //             }
        //         } else {                
        //             if (!data[key+'_percent']) {
        //                 const agentPercentage = data[otherTeamMemberKey] ? '50' : '100';
        //                 data[key + '_percent'] = agentPercentage;
        //                 data[otherTeamMemberKey + '_percent'] = agentPercentage === '50' ? '50' : null;

        //                 if (data[otherTeamMemberKey + '_percent'])
        //                     this.computeHscAgentFees(data, otherTeamMemberKey);
        //             }
        //              this.getHscAgentGrossCumulative(data, value);
        //             this.computeHscAgentFees(data, key);
        //         }
        //     }
        //     if (key.includes('_percent')) {
        //         this.computeHscAgentFees(data, key.split('_percent')[0]);
        //     }
        // }

let displayedHSCAgents = this.state.displayedHSCAgents;

if (key && key.includes('hsc_team_member')) {

    if (key === 'hsc_team_member_1' || key === 'hsc_team_member_2') {

        const otherTeamMemberKey =
            key === 'hsc_team_member_1'
                ? 'hsc_team_member_2'
                : 'hsc_team_member_1';

        if (!value) {

            // If TEAM MEMBER 1 cleared and TEAM MEMBER 2 exists → SHIFT
            if (key === 'hsc_team_member_1' && data['hsc_team_member_2']) {

                data['hsc_team_member_1'] = data['hsc_team_member_2'];
                data['hsc_team_member_1_percent'] = '100';
                data['hsc_team_member_1_net_fee'] = data['hsc_team_member_2_net_fee'];
                data['hsc_team_member_1_net_percent'] = data['hsc_team_member_2_net_percent'];
                data['hsc_team_member_1_gross_fee'] = data['hsc_team_member_2_gross_fee'];

                // Clear TEAM MEMBER 2
                data['hsc_team_member_2'] = null;
                data['hsc_team_member_2_percent'] = null;
                data['hsc_team_member_2_net_fee'] = null;
                data['hsc_team_member_2_net_percent'] = null;
                data['hsc_team_member_2_gross_fee'] = null;

                this.computeHscAgentFees(data, 'hsc_team_member_1');

                displayedHSCAgents = 1;

            } else {

                // Normal clear
                data[key] = null;
                data[key + '_percent'] = null;
                data[key + '_net_fee'] = null;
                data[key + '_net_percent'] = null;
                data[key + '_gross_fee'] = null;

                if (displayedHSCAgents > 1)
                    displayedHSCAgents--;

                // If other agent exists → give 100%
                if (data[otherTeamMemberKey]) {
                    data[otherTeamMemberKey + '_percent'] = '100';
                    this.computeHscAgentFees(data, otherTeamMemberKey);
                }
            }

        } else {

            // Agent selected
            if (!data[key + '_percent']) {

                const agentPercentage = data[otherTeamMemberKey] ? '50' : '100';

                data[key + '_percent'] = agentPercentage;
                data[otherTeamMemberKey + '_percent'] =
                    agentPercentage === '50' ? '50' : null;

                if (data[otherTeamMemberKey + '_percent']) {
                    this.computeHscAgentFees(data, otherTeamMemberKey);
                }
            }

            this.getHscAgentGrossCumulative(data, value);
            this.computeHscAgentFees(data, key);

            if (displayedHSCAgents < 2)
                displayedHSCAgents++;
        }
    }

    // Percent change logic
    if (key.includes('_percent')) {
        this.computeHscAgentFees(data, key.split('_percent')[0]);
    }
}

        const proposalData = {...this.state.proposalData, [key]: data[key]};
        const statusDataCopy = cloneDeep(this.state.historyData)
        if(Array.isArray(statusDataCopy) && statusDataCopy.length && Object.keys(statusDataCopy[0]).length){
            if (value==="STRIVE") {
                statusDataCopy[0].status = "Refi"
            }
            else{
                statusDataCopy[0].status = null
            }
        }

        if(key === "zip"){
            if(this.state.territoryMarketMap[value]){
                data.market = this.state.territoryMarketMap[value]
            }
        }
         this.setState({
            data,
            proposalData,
            loanQuotesData: lqData,
            propertyPaymentsData: paymentsData,
            displayedHSCAgents,
            historyData: statusDataCopy,
        }); 

   /*  this.setState({
        data,
        proposalData,
        loanQuotesData: lqData,
        propertyPaymentsData: paymentsData,
        displayedHSCAgents,
        historyData: statusDataCopy,
    }, async () => {
        // Only call if you have all required data
        if (
            (data.source === 'STRIVE' || data.source === 'External') &&
            data.status === 'Closed' &&
            data.close_of_escrow &&
            paymentsData &&
            paymentsData.length
        ) {
            const token = localStorage.getItem('authToken');
            await this.getAgentsGrossCumulativeProcured(data, paymentsData, token);
        }
    }); */
    }

    handlePropsalInputChange(key, value, e) {
        if (['strengths', 'challenges', 'buyer_pool', 'qualifications', 'recommendations'].includes(key)) {
            let proposalData = this.state.proposalData;
            proposalData = proposalData.map(item => {
                if (item.arcimedes_row_id === e.target.id) {
                    item = {...item, [key]: value}
                }
                return item;
            });
            this.setState({proposalData});
        }
    }

    addHscMember() {
        let displayedHSCAgents = this.state.displayedHSCAgents;
        if(displayedHSCAgents < maxHscMembers)
            displayedHSCAgents++;
        this.setState({displayedHSCAgents})
    }

    handleAddMember() {
        const data = this.state.propertyPaymentsData;
        const propertyData = this.state.data;

        if (data.length + 1 <= maxStriveMembers)
            data.push({
                property_id: propertyData.arcimedes_row_id
            });

        this.setState({
            propertyPaymentsData: data,
        });
    }

    handleChangeFile(key, value){
        let data = this.state.data;
        data[key] = value;
        this.saveData(data, false);
    }

    // async recomputePayments(data, paymentsData) {
    //     this.setState({
    //         recomputePayments: true
    //     });

    //     await this.getAgentsGrossCumulativeProcured(data, paymentsData);
    //     // get the payment data for all properties closed after the current property
    //     const res = await executeQuery({
    //         queryName: GET_PAYMENT_PROPERTIES,
    //         params: {
    //             COE: data.CLOSE_OF_ESCROW,
    //             PROPERTY_ID: data.ARCIMEDES_ROW_ID
    //         }
    //     });
    //     const propertyPaymentsData = cloneDeep(paymentsData);
    //     if (res && res.success && res.data) {
    //         const dataToSave = [];
    //         const agentsGrossCumulativeProcured = {...this.state.agentsGrossCumulativeProcured};
    //         const isReferral = data.TRANSACTION_TYPE === 'Referral';
    //         const paymentMembersId = Object.keys(paymentsData).map(key => paymentsData[key].STRIVE_TEAM_MEMBER_ID);
    //         [...paymentsData, ...res.data].forEach(elem => {
    //             // compute the Net only for the agents that have a new cumulative
    //             if (elem.STRIVE_TEAM_MEMBER_ID && paymentMembersId.includes(elem.STRIVE_TEAM_MEMBER_ID)) {
    //                 const index = paymentMembersId.findIndex(paymentMemberId => paymentMemberId === elem.STRIVE_TEAM_MEMBER_ID);
    //                 const params = {
    //                     grossFeePaid: elem.STRIVE_TEAM_MEMBER_GROSS_FEE ? parseFloat(elem.STRIVE_TEAM_MEMBER_GROSS_FEE) : 0,
    //                 }
    //                 if (elem.LISTING_GROSS_COMMISSION) {
    //                     params.grossFeeProcured = elem.LISTING_GROSS_COMMISSION ? parseFloat(elem.LISTING_GROSS_COMMISSION) : 0;
    //                     params.grossFeeProcured += elem.BUYING_GROSS_COMMISSION ? parseFloat(elem.BUYING_GROSS_COMMISSION) : 0;
    //                 } else {
    //                     const percentProcured = CRUDProperty.getAgentProcuredPercent({agentId: elem.STRIVE_TEAM_MEMBER_ID, data});
    //                     const fee = isReferral ? data.REFERRAL_FEE : data.POTENTIAL_FEE;
    //                     params.grossFeeProcured = priceToNumber(fee) * percentProcured / 100;
    //                 }
    //                 agentsGrossCumulativeProcured[`GROSS_CUMULATIVE_${index + 1}`] += params.grossFeeProcured;
    //                 params.grossCumulativeProcured = agentsGrossCumulativeProcured[`GROSS_CUMULATIVE_${index + 1}`];
    //                 let {net, netPercentage} = CRUDProperty.computeFees(params);
    //                 if (net && net !== elem.STRIVE_TEAM_MEMBER_NET_FEE) {
    //                     propertyPaymentsData[index].STRIVE_TEAM_MEMBER_NET_FEE = net;
    //                     propertyPaymentsData[index].STRIVE_TEAM_MEMBER_NET_PERCENT = netPercentage;
    //                     dataToSave.push({
    //                         STRIVE_TEAM_MEMBER_NET_FEE: net,
    //                         STRIVE_TEAM_MEMBER_NET_PERCENT: netPercentage,
    //                     });
    //                     if (elem.ARCIMEDES_ROW_ID)
    //                         dataToSave[dataToSave.length - 1].ARCIMEDES_ROW_ID = elem.ARCIMEDES_ROW_ID;
    //                 }
    //             }
    //         });

    //         if (dataToSave.length) {
    //             const res = await manageData({tableCode: PROPERTY_PAYMENT_TEAM, data: dataToSave});
    //             if (res && res.success)
    //                 this.setState({recomputePayments: false});
    //             else
    //                 this.setState({
    //                     error: res && res.message ? res.message : "Unspecified error",
    //                 });
    //         } else
    //             this.setState({recomputePayments: false});
    //     } else {
    //         this.setState({
    //             error: res && res.message ? res.message : "Unspecified error",
    //         });
    //     }

    //     return propertyPaymentsData;
    // }
    async recomputePayments(data, paymentsData,token) {
        // Nothing to recompute without a close of escrow or a saved property id
        // (e.g. deleting a property that was never closed)
        if (!data.close_of_escrow || !data.arcimedes_row_id) {
            return paymentsData;
        }

        this.setState({
            recomputePayments: true
        });

        await this.getAgentsGrossCumulativeProcured(data, paymentsData,token);
        // get the payment data for all properties closed after the current property
        // const res = await executeQuery({
        //     queryName: GET_PAYMENT_PROPERTIES,
        //     params: {
        //         COE: data.CLOSE_OF_ESCROW,
        //         PROPERTY_ID: data.ARCIMEDES_ROW_ID
        //     }
        // });
        // if (!data.close_of_escrow ||!data.arcimedes_row_id) {
        //     return; // Exit early if data or paymentsData is not available
        // }
        // const res = await this.client.query({ query: GET_PAYMENT_PROPERTIES, variables: { coe: data.close_of_escrow, property_id: data.arcimedes_row_id},
        //     fetchPolicy: "no-cache",
        //     context: {
        //       headers: {
        //         authorization: `Bearer ${token}`,
        //       },
        //     } 
        // })
        const res = await fetchData(GET_PAYMENT_PROPERTIES,{ coe: data.close_of_escrow, propertyId: String(data.arcimedes_row_id)});
        const propertyPaymentsData = cloneDeep(paymentsData);
        if (res && res.data.getPropertyPayments) {
            const dataToSave = [];
            const agentsGrossCumulativeProcured = { ...this.state.agentsGrossCumulativeProcured };
            const isReferral = data.transaction_type === 'Referral';
            const paymentMembersId = Object.keys(paymentsData).map(key => paymentsData[key].strive_team_member_id);
            [...paymentsData, ...res.data.getPropertyPayments].forEach(elem => {
                // compute the Net only for the agents that have a new cumulative
                if (elem.strive_team_member_id && paymentMembersId.includes(elem.strive_team_member_id)) {
                    const index = paymentMembersId.findIndex(paymentMemberId => paymentMemberId === elem.strive_team_member_id);
                    const params = {
                        grossFeePaid: elem.strive_team_member_gross_fee ? parseFloat(elem.strive_team_member_gross_fee) : 0,
                        closeDate: data.close_of_escrow,
                    }
                    if (elem.listing_gross_commission) {
                        params.grossFeeProcured = elem.listing_gross_commission ? parseFloat(elem.listing_gross_commission) : 0;
                        params.grossFeeProcured += elem.buying_gross_commission ? parseFloat(elem.buying_gross_commission) : 0;
                    } else {
                        const percentProcured = CRUDProperty.getAgentProcuredPercent({ agentId: elem.strive_team_member_id, data });
                        const fee = isReferral ? data.referral_fee : data.potential_fee;
                        params.grossFeeProcured = priceToNumber(fee) * percentProcured / 100;
                    }
                    agentsGrossCumulativeProcured[`GROSS_CUMULATIVE_${index + 1}`] += params.grossFeeProcured;
                    params.grossCumulativeProcured = agentsGrossCumulativeProcured[`GROSS_CUMULATIVE_${index + 1}`];
                    let { net, netPercentage } = CRUDProperty.computeFees(params);
                    if (net && net !== elem.strive_team_member_net_fee) {
                        propertyPaymentsData[index].strive_team_member_net_fee = net;
                        propertyPaymentsData[index].strive_team_member_net_percent = netPercentage;
                        dataToSave.push({
                            strive_team_member_net_fee: net,
                            strive_team_member_net_percent: netPercentage,
                        });
                        if (elem.arcimedes_row_id)
                            dataToSave[dataToSave.length - 1].arcimedes_row_id = elem.arcimedes_row_id;
                    }
                }
            });

            if (dataToSave.length) {
                // const res = await manageData({ tableCode: PROPERTY_PAYMENT_TEAM, data: dataToSave });
                //const res = this.client.mutate({mutation:PROPERTY_PAYMENT_TEAM_MUTATION, variables:{data:dataToSave}})
                const res = mutateData(PROPERTY_PAYMENT_TEAM_MUTATION, {input:dataToSave})
                if (res && res.success)
                    this.setState({ recomputePayments: false });
                else
                    this.setState({
                        error: res && res.message ? res.message : "Unspecified error",
                    });
            } else
                this.setState({ recomputePayments: false });
        } else {
            this.setState({
                error: res && res.message ? res.message : "Unspecified error",
            });
        }

        return propertyPaymentsData;
    }

    async handleInputBlur (key) {
        let data = this.state.data;
        if ((key === 'LOAN_CLOSING_DATE' || key === 'CLOSE_OF_ESCROW') && (data.source === 'HSC' || data.hsc_financing)) {
            await this.getHscAgentsGrossCumulative(data);

            hscAgentsKeys.filter(key => data[key] != null).map(key => {
                this.computeHscAgentFees(data, key);
            });
        }
    }

    async handleChangeInput (key, value){
        if (value === undefined) {
            this.setData(key, !this.state.data[key]);
        }  else {
            const isAgentPercent = agentKeyPercents.includes(key);
            await this.setData(key, value, isAgentPercent);
            if(!value){
                this.setData("lease_expiration_date", value);    
                return;
            }
            if(key==='lease_commencement_date'){
                const transformedDate = new Date(value);
                const ledYear= new Date(this.state.data['lease_expiration_date']).getFullYear();
                const lcdYear= new Date(this.state.data['lease_commencement_date']).getFullYear();
                let year = ledYear ||  lcdYear;      
                if(ledYear <lcdYear){
                    year = lcdYear;
                }          
                let month = transformedDate.getMonth();
                var lastDay = new Date(year, transformedDate.getMonth(), 0).getDate();
                if(transformedDate.getDate()>14){      
                    month = month+2;
                    if(month==13){
                        month=1;
                        year = year+1;
                    }

                    lastDay = new Date(year, transformedDate.getMonth() + 2, 0).getDate();
                }else{
                    if(month<1){
                        month=12;
                        year = year-1;
                    }
                }
                const _value = month+"/"+lastDay+"/"+year;
                this.setData("lease_expiration_date", _value);
            }
        }

    }

    handleNotesChange(updatedNotes, editId) {
  const { data } = this.state;
  const propertyLattitude = data && data.latitude ? parseFloat(data.latitude) : null
  const propertyLongitude = data && data.longitude ? parseFloat(data.longitude) : null
  const cleanedNotes = updatedNotes
    .filter(note => note.NOTES && note.NOTES.trim() !== "")
    .filter(note => {
      if (!note.ARCIMEDES_ROW_ID) return true;                 // new note
      if (editId && note.ARCIMEDES_ROW_ID === editId) return true; // edited note
      if (note.deleted === 1) return true;                     // deleted note
      return false;                                            // skip others
    })
    .map(
      ({
        __typename,
        arcimedes_created,
        arcimedes_modified,
        arcimedes_created_by,
        arcimedes_modified_by,
        temp_id,
        date,
        NOTES,
        user_name,
        CREATED_BY,
        user_id,
        PROPERTY_ID,
        MODIFIED_BY,
        MODIFIED,
        LONGITUDE,
        LATITUDE,
        DELETED,
        CREATED,
        ARCIMEDES_ROW_ID,
        ADDRESS,
        ...rest
      }) => ({
        ...rest,
        notes: NOTES,
        created_by: user_name,
        modified_by: user_name,
        property_id: data.arcimedes_row_id || null,
        latitude:propertyLattitude,
        longitude:propertyLongitude,
        arcimedes_row_id : ARCIMEDES_ROW_ID ? ARCIMEDES_ROW_ID : null
      })
    );

  //  Ensure state update happens after latest value is available
  this.setState({ propertyNotesData: cleanedNotes });
}

    handleHscPaymentsChangeDropdown({data,key,index}){
        if(key === 'hsc_team_member_id'){
            const teamMemberKey = `hsc_team_member_${index+1}`;

            this.setData(teamMemberKey, data.hsc_team_member_id);
        }
    }

    handleHscPaymentsChangeInput({index, key, value}) {
        const newKey = 'hsc_team_member_'+(index+1)+key.split('hsc_team_member')[1];
        this.setData(newKey, value);
    }

    handlePaymentsChangeDropdown({data, key, index}) {
        this.setPaymentsData({key, value: data[key], index});
    }

    handleLoanQuotesChangeInput(key, value) {
        this.setLoanQuotesData(key, value);
    }

    handleLoanQuotesChangeDropdown(query, queryType, x, key) {
        this.setLoanQuotesData(key, query[key]);
    }

    handlePrintPagesDropDown(key,value){
        this.setLoanQuotesData(value, key);
    }

    handleChangeSeller() {
        const data = this.state.data;
        data.seller_id = null;
        this.setState({
            data: data
        });
    }

    handleChangeDropdown(query, queryType, x, key, key2) {
        const isAgentPercent = agentKeyPercents.includes(key);
        if (["listing_agent_4", "buyer_agent_4"].includes(key))
            this.setData(key, query[key], isAgentPercent, key + "_firm", query[key + "_firm"]);
        else if (key === "seller_id") {
            this.setState({sellerSelected: true}, () =>
                this.setData(key, query[key], isAgentPercent)
            );
        } else this.setData(key, query[key], isAgentPercent, key2, query[key2]);
    }

    handleSellerChangeInput(key, value) {
        this.setState({seller: {...this.state.seller, [key]: value}});
    }

    handleSellerChangeDropdown(query, queryType, x, key) {
        if (key === "seller_id") {
            this.setState({sellerSelected: true}, () =>
                this.setData(key, query[key])
            );
        } else this.setState({seller: {...this.state.seller, [key]: query[key]}});
    }
    handleClick(key, value) {
        this.setState((prevState) => {
            const newValue = key === "hot_list"
                ? (prevState.data[key] === "1" ? "0" : "1")
                : value;
    
            return {
                data: {
                    ...prevState.data,
                    [key]: newValue
                }
            };
        });
    }

  getTenantsForTags(tenantIds) {
  if (!tenantIds || !Array.isArray(tenantIds)) return [];

  const tenantsBySQFT = this.state.tenantsBySQFT || [];
  
  const allTenantsById = this.state.allTenantsById || {};
  const response = [];

  for (let i = 0; i < tenantIds.length; i++) {
    const id = tenantIds[i];
    const tenant = allTenantsById[id];
    if (!tenant) continue;

    const first = tenant.first_name;
    const last = tenant.last_name;
    const nameField = tenant.name;

    const isNotVacant =
      (first && first.toLowerCase() !== "vacant") ||
      (last && last.toLowerCase() !== "vacant") ||
      (nameField && nameField.toLowerCase() !== "vacant");

    if (!isNotVacant) continue;

    const sqftObj = tenantsBySQFT.find((t) => t.tenant_id == id);
    const sqft = sqftObj && sqftObj.rr_sqft ? parseInt(sqftObj.rr_sqft) : 0;

    let name = "";
    if (first && last) {
      name = `${first} ${last}`;
    } else if (nameField) {
      name = nameField;
    }

    response.push({ arcimedes_row_id: id, name, sqft });
  }

  response.sort((a, b) => b.sqft - a.sqft);
  response.splice(defaultVisibleTenants, response.length - defaultVisibleTenants);
  response.forEach((el) => {
    delete el.sqft;
  });
  return response;
}

 setValue(updates) {
        this.setState({data: {...this.state.data, ...updates}});
    }

 setDataFromFinancials({ newData, savedTenants, newTenants }) {
  const state = {};

  if (newData) {
    state.data = newData;
  }

  if (newTenants && newTenants.length) {
    let tenants = this.state.allTenants || [];
    let tenantsById = this.state.allTenantsById || {};

    // Merge newTenants into tenants array
    tenants = tenants.concat(newTenants);

    // Merge newTenants into tenantsById object
    const newTenantsById = {};
    newTenants.forEach((t) => {
      if (t.arcimedes_row_id) {
        newTenantsById[t.arcimedes_row_id] = t;
      }
    });

    tenantsById = { ...tenantsById, ...newTenantsById };

    state.allTenants = tenants;
    state.allTenantsById = tenantsById;
  }

  if (newData || (newTenants && newTenants.length)) {
    this.setState(state, () => {
      if (newData) {
        this.checkCoordinatesAndSave(newData, this.state.original, savedTenants);
      }
    });
  }
}


    async calculateGrossAmount(){ 
        this.setState({recomputePayments: false});    
        const data = this.state.data;
        if(data.net_fee){
            let q = {
                AGENT_ID: data.listing_agent_1,
                YEAR: new Date().getFullYear(),//year === 0 ? prevYear : year ,
                order:'CLOSE_OF_ESCROW.asc'
            }   

            const options = filter(q, 'agent-commission');
            const token = localStorage.getItem('authToken');
            const optionsYear = parseInt(options.param.YEAR);
            const optionsAgentId = parseInt(options.param.AGENT_ID);
            Promise.all([
                // executeQuery({queryName: AGENT_COMMISSION_PROCURED, options}),
                // executeQuery({queryName: AGENT_COMMISSION_PAID, options})
                // this.client.query({ query: GET_AGENT_COMMISSION_PROCURED, variables:{year: optionsYear, agentId: optionsAgentId},
                //     fetchPolicy: "no-cache",
                //     context: {
                //       headers: {
                //         authorization: `Bearer ${token}`,
                //       },
                //     } }),
                    fetchData(GET_AGENT_COMMISSION_PROCURED,{year: optionsYear, agentId: optionsAgentId}),
                // this.client.query({ query: GET_AGENT_COMMISSION_PAID, variables:{options:{year: optionsYear, agent_id: optionsAgentId}},
                //     fetchPolicy: "no-cache",
                //     context: {
                //       headers: {
                //         authorization: `Bearer ${token}`,
                //       },
                //     } }),
                    fetchData(GET_AGENT_COMMISSION_PAID,{options:{year: optionsYear, agent_id: optionsAgentId}}),
            ]).then(res => {
                if (res && res[0] && res[0].data && Array.isArray(res[0].data.agentCommissionProcured) &&
                res[1] && res[1] && res[1].data && Array.isArray(res[1].data.agentCommissionPaid)){                
                    let grossCumulative = 0;
                    let netProcured = 0;
                    let prevProcuredCumulative = 0;
                    let netPaid = 0;
                    let currentTrenche = 0;
                    let paidData = removeDuplicateObjects(res[1].data.agentCommissionPaid.filter(property => property.member_id === data.listing_agent_1));
                    let map = new Map();
                    res[0].data.agentCommissionProcured.forEach(item =>{ 
                        map.set(item.arcimedes_row_id, item)
                    });
                    paidData.forEach(item => {
                        if (map.has(item.arcimedes_row_id)) {
                            let team_member_gross_fee = item.team_member_gross_fee;
                            map.set(item.arcimedes_row_id, {...map.get(item.arcimedes_row_id), team_member_gross_fee});
                        } else {
                            map.set(item.arcimedes_row_id, item);
                        }
                    });
                    const mergedArray =  Array.from(map.values());  
                    mergedArray.sort(compareDates);
                    mergedArray.forEach((agentObj,index) => {
                    const listingProcuredGrossFee = agentObj.listing_gross_commission ? parseFloat(agentObj.listing_gross_commission) : 0;
                    const buyingProcuredGrossFee = agentObj.buying_gross_commission ? parseFloat(agentObj.buying_gross_commission) : 0;
                    const totalProcuredGrossFee = listingProcuredGrossFee + buyingProcuredGrossFee;                       
                    let teamMemberGrossFee = agentObj.team_member_gross_fee ? parseFloat(agentObj.team_member_gross_fee) : 0;
                    grossCumulative += totalProcuredGrossFee;

                    if (grossCumulative <= 200000  ) {
                        netProcured += totalProcuredGrossFee * 0.5; 
                        netPaid += teamMemberGrossFee * 0.5;
                    }else if(grossCumulative>200000 && grossCumulative<=400000 ){                 
                        if(prevProcuredCumulative<200000){
                            if(teamMemberGrossFee >= (200000 - prevProcuredCumulative) ) {
                                netProcured += (200000 - prevProcuredCumulative)*0.5+(grossCumulative - 200000)*0.55;
                                netPaid += (200000 - prevProcuredCumulative)*0.5 + (teamMemberGrossFee - (200000 - prevProcuredCumulative))* 0.55;
                            } else {
                                netProcured += (200000 - prevProcuredCumulative)*0.5+(grossCumulative - 200000)*0.55;
                                netPaid += (teamMemberGrossFee-(grossCumulative-200000)) * 0.5 + (grossCumulative - 200000) * 0.55;
                            }
                        }else{
                            netProcured += totalProcuredGrossFee * 0.55;  
                            netPaid += teamMemberGrossFee * 0.55;
                        }                               
                    }else if(grossCumulative>400000 && grossCumulative<=600000 ){                   
                        if(prevProcuredCumulative<400000){
                            if(teamMemberGrossFee >= (400000 - prevProcuredCumulative) ) {
                                netProcured += (400000 - prevProcuredCumulative)*0.55+(grossCumulative - 400000)*0.6;
                                netPaid += (400000 - prevProcuredCumulative)*0.55 + (teamMemberGrossFee - (400000 - prevProcuredCumulative))* 0.6;
                            } else {
                                netProcured += (400000 - prevProcuredCumulative)*0.55+(grossCumulative - 400000)*0.6;
                                netPaid += (teamMemberGrossFee-(grossCumulative-400000)) * 0.55 + (grossCumulative - 400000) * 0.6;
                            }
                        }else{
                            netProcured += totalProcuredGrossFee * 0.6; 
                            netPaid += teamMemberGrossFee * 0.6; 
                        }                           
                    }else if(grossCumulative>600000 && grossCumulative<=800000 ){                  
                        if(prevProcuredCumulative<600000){
                            if(teamMemberGrossFee >= (600000 - prevProcuredCumulative) ) {
                                netProcured += (600000 - prevProcuredCumulative)*0.6+(grossCumulative - 600000)*0.65;
                                netPaid += (600000 - prevProcuredCumulative)*0.6 + (teamMemberGrossFee - (600000 - prevProcuredCumulative))* 0.65;
                            } else {
                                netProcured += (600000 - prevProcuredCumulative)*0.6+(grossCumulative - 600000)*0.65;
                                netPaid += (teamMemberGrossFee-(grossCumulative-600000)) * 0.6 + (grossCumulative - 600000) * 0.65;
                            }
                        }else{
                            netProcured += totalProcuredGrossFee * 0.65; 
                            netPaid += teamMemberGrossFee * 0.65;  
                        } 
                    }else if(grossCumulative>800000 ){                  
                        if(prevProcuredCumulative<800000){
                            if(teamMemberGrossFee >= (800000 - prevProcuredCumulative) ) {
                                netProcured += (800000 - prevProcuredCumulative)*0.65+(grossCumulative - 800000)*0.7;
                                netPaid += (800000 - prevProcuredCumulative)*0.65 + (teamMemberGrossFee - (800000 - prevProcuredCumulative))* 0.7;
                            } else {
                                netProcured += (800000 - prevProcuredCumulative)*0.65 +(grossCumulative - 800000)*0.7;
                                netPaid += (teamMemberGrossFee-(grossCumulative-800000)) * 0.65 + (grossCumulative - 800000) * 0.7;
                            }
                        }else{
                            netProcured += totalProcuredGrossFee * 0.7;  
                            netPaid += teamMemberGrossFee * 0.7;  
                        }
                    }                           
                    prevProcuredCumulative = grossCumulative;  
                });
                // if(insertionIndex === index){
                //     currentTrenche = getCurrentTrancheOnGrossAmount(grossCumulative)
                //     return 0;
                // }
            //    let extraPaymentNetFee = parseFloat(data.NET_FEE.replace(/,/g, ''));
                if (grossCumulative <= 200000  ) {
                    currentTrenche = 0.50;                            
                }else if(grossCumulative>200000 && grossCumulative<=400000 ){
                    currentTrenche = 0.55;                             
                }else if(grossCumulative>400000 && grossCumulative<=600000 ){
                    currentTrenche = 0.60;                
                }else if(grossCumulative>600000 && grossCumulative<=800000 ){
                    currentTrenche = 0.65;                               
                }else if(grossCumulative>800000 ){
                    currentTrenche = 0.70;                               
                }
                data['tranche'] = ( currentTrenche * 100 ).toString(); 
                data['referral_fee'] = (parseFloat(data.net_fee.replace(/,/g, ''))/currentTrenche).toFixed(2);
                this.setData('referral_fee', (parseFloat(data.net_fee.replace(/,/g, ''))/currentTrenche).toFixed(2)); 
                this.setState({ 
                    netFee:(parseFloat(data.net_fee.replace(/,/g, ''))).toFixed(2),
                    tranche: (currentTrenche * 100).toString(), 
                    data: convertDataToForm(data)
                });
                }

            });    
        }


   }
    openFinancialsSpreadsheet() {
        let token = localStorage.getItem("authToken");
        // create new empty property and the fetch the id to pass it to the underwriting
        if (!this.state.data.arcimedes_row_id) {
            this.setState({isBusy: true});
            const data = this.state.data;
            data.sqft = data.sqft && data.sqft.replace(/,/g, "")
            data.vacancy = parseInt(data.vacancy); 
            data.negotiation_cap_rate = parseFloat(data.negotiation_cap_rate);
            // request(arc.path.api, {
            //     service: "arcimedes",
            //     action: "open.datasource.table.Data.updateByTableCode",
            //     params: [PROPERTIES, {
            //         value: [data],
            //     },],
            delete data.date_created;
            delete data.last_modified_date;
            delete data.strengths;
            delete data.challenges;
            delete data.buyer_pool;
            delete data.qualifications;
            delete data.recommendations;
            data.proforma_cap_rate = data.proforma_cap_rate && data.proforma_cap_rate.toString();
            if(data.listing_agent_4_firm == null || data.listing_agent_4_firm === ""){
                delete data.listing_agent_4_firm
            }
            //     this.client.mutate({
            //         mutation: PROPERTIES_MUTATION,
            //         variables: {
            //             input: [data],
            //         },
            //         fetchPolicy: "no-cache",
            //         context: {
            //           headers: {
            //             authorization: `Bearer ${token}`,
            //           },
            //         }
            // })
            mutateData(PROPERTIES_MUTATION,{input: [data],}).then((res) => {
                if (res && res.data.createOrUpdateProperty.success && Array.isArray(res.data.createOrUpdateProperty.data) && res.data.createOrUpdateProperty.data.length) {
                    const newData = this.state.data;
                    newData.arcimedes_row_id = res.data.createOrUpdateProperty.data[0].arcimedes_row_id;
                    this.setState({
                        newPropertyId: res.data.createOrUpdateProperty.data[0].arcimedes_row_id,
                        data: newData,
                        isBusy: null,
                        financialsSpreadsheetInView: true,
                    });
                } else {
                    this.setState({
                        isBusy: null,
                        error: res && res.data.createOrUpdateProperty.message ? res.data.createOrUpdateProperty.message : "Unspecified error",
                    });
                }
            });
        } else {
            this.setState({
                financialsSpreadsheetInView: true,
            });
        }
    }

    closeFinancialsSpreadsheet(notSaved, error) {
        this.setState({financialsSpreadsheetInView: false});
        const isAgentWithRestriction = this.props.isAgent && !isAgentUser(this.props.userData)
        if (isAgentWithRestriction) {
            const route = {
                pathname: "/list",
                search: "?source=STRIVE&status=Active&transaction_type=Investment+Sales",
            };
            if (error && !notSaved) {
                route.state = {error: error};
            }
            if (!error && !notSaved) {
                route.state = {success: "Saved"};
            }
            browserHistory.push(route);
        }

        // delete the new empty property in case nothing was saved
        if (notSaved && this.state.newPropertyId) {
            this.setState({isBusy: true});
            const data = this.state.data;
            data.vacancy = parseInt(data.vacancy); 
            data.negotiation_cap_rate = parseFloat(data.negotiation_cap_rate);
            data.arcimedes_row_id = this.state.newPropertyId;
            data.proforma_cap_rate = data.proforma_cap_rate && data.proforma_cap_rate.toString();
            data.deleted = 1;
            // request(arc.path.api, {
            //     service: "arcimedes",
            //     action: "open.datasource.table.Data.updateByTableCode",
            //     params: [PROPERTIES, {
            //         value: [data],
            //     },],
            // this.client.mutate({
            //     mutation: PROPERTIES_MUTATION,
            //     variables: {
            //         input: [data],
            //     },
            //     fetchPolicy: "no-cache",
            //     context: {
            //       headers: {
            //         authorization: `Bearer ${token}`,
            //       },
            //     }
            // })
            mutateData(PROPERTIES_MUTATION,{input: [data], }).then((res) => {
                if (res && res.data.createOrUpdateProperty.success && Array.isArray(res.data.createOrUpdateProperty.data) && res.data.createOrUpdateProperty.data) {
                    data.deleted = null;
                    this.setState({
                        data: data,
                        newPropertyId: null,
                        isBusy: null,
                    });
                } else {
                    this.setState({
                        isBusy: null,
                        error: res && res.message ? res.message : "Unspecified error",
                    });
                }
            });
        }
    }

    toggleDrawer() {
        this.setState((prevState) => ({showDrawer: !prevState.showDrawer, resetDrawer:false}));
    }

    showHistoryDeleteModal(rowId){
        this.setState({showModal:true, historyDeleteRowId:rowId});
    }

    handleDeleteHistory(rowId){
        let token = localStorage.getItem('authToken');
        const rowToUpdate = {
            arcimedes_row_id:rowId,
            deleted:1
        };
        this.setState({showModal:false}, ()=>{
            //manageData({tableCode: PROPERTY_HISTORY, data: rowToUpdate 
            //     this.client.mutate({
            //         mutation: PROPERTY_HISTORY_MUTATION, variables:{input:rowToUpdate},
            //         fetchPolicy: "no-cache",
            //         context: {
            //             headers: {
            //                 authorization: `Bearer ${token}`,
            //             },
            //         }
           
            // })
            mutateData(PROPERTY_HISTORY_MUTATION,{input:rowToUpdate}).then(res => {
                if (!res || !res.data.createOrUpdatePropertyHistory.success) {
                    this.setState({
                        error: res && res.data.createOrUpdatePropertyHistory.message ? res.data.createOrUpdatePropertyHistory.message : "Unspecified error",
                    });
                } else {
                    let historyData = this.state.historyData;
                    let rowIndex;
                    historyData.forEach((el, index) => {
                        if(el.arcimedes_row_id === rowId)
                            rowIndex = index;
                    });
                    delete historyData[rowIndex];
                    this.setState({
                        historyData,
                        isBusy: null,
                        success: "History row deleted successfully",
                    });
                }
            });
        });
    }

    addNewItem(addNewItemType) {
        this.setState({addNewItemType}, this.toggleDrawer);
    }

    savedNewItem(newData, newFirm) {
        // select the new item id & close drawer
        const key = this.state.addNewItemType;
        const updatedValue =
          key === "seller_id" || key === "buyer_id"
            ? newData.contact_id
            : newData.arcimedes_row_id;
        const state = {
          data: { ...this.state.data, [key]: updatedValue },
        };

        switch (key) {
            case "seller_id": {
                state.newSeller = newData;
                state.seller = {};

                if(state.newSeller.status ==='Off-Market')
                    state.data.status = 'Off Market';
                sellerKeys.forEach(key => {
                    state.seller[key] = newData[key];
                });
                break;
            }
            case "buyer_id": {
                state.newBuyer = newData;
                state.buyer = {};
                sellerKeys.forEach((key) => {
                    state.buyer[key] = newData[key];
                });
                break;
            }
            case "listing_agent_4":
                state.newAgent = newData;
                if (newFirm) {
                    state.newFirm = newFirm;
                    state.data["listing_agent_4_firm"] = newData.firm;
                } else {
                    state.data["listing_agent_4_firm"] = newData.firm;
                }
                break;
            case "buyer_agent_4":
                state.newAgent = newData;
                if (newFirm) {
                    state.newFirm = newFirm;
                    state.data["buyer_agent_4_firm"] = newData.firm;
                } else {
                    state.data["buyer_agent_4_firm"] = newData.firm;
                }
                break;
            case "referred_by_id":
                state.newAgent = newData;
                state.data["referred_by_type"] = 'oa';
                break;
            case "listing_agent_4_firm":
                state.newFirm = newData;
                break;
            case "buyer_agent_4_firm":
                state.newFirm = newData;
                break;
            case "lender_id":
                state.newLender = newData;
                break;
                 case "referring_listing_agent":
                state.newAgent = newData;
                if (newFirm) {
                    state.newFirm = newFirm;
                    state.data["referring_listing_agent_firm"] = newData.firm;
                } else {
                    state.data["referring_listing_agent_firm"] = newData.firm;
                }
                break;
            case "referring_listing_agent_firm":
                state.newFirm = newData;
                break;
            case "referring_buyer_agent":
                state.newAgent = newData;
                if (newFirm) {
                    state.newFirm = newFirm;
                    state.data["referring_buyer_agent_firm"] = newData.firm;
                } else {
                    state.data["referring_buyer_agent_firm"] = newData.firm;
                }
                break;
            case "referring_buyer_agent_firm":
                state.newFirm = newData;
                break;
        }
        this.setState(state, () => this.toggleDrawer());
    }

    getDrawerComponent() {
        const component = this.state.addNewItemType;
        const resetDrawer = this.state.resetDrawer;
        //in the below scenarios chanaged all case values to lowercase to see tha drawer components
        //for ex SELLER_ID changed as seller_id
        switch (component) {
            case "seller_id":
                return (
                    <InvestorDrawer
                        savedNewItem={this.savedNewItem}
                        closeDrawer={this.closeDrawer}
                        resetDrawer={resetDrawer}
                    />
                );
            case "buyer_id":
                return (
                    <InvestorDrawer
                        savedNewItem={this.savedNewItem}
                        closeDrawer={this.closeDrawer}
                        resetDrawer={resetDrawer}
                    />
                );
            case "listing_agent_4":
            case "buyer_agent_4":
            case "referring_listing_agent":
            case "referring_buyer_agent":
            case "referred_by_id":
                return (
                    <AgentDrawer
                        savedNewItem={this.savedNewItem}
                        closeDrawer={this.closeDrawer}
                        resetDrawer={resetDrawer}
                    />
                );
            case "listing_agent_4_firm":
            case "buyer_agent_4_firm":
                return (
                    <FirmDrawer
                        savedNewItem={this.savedNewItem}
                        closeDrawer={this.closeDrawer}
                        resetDrawer={resetDrawer}
                    />
                );
            case "referring_listing_agent_firm":
              return (
                    <FirmDrawer
                        savedNewItem={this.savedNewItem}
                        closeDrawer={this.closeDrawer}
                        resetDrawer={resetDrawer}
                    />
                );
            case "referring_buyer_agent_firm":
                return (
                    <FirmDrawer
                        savedNewItem={this.savedNewItem}
                        closeDrawer={this.closeDrawer}
                        resetDrawer={resetDrawer}
                    />
                );
            case "lender_id":
                return (
                    <LenderDrawer
                        savedNewItem={this.savedNewItem}
                        closeDrawer={this.closeDrawer}
                        resetDrawer={resetDrawer}
                    />
                );
        }
    }

    redirectToEscrowTracking() {
        const id = this.state.data.arcimedes_row_id;
        browserHistory.push({
            pathname: `${arc.path.base}escrow-tracking/${id}`,
            state: id
        });
    }

    redirectToHscTracking() {
        const id = this.state.data.arcimedes_row_id;
        browserHistory.push({
            pathname: `${arc.path.base}hsc-tracking/${id}`,
            state: id
        });
    }

    handleConfirmEscrow() {
        this.setState({ openEscrowDialog: false });
        this.setState({viewMode: false})
    }

    handleEscrowDateError() {
        this.setState({ openEscrowDateError: false });
        this.setState({ viewMode: false })
    }

    getTabs({data, loanQuotesData, isAgent, seller, edit, isReferral, isFinancing, isDB, showTabsForStatus, isStriveFinancing, isStriveClosed, isOtherFinancing, isSeniorAgent, isExtraPayment}) {
        let tabs = [{
            name: "PROPERTY",
            renderedComponent: (
                <PropertyInfo
                    isAgent={isAgent}
                    data={data}
                    handleChangeDropdown={this.handleChangeDropdown}
                    handleChangeInput={this.handleChangeInput}                        
                    handleChangeFile={this.handleChangeFile}
                    getTenantsForTags={this.getTenantsForTags}
                    tenantTags={this.state.tenantTags}
                    handleClick={this.handleClick}
                    viewMode={this.state.viewMode}
                    deleted={data && data.deleted === "1"}
                    isReferral={isReferral}
                    isFinancing={isFinancing}
                    isStriveFinancing={isStriveFinancing}
                    redirectToHscTracking={this.redirectToHscTracking}
                    isSeniorAgent={isSeniorAgent}
                    isExtraPayment={isExtraPayment}
                    hideTransactionType={isDB}
                />
            ),
        },
        {
            name: "PROPERTY GROUPS",
            renderedComponent: (
                <PropertyGroupsTab
                    data={data}
                    viewMode={this.state.viewMode}
                    ownerAgentId={this.context.userData && this.context.userData.id}
                />
            ),
        },
        {
                name: "NOTES",
                renderedComponent: (
                  <PropertyNotes
                  data={data}
                    notes={data && data.notes ? data.notes : []}
                    contact_id = {data && data.contact_id ? data.contact_id : null}
                    viewMode={this.state.viewMode}
                    handleChangeInput={this.handleChangeInput}
                    ref={this.notesRef}
                    //deleted={data && data.DELETED === "1"}
                    deleted={data && data.deleted === "1"}
                   setState={this.setState.bind(this)}
                    onNotesChange={this.handleNotesChange}
                    state={this.state}
                  />
                ),
        },
    ];

        if (isDB && !showTabsForStatus) {
                tabs.push({
                    name: "Financials",
                    renderedComponent: (
                        <PropertyFinancials
                            isAgent={isAgent}
                            data={data}
                            handleChangeInput={this.handleChangeInput}
                            openFinancialsSpreadsheet={this.openFinancialsSpreadsheet}
                            viewMode={this.state.viewMode}
                            deleted={data && data.deleted === "1"}
                            isDB
                        />
                    ),
                },
                {
                    name: "Ownership",
                    renderedComponent: (
                        <OwnershipInfo
                            isAgent={isAgent}
                            seller={seller}
                            data={data}
                            handleChangeDropdown={this.handleChangeDropdown}
                            handleChangeSeller={this.handleChangeSeller}
                            handleSellerChangeDropdown={this.handleSellerChangeDropdown}
                            handleSellerChangeInput={this.handleSellerChangeInput}
                            addNewItem={this.addNewItem}
                            viewMode={this.state.viewMode}
                            deleted={data && data.deleted === "1"}
                            edit={edit}
                            sellerSelected={this.state.sellerSelected}
                            newSeller={this.state.newSeller}
                            newBuyer={this.state.newBuyer}
                            isDB
                        />
                    ),
                },
                {
                    name: "HISTORY",
                    className: 'property-history',
                    renderedComponent: (
                        <PropertyHistory
                            query={this.props.location.query}
                            data={this.state.historyData}
                            deleted={data && data.deleted === "1"}
                            handleDeleteHistory={this.showHistoryDeleteModal}
                            viewMode={this.state.viewMode}
                            propertyPath={this.props.location.pathname + this.props.location.search}
                            isDB
                        />
                    ),
                },
                {
                    name: "WEBSITE",
                    renderedComponent: (
                        <Website
                            isAgent={isAgent}
                            data={data}
                            handleChangeInput={this.handleChangeInput}
                            handleChangeFile={this.handleChangeFile}
                            viewMode={this.state.viewMode}
                            deleted={data && data.deleted === "1"}
                            isDB
                        />
                    ),
                },
                // {
                //     name: "SALE INFO",
                //     renderedComponent: (
                //         <SaleInformation
                //             isAgent={isAgent}
                //             data={data}
                //             handleChangeInput={this.handleChangeInput}
                //             handleInputBlur={this.handleInputBlur}
                //             handleChangeDropdown={this.handleChangeDropdown}
                //             viewMode={this.state.viewMode}
                //             deleted={data && data.deleted === "1"}
                //             isDB
                //         />
                //     ),
                // }
            );
            return tabs;
            }

        else if (isFinancing) {
            tabs.push({
                name: "FINANCIALS",
                renderedComponent: (
                    <PropertyFinancials
                        isAgent={isAgent}
                        data={data}
                        handleChangeInput={this.handleChangeInput}
                        openFinancialsSpreadsheet={this.openFinancialsSpreadsheet}
                        viewMode={this.state.viewMode}
                        deleted={data && data.deleted === "1"}
                        isFinancing
                    />
                ),
            }, {
                name: "OWNERSHIP",
                renderedComponent: (
                    <OwnershipInfo
                        isAgent={isAgent}
                        seller={seller}
                        data={data}
                        handleChangeDropdown={this.handleChangeDropdown}
                        handleChangeSeller={this.handleChangeSeller}
                        handleSellerChangeDropdown={this.handleSellerChangeDropdown}
                        handleSellerChangeInput={this.handleSellerChangeInput}
                        addNewItem={this.addNewItem}
                        viewMode={this.state.viewMode}
                        deleted={data && data.deleted === "1"}
                        edit={edit}
                        sellerSelected={this.state.sellerSelected}
                        newSeller={this.state.newSeller}
                        newBuyer={this.state.newBuyer}
                        isFinancing
                    />
                ),
            }, {
                name: "LOAN QUOTES",
                className: 'loan-quotes',
                renderedComponent: (
                    <LoanQuotes
                        printTitle={data && `${data.name} - ${data.city}, ${data.state}`}
                        data={loanQuotesData}
                        NOIPercent={data && data.noi_percent}
                        handleChangeInput={this.handleLoanQuotesChangeInput}
                        handleChangeDropdown={this.handleLoanQuotesChangeDropdown}
                        handlePrintPagesDropDown={this.handlePrintPagesDropDown}
                        viewMode={this.state.viewMode}
                        deleted={data && data.deleted === "1"}
                        hscTeamMemberIds={ !!data ? hscTeamMembers.find((e)=> e.EMAIL === data['hsc_team_member_1']) : {EMAIL:''}}
                        addNewColumn={this.addNewColumn}
                        updateColumns={this.updateColumns} 
                        LoanType={data && data.loan_type}
                    />
                ),
            }, {
                name: "LOAN INFO",
                renderedComponent: (
                    <Loan
                        isAgent={isAgent}
                        isTeamMember={this.props.userData.email === data.hsc_team_member_1}
                        data={data}
                        handleChangeDropdown={this.handleChangeDropdown}
                        handleChangeInput={this.handleChangeInput}
                        handleInputBlur={this.handleInputBlur}
                        handleChangeFile={this.handleChangeFile}
                        addNewItem={this.addNewItem}
                        openHscPayments={this.openHscPayments}
                        displayedAgentsNr={this.state.displayedHSCAgents}
                        addHscMember = {this.addHscMember}
                        hscTeamMembers={hscAgentsKeys.map((key) => data[key])}
                        newLender={this.state.newLender}
                        newAgent={this.state.newAgent}
                        viewMode={this.state.viewMode}
                        deleted={data && data.deleted === "1"}
                    />
                ),
            }, {
                name: "SALE INFO",
                renderedComponent: (
                    <SaleInformation
                        isAgent={isAgent}
                        data={data}
                        handleChangeInput={this.handleChangeInput}
                        handleInputBlur={this.handleInputBlur}
                        handleChangeDropdown={this.handleChangeDropdown}
                        handleChangeFile={this.handleChangeFile}
                        viewMode={this.state.viewMode}
                        deleted={data && data.deleted === "1"}
                        isFinancing
                    />
                ),
            });

            if(!(data.loan_type === "Refi" || data.loan_type === "Construction")){
                tabs.push({
                    name: "BUYSIDE AGENT",
                    renderedComponent: (
                        <BuysideAgent
                            data={data}
                            handleChangeDropdown={this.handleChangeDropdown}
                            handleChangeInput={this.handleChangeInput}
                            addNewItem={this.addNewItem}
                            newAgent={this.state.newAgent}
                            newBuyer={this.state.newBuyer}
                            newFirm={this.state.newFirm}
                            viewMode={this.state.viewMode}
                            deleted={data && data.deleted === "1"}
                            isFinancing
                            isSeniorAgent={isSeniorAgent}
                        />
                    ),
                }, {
                    name: "LISTING AGENT",
                    renderedComponent: (
                        <ListingAgent
                            data={data}
                            handleChangeDropdown={this.handleChangeDropdown}
                            handleChangeInput={this.handleChangeInput}
                            addNewItem={this.addNewItem}
                            newAgent={this.state.newAgent}
                            newFirm={this.state.newFirm}
                            viewMode={this.state.viewMode}
                            deleted={data && data.deleted === "1"}
                            userData={this.props.userData}
                        />
                    ),
                })}
            } else if (isReferral) {
            tabs.push({
                name: "SALE INFO",
                renderedComponent: (
                    <SaleInformation
                        isAgent={isAgent}
                        data={data}
                        handleChangeInput={this.handleChangeInput}
                        handleInputBlur={this.handleInputBlur}
                        handleChangeDropdown={this.handleChangeDropdown}
                        handleChangeFile={this.handleChangeFile}
                        viewMode={this.state.viewMode}
                        deleted={data && data.deleted === "1"}
                        isReferral
                    />
                ),
            })
            if (data.arcimedes_row_id && data.close_of_escrow)
                tabs.push({
                    name: "PAYMENT",
                    renderedComponent: (
                        <PropertyPayments
                            paymentsData={this.state.propertyPaymentsData}
                            propertyData={data}
                            handleAddMember={this.handleAddMember}
                            handleChangeDropdown={this.handlePaymentsChangeDropdown}
                            handleChangeInput={this.setPaymentsData}
                            viewMode={this.state.viewMode}
                            deleted={data && data.deleted === "1"}
                            isAgent={isAgent}
                            isReferral
                        />
                    ),
                });

        }else if (isExtraPayment) {
            tabs.push({
                name: "SALE INFO",
                renderedComponent: (
                    <SaleInformation
                        isAgent={isAgent}
                        data={data}
                        handleChangeInput={this.handleChangeInput}
                        handleInputBlur={this.handleInputBlur}
                        handleChangeDropdown={this.handleChangeDropdown}
                        handleChangeFile={this.handleChangeFile}
                        viewMode={this.state.viewMode}
                        deleted={data && data.deleted === "1"}                     
                        isExtraPayment
                        calculateGrossAmount= {this.calculateGrossAmount}
                    />
                ),
            })            
        } else {
            tabs.push({
                name: "LISTING AGENT",
                renderedComponent: (
                    <ListingAgent
                        setParentState={this.setState.bind(this)}
                        data={data}
                        handleChangeDropdown={this.handleChangeDropdown}
                        handleChangeInput={this.handleChangeInput}
                        addNewItem={this.addNewItem}
                        newAgent={this.state.newAgent}
                        newFirm={this.state.newFirm}
                        viewMode={this.state.viewMode}
                        deleted={data && data.deleted === "1"}
                        userData={this.props.userData}
                    />
                ),
            },
                {
                    name: "PROPOSAL",
                    renderedComponent: (
                        <Proposal
                            data={this.state.proposalData}
                            handleChangeInput={this.handleChangeInput}
                            viewMode={this.state.viewMode}
                            deleted={data && data.deleted === "1"}
                        />
                    ),
                },
                {
                    name: "REP AGREEMENT",
                    renderedComponent: (
                        <RepresentationAgreement
                            isAgent={isAgent}
                            data={data}
                            handleChangeInput={this.handleChangeInput}
                            handleChangeFile={this.handleChangeFile}
                            viewMode={this.state.viewMode}
                            deleted={data && data.deleted === "1"}
                        />
                    ),
                }, {
                name: "FINANCIALS",
                renderedComponent: (
                    <PropertyFinancials
                        isAgent={isAgent}
                        data={data}
                        handleChangeInput={this.handleChangeInput}
                        openFinancialsSpreadsheet={this.openFinancialsSpreadsheet}
                        viewMode={this.state.viewMode}
                        deleted={data && data.deleted === "1"}
                    />
                ),
            }, {
                name: "OWNERSHIP",
                renderedComponent: (
                    <OwnershipInfo
                        isAgent={isAgent}
                        seller={seller}
                        data={data}
                        handleChangeSeller={this.handleChangeSeller}
                        handleSellerChangeDropdown={this.handleSellerChangeDropdown}
                        handleSellerChangeInput={this.handleSellerChangeInput}
                        addNewItem={this.addNewItem}
                        viewMode={this.state.viewMode}
                        deleted={data && data.deleted === "1"}
                        edit={edit}
                        sellerSelected={this.state.sellerSelected}
                        newSeller={this.state.newSeller}
                    />
                ),
            }, {
                name: "IN NEG/UNDER CONTRACT",
                    renderedComponent: (
                    <InNegotiationUnderContract
                        isAgent={isAgent}
                        data={data}
                        handleChangeInput={this.handleChangeInput}
                        handleChangeDropdown={this.handleChangeDropdown}
                        handleChangeFile={this.handleChangeFile}
                        redirectToEscrowTracking={this.redirectToEscrowTracking}
                        viewMode={this.state.viewMode}
                        deleted={data && data.deleted === "1"}
                        isStriveFinancing={isStriveFinancing}
                    />
                ),
            }, {
                name: "BUYSIDE AGENT",
                renderedComponent: (
                    <BuysideAgent
                        data={data}
                        handleChangeDropdown={this.handleChangeDropdown}
                        handleChangeInput={this.handleChangeInput}
                        addNewItem={this.addNewItem}
                        newAgent={this.state.newAgent}
                        newBuyer={this.state.newBuyer}
                        newFirm={this.state.newFirm}
                        viewMode={this.state.viewMode}
                        deleted={data && data.deleted === "1"}
                        isSeniorAgent = {isSeniorAgent}
                    />
                ),
            }, {
                name: "SALE INFO",
                renderedComponent: (
                    <SaleInformation
                        isAgent={isAgent}
                        isSeniorAgent={isSeniorAgent}
                        data={data}
                        handleChangeInput={this.handleChangeInput}
                        handleInputBlur={this.handleInputBlur}
                        handleChangeDropdown={this.handleChangeDropdown}
                        handleChangeFile={this.handleChangeFile}
                        viewMode={this.state.viewMode}
                        deleted={data && data.deleted === "1"}
                        isStriveFinancing={isStriveFinancing}
                    />
                ),
            });

            if (isStriveFinancing)
                tabs.push(
                    {
                        name: "LOAN QUOTES",
                        className: 'loan-quotes',
                        renderedComponent: (
                            <LoanQuotes
                                printTitle={data && `${data.name} - ${data.city}, ${data.state}`}
                                data={loanQuotesData}
                                NOIPercent={data && data.noi_percent}
                                LoanType={data && data.loan_type}
                                handleChangeInput={this.handleLoanQuotesChangeInput}
                                handleChangeDropdown={this.handleLoanQuotesChangeDropdown}
                                handlePrintPagesDropDown={this.handlePrintPagesDropDown}
                                viewMode={this.state.viewMode}
                                deleted={data && data.deleted === "1"}
                                hscTeamMemberIds={hscAgentsKeys.map(key => data[key])}
                                addNewColumn={this.addNewColumn}
                                updateColumns={this.updateColumns} 
                            />
                        ),
                    }, {
                        name: "LOAN INFO",
                        renderedComponent: (
                            <Loan
                                isAgent={isAgent}
                                isTeamMember={this.props.userData.email === data.hsc_team_member_1}
                                data={data}
                                handleChangeDropdown={this.handleChangeDropdown}
                                handleChangeInput={this.handleChangeInput}
                                handleInputBlur={this.handleInputBlur}
                                handleChangeFile={this.handleChangeFile}
                                displayedAgentsNr={this.state.displayedHSCAgents}
                                addHscMember = {this.addHscMember}
                                addNewItem={this.addNewItem}
                                openHscPayments={this.openHscPayments}                        
                                hscTeamMembers={hscAgentsKeys.map(key => data[key])}
                                newLender={this.state.newLender}
                                newAgent={this.state.newAgent}
                                viewMode={this.state.viewMode}
                                deleted={data && data.deleted === "1"}
                            />
                        ),
                    });

                if (isOtherFinancing)
                tabs.push({
                    name: "LOAN INFO",
                    renderedComponent: (
                        <Loan
                            isAgent={isAgent}
                            isTeamMember={this.props.userData.email === data.hsc_team_member_1}
                            data={data}
                            handleChangeDropdown={this.handleChangeDropdown}
                            handleChangeInput={this.handleChangeInput}
                            handleInputBlur={this.handleInputBlur}
                            handleChangeFile={this.handleChangeFile}
                            displayedAgentsNr={this.state.displayedHSCAgents}
                            addHscMember = {this.addHscMember}
                            addNewItem={this.addNewItem}
                            openHscPayments={this.openHscPayments}
                            hscTeamMembers={hscAgentsKeys.map(key => data[key])}
                            newLender={this.state.newLender}
                            newAgent={this.state.newAgent}
                            viewMode={this.state.viewMode}
                            deleted={data && data.deleted === "1"}
                        />
                    ),
                });
            if (!isFinancing) {
                tabs.push({
                    name: "HISTORY",
                    className: 'property-history',
                    renderedComponent: (
                        <PropertyHistory
                            query={this.props.location.query}
                            data={this.state.historyData}
                            deleted={data && data.deleted === "1"}
                            handleDeleteHistory={this.showHistoryDeleteModal}
                            viewMode={this.state.viewMode}
                            propertyPath={this.props.location.pathname + this.props.location.search}
                        />
                    )
                })
            }

            tabs.push({
                name: "WEBSITE",
                renderedComponent: (
                    <Website
                        isAgent={isAgent}
                        data={data}
                        handleChangeInput={this.handleChangeInput}
                        handleChangeFile={this.handleChangeFile}
                        viewMode={this.state.viewMode}
                        deleted={data && data.deleted === "1"}
                    />
                ),
            });

            if ((isStriveClosed || (data && data.buyer_agent_4_firm == buyer_agent4_firmvalue && data.source == "External" && data.status == "Closed")) && data.arcimedes_row_id)
                tabs.push({
                    name: "PAYMENT",
                    renderedComponent: (
                        <PropertyPayments
                            paymentsData={this.state.propertyPaymentsData}
                            propertyData={data}
                            handleAddMember={this.handleAddMember}
                            handleChangeDropdown={this.handlePaymentsChangeDropdown}
                            handleChangeInput={this.setPaymentsData}                            
                            viewMode={isSeniorAgent && data && data.source === 'STRIVE' && data.status && data.status.toLowerCase()==="closed" ? true : this.state.viewMode}
                            deleted={data && data.deleted === "1"}
                            isAgent={isAgent}
                        />
                    ),
                });
        }
        if(isSeniorAgent && (data && data.source=="External")){
            const _tabs=["PROPERTY","FINANCIALS", "SALE INFO", "PROPOSAL", "LISTING AGENT", "OWNERSHIP", "BUYSIDE AGENT"];
            tabs = tabs.filter((e) => _tabs.indexOf(e.name)>=0);
        }
        else if (isSeniorAgent){
            const _tabs=["PROPERTY","FINANCIALS", "SALE INFO", "PROPOSAL"]
            tabs = tabs.filter((e) => _tabs.indexOf(e.name)>=0);
        }
        return tabs;
    }

    onConfirm(){
        this.setState({isDialogueOpen: false});
        if(this.state.data.status === 'Active' && this.state.original.status !== 'Active'){            
            this.clearBuysideAgentFieldsAndUnderContratPrice();
        }
        const data = this.state.data;
        const original = this.state.original;
        this.setState({viewMode: true}, () =>
            this.checkCoordinatesAndSave(data, original)
        );
    }
    onCancel(){
        this.setState({isDialogueOpen: false, isBusy: false});
    }

 handlePropertyNotesUpdate(res) {
  try {
    const { propertyNotesData } = this.state;

    let newPropertyId = null;

    if (
      res &&
      Array.isArray(res) &&
      res.length > 0 &&
      res[0].data &&
      res[0].data.createOrUpdateProperty &&
      res[0].data.createOrUpdateProperty.data &&
      Array.isArray(res[0].data.createOrUpdateProperty.data) &&
      res[0].data.createOrUpdateProperty.data.length > 0 &&
      res[0].data.createOrUpdateProperty.data[0].arcimedes_row_id
    ) {
      newPropertyId = parseInt(
        res[0].data.createOrUpdateProperty.data[0].arcimedes_row_id
      );
    }

    if (!newPropertyId) {
      console.error("Invalid response: arcimedes_row_id not found.");
      return;
    }

    if (propertyNotesData && propertyNotesData.length > 0) {
      const updatedNotes = propertyNotesData.map(note => ({
        ...note,
        property_id: note.property_id === null ? newPropertyId : parseInt(note.property_id, 10),
      }));

      mutateData(PROPERTY_NOTES_MUTATION, { input: updatedNotes })
        .then(response => {
          console.log("Property notes updated successfully:", response);
        })
        .catch(error => {
          console.error("Error updating property notes:", error);
        });
    } else {
      console.log("No property notes to update.");
    }
  } catch (err) {
    console.error("Unexpected error in handlePropertyNotesUpdate:", err);
  }
}




    addNewColumn(e) {
        let newColumn = {
            "amortization": null,
            "bank": null,
            "bank_contact": null,
            "cap_rate": null,
            "cash_flow_annually": null,
            "cash_flow_monthly": null,
            "cash_on_cash": null,
            "debt_yield": null,
            "deleted": null,
            "down_payment": null,
            "down_payment_percent": null,
            "dscr": null,
            "interest_rate": null,
            "is_printable": 1,
            "loan_amount": null,
            "loan_payment_annually": null,
            "loan_payment_monthly": null,
            "loan_structure": null,
            "loan_term": null,
            "maturity": null,
            "noi": null,
            "noi_multiplied": null,
            "noi_percentage": null,
            "notes": null,
            "prepayment_penalty": null,
            "property_id": this.state.data.arcimedes_row_id,
            "purchase_price": null,
            "recourse": null,
            "total_origination_fee": null,
            "arcimedes_modified_by": this.props.userData.id && this.props.userData.id.toString(),
            "print_page_number": 1,
            "autopopulate": 0
          };
        this.setState({
            loanQuotesData: [...this.state.loanQuotesData,newColumn]
        })
    }
    updateColumns(updatedColumns) {
        this.setState({ loanQuotesData: updatedColumns });
    }

    // First + last name only - no company_name/email fallback, and never an id.
    // A deleted contact resolves to no name, which hides the header link entirely.
    getInvestorContactName(contact) {
        if (!contact || CRUDProperty.isDeletedInvestor(contact)) {
            return null;
        }
        const name = `${contact.first_name || ""} ${contact.last_name || ""}`.trim();
        return name || null;
    }

    renderInvestorHeaderLink() {
        const {data, buyer, newBuyer, seller, newSeller} = this.state;
        if (!data) {
            return null;
        }

        const isActiveListing = String(data.status) === "Active";
        let investorId = null;
        let investorContact = null;
        // Only the seller side is denormalized onto the property; there is no
        // buyer_first_name/buyer_last_name in any properties query.
        let fallbackName = null;

        // Ownership = Active (investor selling) → Ownership tab seller/investor.
        if (isActiveListing && data.seller_id) {
            investorId = data.seller_id;
            investorContact = seller || newSeller;
            fallbackName = this.getInvestorContactName({
                first_name: data.seller_first_name || data.sellers_first_name,
                last_name: data.seller_last_name || data.sellers_last_name,
            });
        // Ownership = Owned (investor bought) → Buyside Agent buyer/investor.
        } else if (data.buyer_id) {
            investorId = data.buyer_id;
            investorContact = buyer || newBuyer;
        } else if (data.seller_id) {
            investorId = data.seller_id;
            investorContact = seller || newSeller;
            fallbackName = this.getInvestorContactName({
                first_name: data.seller_first_name || data.sellers_first_name,
                last_name: data.seller_last_name || data.sellers_last_name,
            });
        }

        if (!investorId) {
            return null;
        }

        // A resolved contact is authoritative: if it is deleted, the investor is not
        // active and the link is hidden even when the property carries a stale name.
        const hasContact = investorContact && Object.keys(investorContact).length > 0;
        if (hasContact && CRUDProperty.isDeletedInvestor(investorContact)) {
            return null;
        }

        const investorName = this.getInvestorContactName(investorContact) || fallbackName;
        // Never fall back to the raw contact_id/arcimedes_row_id.
        if (!investorName) {
            return null;
        }

        // Prefer the contact_id the lookup resolved - buyer_id/seller_id may hold an
        // arcimedes_row_id, which the /investor/ route cannot open.
        const linkId = (hasContact && investorContact.contact_id) || investorId;

        const basePath = arc.path.base.endsWith("/")
            ? arc.path.base.slice(0, -1)
            : arc.path.base;
        const propertyPath =
            this.props.location.pathname + this.props.location.search;
        return (
            <div className="CRUD_content_owner-link">
                <span className="CRUD_content_label">Investor: </span>
                <Link
                    className="green"
                    to={{
                        pathname: `${basePath}/investor/${linkId}`,
                        state: {fromListUrl: propertyPath},
                    }}
                >
                    {investorName}
                </Link>
            </div>
        );
    }

    renderBuysideInvestorHeaderLink() {
        return this.renderInvestorHeaderLink();
    }

    render() {
        const {data, seller, loanQuotesData, recomputePayments, viewMode} = this.state;
        const isAgent = this.props.isAgent;
        const isSuper = this.props.isSuper;
        const isSeniorAgent = this.props.isSeniorAgent;
        const email = this.props.userData ? this.props.userData.email : "";
        const {edit} = this.props;
        const isReferral = data && data.transaction_type === 'Referral';
        const isFinancing = data && data.source === 'HSC';
        const showTabsForStatus = data && ['Active','In Negotiation','Under Contract'].includes(String(data.status));
        const isDB = data && typeof data.source === 'string' && data.source.toUpperCase() === 'DB';
        const isStriveFinancing = data && data.hsc_financing;
        const isStriveClosed = data && data.source === 'STRIVE' && data.status === 'Closed';
        const isOtherFinancing = data && data.other_financing;
        const isExtraPayment = data && data.transaction_type === 'Extra Payment';

        return (
            <ApolloConsumer>
                {
                    client => {
                        if (!this.client) {
                            this.client = client;
                        }
                        return (
                            <React.Fragment>
                            <PopupDialog
                                title={'Do you have an Amendment to the Rep Agreement to change the price?'} 
                                isOpen={this.state.isDialogueOpen} 
                                onConfirm={() => { this.onConfirm()}}
                                onCancel={() => {this.onCancel()}}
                            />
                <Modal show={this.state.showModal} onClose={()=>this.setState({showModal:false, historyDeleteRowId:null})}>
                    <div className="modal-content">
                        <span className='modal-title'> Do you really want to delete this row? </span>
                        <div className="modal-buttons">
                            <button className='button-new positive' onClick={()=>this.handleDeleteHistory(this.state.historyDeleteRowId)}>Yes</button>
                            <button className='button-new negative' onClick={()=>this.setState({showModal:false, historyDeleteRowId:null})}>No</button>
                        </div>
                    </div>
                </Modal>
                <Modal className='hsc-payments' show={this.state.showHscModal} onClose={()=>this.setState({showHscModal:false})}>
                    <div className='hsc-modal'>
                        <span className='green-title'>AthCap Payments </span>
                        <div className='close-button' onClick={()=>this.setState({showHscModal:false})}/>
                    </div>
                    <div className='hsc-modal-content'>
                        <PropertyPayments
                            propertyData={data}
                            handleChangeDropdown={this.handleHscPaymentsChangeDropdown}
                            handleChangeInput={this.handleHscPaymentsChangeInput}
                            deleted={data && data.deleted === "1"}
                            isAgent={isAgent}
                            viewMode={viewMode}
                            isHsc
                        />
                    </div>
                </Modal>
                <Dialog
        open={this.state.openEscrowDialog}
        onClose={this.handleCloseOfEscrow}
        fullWidth
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >

            <DialogTitle>
               Please, Enter a Close of Escrow Date in Sale Info Tab !!!
            </DialogTitle>
            <DialogActions>
          <Button onClick={this.handleConfirmEscrow.bind(this)} color="primary" autoFocus>
            Ok
          </Button>
            </DialogActions>
      </Dialog>
                <Dialog
                    open={this.state.openEscrowDateError}
                    fullWidth
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >

                    <DialogTitle>
                        Invalid Close of Escrow date format. Please use MM/DD/YYYY.
                    </DialogTitle>
                    <DialogActions>
                        <Button onClick={this.handleEscrowDateError.bind(this)} color="primary" autoFocus>
                            Ok
                        </Button>
                    </DialogActions>
                </Dialog>
                {this.state.openReminderDialog && <ReminderPropertyDialog handleReminderClose={() => {
                    this.setState({ openReminderDialog: false })
                }}
                    handleReminderAccept={(event) => {
                        this.setState({ openReminderDialog: false });
                        this.handleSubmit(event);
                    }}
                />}
                <CRUD
                    userData={this.context.userData}
                    isSeniorAgent={isSeniorAgent}
                    isSuper={isSuper}                   
                    originalData={data}
                    tabsData={this.getTabs({data, loanQuotesData, isAgent, seller, edit, isReferral, isFinancing, isDB, showTabsForStatus, isStriveFinancing, isStriveClosed, isOtherFinancing, isSeniorAgent, isExtraPayment, showTabsForStatus})}
                    currentPageRef={this.currentPageRef}
                    filterData={this.state.filterData}
                    currentIndex={this.state.currentIndex}
                    updateURL={this.updateURL}
                    // backToUrl={"list"}
                    backToUrl={getLastPropertiesListUrl()}
                    backName="PROPERTIES"
                    drawer={
                        <Drawer
                            isOpen={this.state.showDrawer}
                            shouldDisplayChildDrawer={true}
                            reff={this.drawerComponentRef}
                            closeDrawer={this.closeDrawer}
                        >
                            {this.getDrawerComponent()}
                        </Drawer>
                    }
                    backLink={`${arc.path.base}list?source=STRIVE&status=Active&transaction_type=Investment+Sales`}
                    edit={edit}
                    state={this.state}
                    setState={this.setState.bind(this)}
                    handleSubmit={this.isPropertyExists}
                    saveData={this.saveData}
                    extraHeaderInfo={
                        <React.Fragment>
                            {this.renderBuysideInvestorHeaderLink()}
                            {
                                !isReferral && !isExtraPayment && (
                                    isFinancing ?
                                        <Dropdown
                                            className="CRUD_content_status"
                                            viewClassName="CRUD_content_status_view"
                                            data={data}
                                            isFromProperty
                                            optionsType='status-financing'
                                            value={data && data.hsc_status}
                                            valueKey="hsc_status"
                                            disabled={isAgent}
                                            handleParentChange={this.handleChangeDropdown}
                                            viewMode={this.state.viewMode}
                                            deleted={this.state.deleted}
                                        />
                                        :
                                        <Dropdown
                                            className="CRUD_content_status"
                                            viewClassName="CRUD_content_status_view"
                                            optionKey='code'
                                            optionLabelKey='code'
                                            data={data}
                                            isFromProperty
                                            optionsType='status'
                                            value={data && data.status}
                                            valueKey="status"
                                            disabled={isAgent}
                                            handleParentChange={this.handleChangeDropdown}
                                            viewMode={this.state.viewMode}
                                            deleted={this.state.deleted}
                                        />
                                )
                            }
                            {
                                recomputePayments && <span className="CRUD_content_label">Recomputing Payment</span>
                            }
                        </React.Fragment>

                    }
                    extraInfo={
                        edit && data ? (
                            <div className="CRUD_content_info">
                                <div>
                                    Date created: <span>{data.date_created}</span>
                                </div>
                                <div>
                                    Created by: <span>{data.created_by}</span>
                                </div>
                                {data.status=="Proposal" ?
                                <div>
                                     Proposal Date: <span>{data.proposal_date}</span>
                                </div> : null }
                                <div>
                                    Last modified: <span>{data.last_modified_date}</span>
                                </div>
                                <div>
                                    Modified by: <span>{data.last_modified_by}</span>
                                </div>
                            </div>
                        ) : null
                    }
                    type="property"
                    title={data && data.name  ? (`${data.name} - ${data.city ? data.city : ''}, ${data.state ? data.state : ''}` ) : ""}
                    isAgent={isAgent}
                    formattedOriginalData={convertDataToForm(this.state.original)}
                    formattedLoanQuotesOriginalData={{name:'loanQuotesData', data:cloneDeep(this.state.originalLoanQuotesData)}}
                    formattedPaymentsOriginalData={{name:'propertyPaymentsData', data:cloneDeep(this.state.originalPaymentsData)}}
                >
                    {this.state.financialsSpreadsheetInView ? (
                        <Financials
                            location={this.props.location}
                            data={data}
                            propsalData={this.state.proposalData}
                            newPropertyId={this.state.newPropertyId}
                            allTenantsById={this.state.allTenantsById}
                            parentSetData={this.setDataFromFinancials}
                            isAgent={isAgent}
                            isSuper={isSuper}
                            email={email}
                            close={this.closeFinancialsSpreadsheet}
                        />
                    ) : null}
                </CRUD>
            </React.Fragment>
                        )
                    }
                }
            </ApolloConsumer>
            
        );
    }
}

//#endregion
